/* eslint-disable no-case-declarations */
/* global jQuery, $, PDFLib, fontkit, dat */

/*                                                                                                

          _____                    _____                    _____                    _____                    _____                   _______         
         /\    \                  /\    \                  /\    \                  /\    \                  /\    \                 /::\    \        
        /::\____\                /::\    \                /::\    \                /::\    \                /::\____\               /::::\    \       
       /::::|   |               /::::\    \              /::::\    \              /::::\    \              /:::/    /              /::::::\    \      
      /:::::|   |              /::::::\    \            /::::::\    \            /::::::\    \            /:::/    /              /::::::::\    \     
     /::::::|   |             /:::/\:::\    \          /:::/\:::\    \          /:::/\:::\    \          /:::/    /              /:::/~~\:::\    \    
    /:::/|::|   |            /:::/__\:::\    \        /:::/__\:::\    \        /:::/__\:::\    \        /:::/____/              /:::/    \:::\    \   
   /:::/ |::|   |           /::::\   \:::\    \      /::::\   \:::\    \      /::::\   \:::\    \       |::|    |              /:::/    / \:::\    \  
  /:::/  |::|___|______    /::::::\   \:::\    \    /::::::\   \:::\    \    /::::::\   \:::\    \      |::|    |     _____   /:::/____/   \:::\____\ 
 /:::/   |::::::::\    \  /:::/\:::\   \:::\    \  /:::/\:::\   \:::\____\  /:::/\:::\   \:::\    \     |::|    |    /\    \ |:::|    |     |:::|    |
/:::/    |:::::::::\____\/:::/  \:::\   \:::\____\/:::/  \:::\   \:::|    |/:::/__\:::\   \:::\____\    |::|    |   /::\____\|:::|____|     |:::|    |
\::/    / ~~~~~/:::/    /\::/    \:::\  /:::/    /\::/   |::::\  /:::|____|\:::\   \:::\   \::/    /    |::|    |  /:::/    / \:::\    \   /:::/    / 
 \/____/      /:::/    /  \/____/ \:::\/:::/    /  \/____|:::::\/:::/    /  \:::\   \:::\   \/____/     |::|    | /:::/    /   \:::\    \ /:::/    /  
             /:::/    /            \::::::/    /         |:::::::::/    /    \:::\   \:::\    \         |::|____|/:::/    /     \:::\    /:::/    /   
            /:::/    /              \::::/    /          |::|\::::/    /      \:::\   \:::\____\        |:::::::::::/    /       \:::\__/:::/    /    
           /:::/    /               /:::/    /           |::| \::/____/        \:::\   \::/    /        \::::::::::/____/         \::::::::/    /     
          /:::/    /               /:::/    /            |::|  ~|               \:::\   \/____/          ~~~~~~~~~~                \::::::/    /      
         /:::/    /               /:::/    /             |::|   |                \:::\    \                                         \::::/    /       
        /:::/    /               /:::/    /              \::|   |                 \:::\____\                                         \::/____/        
        \::/    /                \::/    /                \:|   |                  \::/    /                                          ~~              
         \/____/                  \/____/                  \|___|                   \/____/                                                           
                                                                                                                                                      


   ____  _      _                        _        _______         __                      _           _    
  / __ \| |    | |                      | |      |__   __|       / _|                    | |         | |   
 | |  | | | ___| | _____  __ _ _ __   __| |_ __     | |_ __ ___ | |_ _   _ _ __ ___   ___| |__  _   _| | __
 | |  | | |/ _ \ |/ / __|/ _` | '_ \ / _` | '__|    | | '__/ _ \|  _| | | | '_ ` _ \ / __| '_ \| | | | |/ /
 | |__| | |  __/   <\__ \ (_| | | | | (_| | |       | | | | (_) | | | |_| | | | | | | (__| | | | |_| |   < 
  \____/|_|\___|_|\_\___/\__,_|_| |_|\__,_|_|       |_|_|  \___/|_|  \__, |_| |_| |_|\___|_| |_|\__,_|_|\_\
  _____            _        __      __                   _            __/ |                                
 |  __ \          | |       \ \    / /                  (_)          |___/                                 
 | |__) |_ ___   _| | ___    \ \  / /__  _ __ ___  _ __  _ _ __                                            
 |  ___/ _` \ \ / / |/ _ \    \ \/ / _ \| '__/ _ \| '_ \| | '_ \                                           
 | |  | (_| |\ V /| | (_) |    \  / (_) | | | (_) | | | | | | | |                                          
 |_|   \__,_| \_/ |_|\___/      \/ \___/|_|  \___/|_| |_|_|_| |_|                                          
 
*/

// 3d-configurator created by Marevo (Pavlo Voronin based on Oleksandr Trofymchuk's configurator)
// changing configurations` script has been updated and added luminance` logo changing by Kseniya Lotsman

// Welcome to our custom script!

// REMEMBER:
// Theft is wrong not because some ancient text says, 'Thou shalt not steal.'
// It's always bad, robber :)

"use strict";
import $ from "jquery";
import * as THREE from "three";
import "../core/model-viewer.marevo";
import { getPostMeshName, getLouverMeshNames, getPostMorphSet } from "./Meshconfig";

// import * as GeometryUtils from 'three/addons/utils/GeometryUtils.js';
import { TextGeometry } from "three/addons/geometries/TextGeometry.js";
import { FontLoader } from "three/addons/loaders/FontLoader.js";
import { computeMorphedAttributes } from "three/addons/utils/BufferGeometryUtils.js";


//#region PUBLIC VALUES
import {
  BACKGROUND_COLOR,
  ENVIRONMENT_MAP,
  ENVIRONMENT_MAP_INTENSITY,
  MODEL_CENTER_POSITION,
  MODEL_PATHS,
  MORPH_DATA,
  MORPH_DATA_SI,
  pdfImg,
  pdfImgTop,
  SHADOW_TRANSPARENCY,
  state,
  WALL_OFFSETS,
  getHeightMorph,
  getWidthMorph,
  getLengthMorph,
  getLenthFrameX150Morph,
  getDoorHeightMorph,
  getDoorFrameWidthMorph,
  getDoorPanelWidthMorph,
  getShutterFrameWidthMorph,
  getShutterPanelWidthMorph,
  getShutterLouverWidthMorph,
  getShutterTrackHeightMorph,
  getShadeHeightMorph,
  getShadeClosingScale
} from "./settings";

import { interfaceComponent } from "../components/interface/interface";
import { updateMaterialMap, applyAllColors, resetUIToDefaults } from "../components/interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs";
import {
  animateScale,
  bloomPass,
  camera,
  canvas,
  create3DScene,
  dirLight,
  fxaaPass,
  getMobileOperatingSystem,
  IMPORTED_MODELS,
  outputPass,
  renderer,
  requestDelayedRender,
  saoPass,
  scene,
  updateBloomSettings,
  updateEnvMap,
  updateRenderSize,
} from "./3d-scene";
import { initSubSystem } from "./customFunctions/initiSubSystem";
import { preloadTextures, setMaterialTexture, TEXTURES } from "./utils";
import { initURLSystem, decodeURLToState, initStateFromUrl } from "./customFunctions/paramsURL"

const DEBUG_MODE_VALUES = false;
export let modelForExport = null;

const sceneProperties = {
  BACKGROUND_COLOR: BACKGROUND_COLOR,
  MODEL_PATHS: MODEL_PATHS,
  MODEL_CENTER_POSITION: MODEL_CENTER_POSITION,
  SHADOW_TRANSPARENCY: SHADOW_TRANSPARENCY,
  ENVIRONMENT_MAP: ENVIRONMENT_MAP,
  ENVIRONMENT_MAP_INTENSITY: ENVIRONMENT_MAP_INTENSITY,
};

export const clickableObjects = [];
export const hotspots = [];
export const labelObjects = {
  addObject: {
    url: "public/img/icons/hotspot.svg",
    obj: null,
  },
  addObjectHover: {
    url: "public/img/icons/hotspot-hover.svg",
    obj: null,
  },
};

export let currentOS = "unknown";
let delayForWriteURL = false;
let parametersKey = "config";
let parametersValue = "";
let loaded = false;
let paramsLoaded = false;
let isFirstStart = true;
let init = true;
const spanAvatarThickness = 0.1;

let pointsBeamX = [];
let pointsBeamZ = [];

let tblInfo;
let tblInfoItemQr;
let tblInfoItemSharing;
let tblInfoItemLoupe;

let modelViewer;
let qrcode;
let qrScaned = 0;

export let theModel;

let isAutoRotate = false;
const autoRotateSpeed = 0.05;
const spanOpacity = 0.15;

// MORPHS & SHADER

let isWorldposVertexShaderEnabled = true;
let morphs = [];
let globalMorphs = [];

var threejs_font_helvetiker_regular;

//#endregion

var isRedirectionProject = false;

export const pergolaConst = {
  structureColorType: {
    // Standard: +structureColorTypeStandard_option.split("-")[1],
    // Wood: +structureColorTypeWood_option.split("-")[1],
  },
  side: {
    Left: 0,
    Right: 1,
    Front: 2,
    Back: 3,
    Center: 4,
  },
  sideString: {
    0: "Left",
    1: "Right",
    2: "Front",
    3: "Back",
    4: "Center",
  },
  corner: {
    RL: 0,
    RR: 1,
    FL: 2,
    FR: 3,
  },
  direction: {
    Straight: 0,
    Perpendicular: 1,
  },
  postPlace: {
    CornerFront: 0,
    CornerBack: 1,
    MiddleFront: 2,
    MiddleBack: 3,
    CornerBackLeft: 4,
    CornerBackRight: 5,
  },
  canopyType: {
    Fixed: 0,
    Moving: 1,
    Handle: 2,
    Led: 3,
  },
  systemType: {
    slidingGlassDoor: 0,
    privacyWall: 1,
    autoShade: 2,
  },
  option: {
    heater: 0,
    LEDRampLight: 1,
  },
  optionNameString: {
    heater: "Heater",
    LEDRampLight: "Perimeter LED lights",
  },
  systemNameString: {
    slidingGlassDoor: "Slidetec Glass Doors",
    autoShade: "Outdoor Blinds",
    privacyWall: "Aluminum Sliding Shutters",
  },
};

loadThreeJSFonts();

//#region INITIALIZATION

export async function Start() {
  blockURLWriter = true;
  currentOS = await getMobileOperatingSystem();

  create3DScene(sceneProperties, async () => await startCallback());

  const startCallback = async () => {
    if (loaded) return;
    loaded = true;

    // ReadURLParameters(StartSettings);
    await StartSettings();
    setTimeout(() => {
      toggleLoad(false);
    }, 3000);
  };
}

export const clones = [];

function animateProperty(object, property, targetValue, duration, onUpdate) {
  const startValue = object[property];
  const startTime = performance.now();

  function animate(time) {
    const elapsedTime = time - startTime;
    const progress = Math.min(elapsedTime / duration, 1);
    object[property] = startValue + (targetValue - startValue) * progress;

    if (onUpdate) onUpdate();

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  }

  requestAnimationFrame(animate);
}

// #region RAYCAST
function initRaycast() {
  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();
  const canvas = document.getElementById("ar_model_view");

  let isMouseMoved = false;
  let clickThreshold = 5;
  let startX, startY;

  let avatarObject;

  function onMouseDown(event) {
    isMouseMoved = false;
    startX = event.offsetX;
    startY = event.offsetY;
  }

  function onMouseMove(event) {
    mouse.x = (event.offsetX / renderer.domElement.clientWidth) * 2 - 1;
    mouse.y = -(event.offsetY / renderer.domElement.clientHeight) * 2 + 1;
    raycaster.setFromCamera(mouse, camera);

    const visibleClickableObjects =
      getVisibleClickableObjects(clickableObjects);
    const intersects = raycaster.intersectObjects(
      visibleClickableObjects,
      true
    );

    if (intersects.length > 0) {
      canvas.style.cursor = "pointer";
      avatarObject = intersects[0].object;
      visibleClickableObjects.forEach((object) => {
        // pergola && pergola.outlineAvatar(object, false);
      });
      // pergola && pergola.outlineAvatar(avatarObject, true, false);
    } else {
      canvas.style.cursor = "default";
      visibleClickableObjects.forEach((object) => {
        pergola && pergola.outlineAvatar(object, false);
      });
    }

    if (
      Math.abs(event.offsetX - startX) > clickThreshold ||
      Math.abs(event.offsetY - startY) > clickThreshold
    ) {
      isMouseMoved = true;
    }
  }

  function onMouseUp(event) {
    if (!isMouseMoved) {
      mouse.x = (event.offsetX / renderer.domElement.clientWidth) * 2 - 1;
      mouse.y = -(event.offsetY / renderer.domElement.clientHeight) * 2 + 1;
      raycaster.setFromCamera(mouse, camera);

      const visibleClickableObjects =
        getVisibleClickableObjects(clickableObjects);
      const intersects = raycaster.intersectObjects(
        visibleClickableObjects,
        true
      );

      if (intersects.length > 0) {
        const intersectedObject = intersects[0].object;
        console.log(`CLICKED: ${intersectedObject.name}`);

        const clickedSpan = intersectedObject.parentSpan;
        pergola && pergola.editSystem(clickedSpan);
        visibleClickableObjects.forEach((object) => {
          pergola && pergola.outlineAvatar(object, false);
        });
      }
    }
  }

  canvas.addEventListener("mousedown", onMouseDown);
  canvas.addEventListener("mousemove", onMouseMove);
  canvas.addEventListener("mouseup", onMouseUp);
}

function getVisibleClickableObjects(objects = []) {
  const visibleObjects = objects.filter(
    (avatar) => avatar.parentSpan.isSystemSet === true
  );

  return visibleObjects;
}

// #endregion

function mirrorObject(object, value = true) {
  if (object) object.scale.x = value ? -1 : 1;
}

export async function toggleBackWall(toggle) {
  const backWallNoDoor = GetGroup("wall_back_no_door");
  const backWall = GetGroup("wall_back_door");

  if (backWall) {
    backWall.children.forEach((group) => {
      group.traverse((object) => {
        if (object.isMesh) {
          object.visible = toggle;
        }
      });
    });
  }

  if (backWallNoDoor) {
    backWallNoDoor.children.forEach((group) => {
      group.traverse((object) => {
        if (object.isMesh) {
          object.visible = toggle;
        }
      });
    });
  }
}

export function toggleLoad(toggle) {
  toggle
    ? $("#app").addClass("app-loader")
    : $("#app").removeClass("app-loader");
}

export async function getSize(model) {
  const box = new THREE.Box3().setFromObject(model);
  const size = box.getSize(new THREE.Vector3());
}

async function StartSettings() {
  theModel = IMPORTED_MODELS[0];
  console.log("🚀 ~ theModel:", theModel);
  InitMorphModel(theModel);

  getSize(theModel);

  PrepareAR();
  paramsLoaded = true;

  CreatePergola(theModel);

  theModel.scale.set(0, 0, 0);
  theModel.visible = true;
  animateScale(theModel);

  await preloadTextures();

  isFirstStart = false;

  if (["Android", "iOS", "VisionPro"].includes(currentOS)) {
    CheckQRMobile();
  }

  modelForExport = theModel;

  theModel.traverse((object) => {
    if (object.isMesh && object.name === "louver_X") {
      object.visible = false;
    }
  });

  //UI ADD
  interfaceComponent($("#content"));

  setAllHotspotsVisibility(false);
  //#endregion

  pergola.changeDimensions(state.width, state.length, state.height);

  initRaycast();
}

//#endregion

//#region MESH / MATERIAL utils

export function GetMesh(name, model = theModel) {
  var object = null;
  model?.traverse((o) => {
    if (o.isMesh) {
      if (name == o.name) {
        object = o;
      }
    }
  });

  return object;
}

export function GetGroup(name, model = theModel) {
  var group = null;
  model.traverse((o) => {
    if (o.isGroup) {
      if (name == o.name) {
        group = o;
      }
    }
  });

  return group;
}

//#region HOTSPOTS
function createHotspot(id, normalUrl, hoverUrl, position, groupName = "") {
  const hotspotContainer = document.getElementById("ar_model_viewer");
  if (!hotspotContainer) {
    return;
  }

  const hotspot = document.createElement("div");
  hotspot.classList.add("hotspot");
  hotspot.id = id;
  hotspot.dataset.id = id;
  hotspot.style.backgroundImage = `url(${normalUrl})`;
  hotspot.groupName = groupName;
  hotspot.dataset.group = groupName;

  hotspot.hoverFunction = () => { };
  hotspot.normalFunction = () => { };
  hotspot.clickFunction = () => { };

  hotspot.addEventListener("mouseenter", () => {
    hotspot.style.backgroundImage = `url(${hoverUrl})`;
    hotspot.hoverFunction();
  });

  hotspot.addEventListener("mouseleave", () => {
    hotspot.style.backgroundImage = `url(${normalUrl})`;
    hotspot.normalFunction();
  });

  hotspot.addEventListener("click", () => {
    // console.log(`Hotspot ${id} clicked`);
    hotspot.clickFunction();
  });

  hotspotContainer.appendChild(hotspot);

  return {
    element: hotspot,
    position: position,
    setHoverFunction: (newFunction) => {
      hotspot.hoverFunction = newFunction;
    },
    setNormalFunction: (newFunction) => {
      hotspot.normalFunction = newFunction;
    },
    setClickFunction: (newFunction) => {
      hotspot.clickFunction = newFunction;
    },
  };
}

export function updateHotspots(hotspots) {
  const $canvasContainer = $("#ar_model_viewer");
  hotspots.forEach(({ element, position }) => {
    if (position && element.style.display !== 'none') {
      const screenPosition = position.clone();
      screenPosition.project(camera);
      const x = (screenPosition.x * 0.5 + 0.5) * $canvasContainer.width();
      const y = (screenPosition.y * -0.5 + 0.5) * $canvasContainer.height();
      $(element).css({
        left: `${x}px`,
        top: `${y}px`,
        transform: "translate(-50%, -50%)",
        "-webkit-transform": "translate(-50%, -50%)",
      });
    }
  });
}

function setHotspotVisibility(hotspot, visible) {
  if (!hotspot || !hotspot.element) {
    return;
  }
  hotspot.element.style.display = visible ? "block" : "none";
}

export function setAllHotspotsVisibility(visible) {
  const hotspots = document.querySelectorAll(".hotspot");

  hotspots.forEach((hotspot) => {
    setHotspotVisibility(hotspot, visible);
  });
}

function setHotspotsByGroupVisibility(groupName, visible) {
  const hotspots = document.querySelectorAll(
    `.hotspot[data-group="${groupName}"]`
  );
  hotspots?.forEach((hotspot) => {
    hotspot.style.display = visible ? "block" : "none";
  });
}

window.addEventListener("resize", () => {
  updateHotspots(hotspots);
});

window.addEventListener("orientationchange", function (event) {
  // window.orientation is read-only in modern browsers
});

//#endregion

// eslint-disable-next-line no-unused-vars
function CloneMesh(name, model = theModel) {
  const originalMesh = GetMesh(name, model);
  if (originalMesh) {
    const clonedMesh = originalMesh.clone();
    return clonedMesh;
  } else {
    console.warn(`Mesh with name ${name} not found.`);
    return null;
  }
}

const subSystems_options = {
  BifoldDoor: {
    limitHeightInch: 110,
    limitWidthInch: null,
    elementMaxWidthMM: 700,
    shapekeys_straight: {
      frame: {
        height: {
          key: "height",
          min: 2132,
          max: 3350,
        },
        width: {
          key: "width_bi-doors_frame",
          min: 879,
          max: 5999,
        },
      },
      element: {
        height: {
          key: "height",
          min: 2132,
          max: 3350,
        },
        width: {
          key: "width_bi-door",
          min: 350,
          max: 700,
        },
        thickness: 0.029174,
      },
    },
    shapekeys_perpendicular: {
      frame: {
        height: {
          key: "height",
          min: 2132,
          max: 3350,
        },
        depth: {
          key: "length_bi-doors_frame",
          min: 879,
          max: 5999,
        },
      },
      element: {
        height: {
          key: "height",
          min: 2132,
          max: 3350,
        },
        width: {
          key: "length_bi-door_side",
          min: 350,
          max: 700,
        },
        thickness: 0.029174,
      },
    },
  },
  BifoldDoorShatters: {
    limitHeightInch: 110,
    limitWidthInch: null,
    elementMaxWidthMM: 1350,
    shapekeys_straight: {
      frame: {
        height: {
          key: "height",
          min: 2132,
          max: 3350,
        },
        width: {
          key: "width_bifold_shutters_frame",
          min: 879,
          max: 5999,
        },
      },
      element: {
        height: {
          key: "height",
          min: 2132,
          max: 3350,
        },
        width: {
          key: "width_bifold_shutter",
          keyBlade: "width_blabe_bifold_shutters",
          min: 400,
          max: 1350,
        },
        thickness: 0.029174,
      },
    },
    shapekeys_perpendicular: {
      frame: {
        height: {
          key: "height",
          min: 2132,
          max: 3350,
        },
        depth: {
          key: "length_bi-doors_frame",
          min: 879,
          max: 5999,
        },
      },
      element: {
        height: {
          key: "height",
          min: 2132,
          max: 3350,
        },
        width: {
          key: "length_bifold_shutter",
          keyBlade: "length_blabe_bifold_shutters",
          min: 400,
          max: 1350,
        },
        thickness: 0.029174,
      },
    },
  },
  GuilotineGlass: {
    option: "option_4-1",
    group: "group-19",
    limitHeightInch: null,
    limitWidthInch: 168,
    elementMaxWidthMM: null,
    overlapMM: 50, // mm
    shapekeys_straight: {
      frame: {
        height: {
          key: "height_Guillotine",
          min: 1520,
          max: 3660,
        },
        width: {
          key: "length_Guillotine",
          min: 1880,
          max: 4270,
        },
      },
      element: {
        height: {
          key: "height_Guillotine_win",
          min: 508,
          max: 1220,
        },
        width: {
          key: "length_Guillotine_win",
          min: 1780,
          max: 4170,
        },
        thickness: 0.0241,
      },
    },
    shapekeys_perpendicular: {
      frame: {
        height: {
          key: "height_Guillotine_side",
          min: 1520,
          max: 3480,
        },
        depth: {
          key: "length_Guillotine_side",
          min: 2290,
          max: 9090,
        },
      },
      element: {
        height: {
          key: "height_Guillotine_win_side",
          min: 508,
          max: 1220,
        },
        width: {
          key: "length_Guillotine_win_side",
          min: 2190,
          max: 8990,
        },
        thickness: 0.0241,
      },
    },
  },
  SlidingGlassDoor: {
    option: "option_4-2",
    group: "group-10",
    limitHeightInch: 120,
    limitWidthInch: null,
    elementMaxWidthMM: 900,
    overlapMM: 16, // mm
    shapekeys_straight: {
      frame: {
        height: {
          key: "height_sliding_glass",
          min: 2232,
          max: 3450,
        },
        width: {
          key: "length_sliding_glass",
          min: 1880,
          max: 4270,
        },
      },
      element: {
        height: {
          key: "height_sliding_glass_win",
          min: 1420,
          max: 3560,
        },
        width: {
          key: "length_sliding_glass_win",
          min: 593,
          max: 1060,
        },
        thickness: 0.02, // 0.0241,
      },
    },
    shapekeys_perpendicular: {
      frame: {
        height: {
          key: "height_sliding_glass_side",
          min: 2520,
          max: 4480,
        },
        depth: {
          key: "length_sliding_glass_side",
          min: 2290,
          max: 9090,
        },
      },
      element: {
        height: {
          key: "height_sliding_glass_win_side",
          min: 1420,
          max: 3380,
        },
        width: {
          key: "length_sliding_glass_win_side",
          min: 593,
          max: 1060,
        },
        thickness: 0.02, // 0.0241,
      },
    },
  },
  LiftSlideDoor: {
    limitHeightInch: 120,
    limitWidthInch: null,
    elementMaxWidthMM: 1350,
    overlapMM: 10, // mm
    shapekeys_straight: {
      frame: {
        height: {
          key: "height",
          min: 2132,
          max: 3350,
        },
        width: {
          key: "width_sl-shutters_frame",
          min: 879,
          max: 6000,
        },
      },
      element: {
        height: {
          key: "height",
          min: 1420,
          max: 2690,
        },
        width: {
          keyFix: "width_fix_shutter",
          key: "width_sl-shutter",
          min: 399,
          max: 1349,
        },
        thickness: 0.029175, // 0.0241,
      },
      shatter: {
        width: {
          keyFix: "width_blabe_fix_shutters",
          key: "width_blabe_sl_shutters",
          min: 399,
          max: 1349,
        },
      },
    },
    shapekeys_perpendicular: {
      frame: {
        height: {
          key: "height",
          min: 1520,
          max: 2790,
        },
        depth: {
          key: "length_sl-shutters_frame",
          min: 879,
          max: 6000,
        },
      },
      element: {
        height: {
          key: "height",
          min: 1420,
          max: 2690,
        },
        width: {
          keyFix: "length_fix_shutter",
          key: "length_sl-shutter",
          min: 399,
          max: 1349,
        },
        thickness: 0.029175, // 0.0241,
      },
      shatter: {
        width: {
          keyFix: "length_blabe_fix_shutters",
          key: "length_blabe_sl_shutters",
          min: 399,
          max: 1349,
        },
      },
    },
  },
  BlindShade: {
    option: "option_4-4",
    group: "group-12",
    limitHeightInch: null,
    limitWidthInch: null,
    elementMaxWidthMM: null,
    overlapMM: null, // mm
    shapekeys_straight: {
      frame: {
        height: {
          key: "height_shades",
          min: 1520,
          max: 3660,
        },
        width: {
          key: "width_shades",
          min: 1880,
          max: 4270,
        },
      },
      element: {
        closing: {
          key: "close_shades",
          min: 1520,
          max: 3660,
        },
      },
    },
    shapekeys_perpendicular: {
      frame: {
        height: {
          key: "height_shades_side",
          min: 1520,
          max: 3660,
        },
        depth: {
          key: "length_shades_side",
          min: 2290,
          max: 9090,
        },
      },
      element: {
        closing: {
          key: "close_shades_side",
          min: 1520,
          max: 2790,
        },
      },
    },
  },
  Window: {
    front: {
      height: {
        key: "height_win_up",
        min: 203,
        max: 914,
      },
      width: {
        key: "length_win_up",
        min: 1880,
        max: 4270,
      },
    },
    back: {
      height: {
        key: "height_win_up_back",
        min: 203,
        max: 2030,
      },
      width: {
        key: "length_win_up",
        min: 1880,
        max: 4270,
      },
    },
    leftRight: {
      heightDelta: {
        key: "height_win_up_side",
        min: 0,
        max: 910,
      },
      heightPos: {
        //! it used in pergola.changeDimensions();
        key: "height_win_up_side.001",
        minInch: 60, // це висота перголи у футах
        maxInch: 144, // це висота перголи у футах
      },
      width: {
        //! it used in pergola.changeDimensions();
        key: "length_win_up_side",
        min: 2290,
        max: 9090,
        minInch: 96,
        maxInch: 360,
      },
    },
  },
  Led: {
    option: "option_4-5",
    group: "group-13",
  },
};

// eslint-disable-next-line no-unused-vars
function GetMaterial(name) {
  var material = null;
  theModel.traverse((o) => {
    if (o.isMaterial) {
      if (name == o.material.name) {
        material = o.material;
      }
    }
  });

  return material;
}

function GetMaterialFromScene(name) {
  var material = null;
  scene.traverse((o) => {
    if (o.material) {
      if (name == o.material.name) {
        material = o.material;
      }
    }
  });

  return material;
}

// eslint-disable-next-line no-unused-vars
export function ChangeMaterialTilling(materialName, x, y) {
  var materialObject = GetMaterialFromScene(materialName);

  if (materialObject == null) {
    return;
  }

  if (materialObject.map != null) {
    materialObject.map.repeat.set(x, y);
  }

  if (materialObject.normalMap != null) {
    materialObject.normalMap.repeat.set(x, y);
  }

  if (materialObject.roughnessMap != null) {
    materialObject.roughnessMap.repeat.set(x, y);
  }

  if (materialObject.metalnessMap != null) {
    materialObject.metalnessMap.repeat.set(x, y);
  }

  if (materialObject.aoMap != null) {
    materialObject.aoMap.repeat.set(x, y);
  }
}

// eslint-disable-next-line no-unused-vars
export function ChangeMaterialOffset(materialName, x, y) {
  var materialObject = GetMaterialFromScene(materialName);

  if (materialObject == null) {
    return;
  }

  if (materialObject.map != null) {
    materialObject.map.offset.set(x, y);
  }

  if (materialObject.normalMap != null) {
    materialObject.normalMap.offset.set(x, y);
  }

  if (materialObject.roughnessMap != null) {
    materialObject.roughnessMap.offset.set(x, y);
  }

  if (materialObject.metalnessMap != null) {
    materialObject.metalnessMap.offset.set(x, y);
  }

  if (materialObject.aoMap != null) {
    materialObject.aoMap.offset.set(x, y);
  }
}

export function triggerIconClick(iconType) {
  const icon = $(`.icon_wrap`).find(`#${iconType}`);
  icon.show();

  if (icon.length) {
    icon.trigger("click");
  } else {
    console.error("Icon not found");
  }
}

export function showIcon(iconType, trigger = false) {
  const icon = $(`.icon_wrap`).find(`#${iconType}`);
  icon.show();

  if (trigger) {
    icon.trigger("click");
  }
}

export function hideIcon(iconType) {
  const icon = $(`.icon_wrap`).find(`#${iconType}`);

  // REMOVE CLASS "active" from icon
  const classesToRemove = icon
    .attr("class")
    ?.split(" ")
    .filter((className) => className.includes("active"));

  if (classesToRemove?.length) {
    icon.removeClass(classesToRemove.join(" "));
  }

  icon.hide();
  $(".portal-container").hide();

  //mobile
  $(".interface-container").removeClass("interface-container-portal");
}
// eslint-disable-next-line no-unused-vars
function setMaterialColor(materialName, color) {
  const materialObject = GetMaterialFromScene(materialName);
  if (materialObject == null) {
    return;
  }
  materialObject.color.set(color);
  materialObject.needsUpdate = true;
}

const textureLoader = new THREE.TextureLoader();
textureLoader.setCrossOrigin("anonymous");
const textureCache = {};
const texturePool = {};

function setTexture(id, path, material, materialProp, tilling) {
  if (material == null) {
    return;
  }
  if (materialProp == null) {
    return;
  }

  const value = texturePool[id.toLowerCase()];
  if (value != null) {
    assingTexture(material, materialProp, value, tilling);
    return;
  }

  textureLoader.load(
    path,
    (texture) => {
      // console.log("texture is loading");
      texture.magFilter = THREE.NearestFilter;
      texture.minFilter = THREE.NearestMipmapNearestFilter;
      texture.anisotropy = 16;
      texture.flipY = false;
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;
      texturePool[id.toLowerCase()] = texture;

      assingTexture(material, materialProp, texture, tilling);
    },
    undefined,
    () => {
      console.error("An error happened.");
    }
  );

  function assingTexture(material, materialProp, texture, tilling) {
    switch (materialProp) {
      case "map":
        material.map = texture;
        if (tilling != null) {
          texture.repeat.set(tilling.x, tilling.y);
        }
        break;
      default:
        break;
    }
    material.needsUpdate = true;
  }
}

//#region QR
function CreateQR() {
  var uri = window.location.href;
  var encoded = encodeURIComponent(uri);
  var qrImg = new Image();
  qrImg.src = "https://quickchart.io/qr?text=" + encoded + "&size=200";
  qrImg.addEventListener("load", () => {
    $(qrImg).addClass("ar__bottom__qr");
    $("#qr-container").html(qrImg);
  });
}

async function CheckQRMobile() {
  // eslint-disable-next-line no-unused-vars
  await waitFor((_) => loaded === true);
  // eslint-disable-next-line no-unused-vars
  await waitFor((_) => modelViewer != undefined);
  await new Promise((r) => setTimeout(r, 2000));

  if (qrScaned == 1) {
    if (["Android", "iOS", "VisionPro"].includes(currentOS)) {
      OpenAR();
    }

    qrScaned = 0;

    WriteURLParameters();
  }
}

//#endregion

//#region AR
function PrepareAR() {
  modelViewer = $("#marevo_model");
  const arPromt = $("#ar-prompt");
  modelViewer[0].addEventListener("ar-status", (event) => {
    if (event.detail.status == "session-started") {
      arPromt[0].style.display = "block";
    } else if (event.detail.status == "not-presenting") {
      arPromt[0].style.display = "none";
      modelViewer[0].resetScene();
      init = true;
      if (pergola != null) pergola.restoreLogoUVs();

      if (getMobileOperatingSystem() == "Android") {
        if (pergolaSettings.mountingWall_Back && pergola != null) {
          pergola.changeMountingWallVisibility(
            pergolaSettings.mountingWall_Back,
            PergolaElementOrientSide.Back,
            true
          );
        }

        if (pergolaSettings.mountingWall_Left && pergola != null) {
          pergola.changeMountingWallVisibility(
            pergolaSettings.mountingWall_Left,
            PergolaElementOrientSide.Left,
            true
          );
        }

        if (pergolaSettings.mountingWall_Right && pergola != null) {
          pergola.changeMountingWallVisibility(
            pergolaSettings.mountingWall_Right,
            PergolaElementOrientSide.Right,
            true
          );
        }
      }
    } else {
      arPromt[0].style.display = "none";
    }
  });
}

async function OpenAR() {
  console.log("start");

  if (init) {
    console.log("open", scene, pergola, theModel, modelForExport);

    InitMorphModel(theModel);

    ComputeMorphedAttributes();

    // //Remove wall
    if (pergola != null) {
      if (pergolaSettings.mountingWall_Back) {
        pergola.changeMountingWallVisibility(
          false,
          PergolaElementOrientSide.Back
        );
      }

      //   if (pergolaSettings.mountingWall_Left) {
      //     pergola.changeMountingWallVisibility(
      //       false,
      //       PergolaElementOrientSide.Left
      //     );
      //   }

      //   if (pergolaSettings.mountingWall_Right) {
      //     pergola.changeMountingWallVisibility(
      //       false,
      //       PergolaElementOrientSide.Right
      //     );
      //   }
    }

    // Hide backWall before export so it doesn't appear in AR
    const arBackWallVisible = state.backWall;
    if (arBackWallVisible) toggleBackWall(false);

    // Fix glass panel materials for AR transparency
    scene.traverse((o) => {
      if (!o.isMesh || !o.material) return;
      let isInsideGlassPanel = false;
      let p = o.parent;
      while (p) {
        if (p.name && p.name.startsWith('sliding_glass_panel')) { isInsideGlassPanel = true; break; }
        if (p.userData?.clonedDoor) { isInsideGlassPanel = true; break; }
        p = p.parent;
      }
      if (!isInsideGlassPanel) return;
      const mats = Array.isArray(o.material) ? o.material : [o.material];
      mats.forEach((mat) => {
        if (!mat) return;
        const n = (mat.name || '').toLowerCase();
        if (n.includes('glass') || n.includes('glazing') || n.includes('window') || mat.opacity < 0.99) {
          mat.transparent = true;
          if (mat.opacity >= 0.99) mat.opacity = 0.3;
          mat.side = THREE.DoubleSide;
          mat.depthWrite = false;
          mat.needsUpdate = true;
        }
      });
    });

    await ImportScene(scene);

    // Restore backWall after export (iOS shows model-viewer immediately)
    if (arBackWallVisible) toggleBackWall(true);

    if (getMobileOperatingSystem() == "iOS") {
      if (pergola != null) {
        if (pergolaSettings.mountingWall_Back) {
          pergola.changeMountingWallVisibility(
            pergolaSettings.mountingWall_Back,
            PergolaElementOrientSide.Back,
            true
          );
        }
        //     if (pergolaSettings.mountingWall_Left) {
        //       pergola.changeMountingWallVisibility(
        //         pergolaSettings.mountingWall_Left,
        //         PergolaElementOrientSide.Left,
        //         true
        //       );
        //     }
        //     if (pergolaSettings.mountingWall_Right) {
        //       pergola.changeMountingWallVisibility(
        //         pergolaSettings.mountingWall_Right,
        //         PergolaElementOrientSide.Right,
        //         true
        //       );
        //     }
      }
    }

    init = false;
  }

  console.log("end");
}

// eslint-disable-next-line no-unused-vars
export function OpenARorQR() {
  console.log("click AR");
  if (["Android", "iOS", "VisionPro"].includes(currentOS)) {
    init = true;
    OpenAR();
    return;
  }

  console.log("QR");
  CreateQR();

  $("#ar").show();
}

//IMPORT
async function ImportScene(newScene) {
  console.log(modelViewer[0], newScene);
  await modelViewer[0].importScene(newScene);
  modelViewer[0].activateAR();
}
//#endregion

//#region URL PARAMETERS

// eslint-disable-next-line no-unused-vars
var wix_url_base = null;
var wix_current_url = null;
var wix_url_load_params = null;

// eslint-disable-next-line no-unused-vars
function PostMassagesListener(event) {
  let receivedMessage = event.data;
  //console.log("Отримано повідомлення з main сайту:", receivedMessage);

  if (receivedMessage == "undefined") {
    return;
  }
  if (receivedMessage == undefined) {
    return;
  }
  if (receivedMessage == null) {
    return;
  }

  if (receivedMessage.includes("WIX_URL_LOAD|")) {
    return;
  }
  if (receivedMessage.includes("WIX_CURRENT_URL|")) {
    wix_current_url = receivedMessage.replace("WIX_CURRENT_URL|", "");
    return;
  }
  if (receivedMessage.includes("WIX_URL_LOAD_Params|")) {
    wix_url_load_params = receivedMessage.replace("WIX_URL_LOAD_Params|", "");
    var url =
      location.protocol + "//" + location.host + location.pathname + "?";
    history.pushState(null, "marevo", url + "config=" + wix_url_load_params);
    return;
  }
  if (receivedMessage.includes("URL_Params|")) {
    return;
  }
  if (receivedMessage.includes("WIX_URL_BASE|")) {
    wix_url_base = receivedMessage.replace("WIX_URL_BASE|", "");
    return;
  }

  if (receivedMessage.includes("WIX_IS_LOADED|")) {
    return;
  }
}

function WriteURLParameters() {
  if (!paramsLoaded) {
    return;
  }
  if (blockURLWriter) {
    return;
  }

  if (!delayForWriteURL) {
    delayForWriteURL = true;
    promiseDelay(100, function () {
      history.pushState(null, "marevo", GetURLWithParameters());
      if (isWIX == true) {
        window.parent.postMessage(
          "URL_Params|" + GetURLWithParameters("", true),
          "*"
        );
      }
      delayForWriteURL = false;
    });
  }
}

function GetParametersString() {
  parametersValue = "";

  if (pergolaSettings == null) {
    return parametersValue;
  }

  var splitValue = "-";

  parametersValue += pergolaSettings.width + splitValue;
  parametersValue += pergolaSettings.length + splitValue;
  parametersValue += pergolaSettings.height + splitValue;
  parametersValue += pergolaSettings.postSize + splitValue;
  parametersValue += pergolaSettings.colorHex + splitValue;
  parametersValue += pergolaSettings.colorLouveredHex + splitValue;
  parametersValue += pergolaSettings.colorLedHex + splitValue;
  parametersValue += pergolaSettings.colorMoodHex + splitValue;
  parametersValue += pergolaSettings.roofType + splitValue;
  parametersValue += pergolaSettings.roofLouveredDirection + splitValue;
  parametersValue +=
    (pergolaSettings.mountingWall_Back == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.mountingWall_Left == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.mountingWall_Right == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionLight == true ? 1 : 0) + splitValue;
  parametersValue += pergolaSettings.extraOptionLightSpacing + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionFan == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionLed == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionHeaters == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionMoodLight == true ? 1 : 0) + splitValue;
  parametersValue += (sceneTime == "Night" ? 1 : 0) + splitValue;
  parametersValue += qrScaned;

  parametersValue = parametersValue.SEncode();

  return parametersValue;
}

function GetURLWithParameters(updateURL = null, withoutKey = false) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const entries = urlParams.entries();

  var url = location.protocol + "//" + location.host + location.pathname + "?";

  if (updateURL != null) {
    url = updateURL + "?";
  }

  var configEmpty = true;

  for (const entry of entries) {
    if (entry[0] == parametersKey) {
      url += parametersKey + "=" + GetParametersString() + "&";
      configEmpty = false;
    } else if (entry[0] == "onlyAR") {
      continue;
    } else {
      url += entry[0] + "=" + entry[1] + "&";
    }
  }

  if (configEmpty) {
    url += parametersKey + "=" + GetParametersString();
  }

  if (withoutKey) {
    url = url.replace("?" + parametersKey + "=", "");
  }

  if (url.endsWith("&")) {
    url = url.substring(0, url.length - 1);
  }

  return url;
}

// eslint-disable-next-line no-unused-vars
function delay(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

//#endregion

//#region UTILS

function waitFor(conditionFunction) {
  const poll = (resolve) => {
    if (conditionFunction()) resolve();
    // eslint-disable-next-line no-unused-vars
    else setTimeout((_) => poll(resolve), 400);
  };

  return new Promise(poll);
}

function promiseDelay(time, callback) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve("resolved");
      if (callback != null) {
        callback();
      }
    }, time);
  });
}

// eslint-disable-next-line no-unused-vars
async function waitForValueChange(input, result, callback) {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (input === result) {
        clearInterval(interval);
        resolve();

        if (callback != null) {
          callback();
        }
      }
    }, 100);
  });
}

//#endregion

//#region SHADER and MORPHS

function Shader_ChangeVertexToWorldpos(object) {
  var vUvSymbol = "vUv";
  var uvTransformSymbol = "uvTransform";

  if (THREE.REVISION >= 150) {
    vUvSymbol = "vMapUv";
    uvTransformSymbol = "mapTransform";
  }

  promiseDelayShaderSettings(500, object, () => {
    if (object.isMesh) {
      if (isWorldposVertexShaderEnabled) {
        if (object.material) {
          if (object.material.name.includes("_Z")) {
            object.material.onBeforeCompile = (shader) => {
              shader.vertexShader = shader.vertexShader
                .replace("#include <uv_vertex>\n", "")
                .replace(
                  "#include <worldpos_vertex>",
                  `vec4 worldPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\nworldPosition = instanceMatrix * worldPosition;\n#endif\nworldPosition = modelMatrix * worldPosition;\n${vUvSymbol} = (${uvTransformSymbol} * vec3(worldPosition.xz, 1)).xy;`
                );
            };
          } else if (object.material.name.includes("_Y")) {
            object.material.onBeforeCompile = (shader) => {
              shader.vertexShader = shader.vertexShader
                .replace("#include <uv_vertex>\n", "")
                .replace(
                  "#include <worldpos_vertex>",
                  `vec4 worldPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\nworldPosition = instanceMatrix * worldPosition;\n#endif\nworldPosition = modelMatrix * worldPosition;\n${vUvSymbol} = (${uvTransformSymbol} * vec3(worldPosition.xy, 1)).xy;`
                );
            };
          } else if (object.material.name.includes("_X")) {
            object.material.onBeforeCompile = (shader) => {
              shader.vertexShader = shader.vertexShader
                .replace("#include <uv_vertex>\n", "")
                .replace(
                  "#include <worldpos_vertex>",
                  `vec4 worldPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\nworldPosition = instanceMatrix * worldPosition;\n#endif\nworldPosition = modelMatrix * worldPosition;\n${vUvSymbol} = (${uvTransformSymbol} * vec3(worldPosition.yz, 1)).xy;`
                );
            };
          }
          object.material.needsUpdate = true;
        }
      }
    }
  });
}

function promiseDelayShaderSettings(time, object, callback) {
  if (time == null) {
    time = 2000;
  }

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve("resolved");
      if (object.material.map == null) {
        promiseDelayShaderSettings(time, object, callback);
      } else {
        if (callback != null) {
          callback();
        }
      }
    }, time);
  });
}

function InitMorphModel(model) {
  ParseMorphByModel(model);
}

export function ParseMorphByModel(model, callback = null) {
  morphs = [];
  model.traverse((object) => {
    if (object.isMesh) {
      Shader_ChangeVertexToWorldpos(object);

      if (object.morphTargetDictionary != null) {
        for (const [key, value] of Object.entries(
          object.morphTargetDictionary
        )) {
          var morph = {
            name: key,
            object: object,
            key: value,
            value: value,
          };

          if (!morphs.includes(morph)) {
            morphs.push(morph);
          }
        }
      }
    }
  });

  PrepareGlobalMorphs(callback);
}

function PrepareGlobalMorphs(callback = null) {
  globalMorphs = [];

  for (let index = 0; index < morphs.length; index++) {
    const morph = morphs[index];

    var hasMorph = false;

    for (let m = 0; m < globalMorphs.length; m++) {
      const globalMorph = globalMorphs[m];
      if (globalMorph.name != morph.name) {
        continue;
      }
      hasMorph = true;
      break;
    }

    if (!hasMorph) {
      globalMorphs.push(morph);
    }
  }

  if (callback != null) {
    callback();
  }
}

export function ComputeMorphedAttributes() {
  for (let index = 0; index < morphs.length; index++) {
    const morph = morphs[index];
    var computeMorphedAttributesValue = computeMorphedAttributes(morph.object);
    morph.object.geometry.computeMorphedAttributes =
      computeMorphedAttributesValue;
  }

  // console.log(scene);

  scene.traverse((object) => {
    if (object.isMesh) {
      var computeMorphedAttributesValue = computeMorphedAttributes(object);

      console.log(computeMorphedAttributesValue);

      object.geometry.computeMorphedAttributes = computeMorphedAttributesValue;
    }
  });
}

// eslint-disable-next-line no-unused-vars
function ChangeObjectMorph(object, key, inputValue) {
  if (!object) return;

  function processObject(obj) {
    if (obj.isMesh && obj.morphTargetDictionary) {
      const morphIndex = obj.morphTargetDictionary[key];
      if (morphIndex !== undefined && obj.morphTargetInfluences) {
        obj.morphTargetInfluences[morphIndex] = inputValue;
      }
    }

    if (obj.children && obj.children.length > 0) {
      obj.children.forEach((child) => processObject(child));
    }
  }

  processObject(object);
}

// eslint-disable-next-line no-unused-vars
export function ChangeObjectWithMorph(object, key, inputvalue) {
  if (object == null) {
    return;
  }

  if (object.morphTargetInfluences != null) {
    object.morphTargetInfluences[key] = inputvalue;
  }
}

export function ChangeGlobalMorph(morphName, inputvalue) {
  for (let index = 0; index < morphs.length; index++) {
    const morph = morphs[index];

    if (morph.name != morphName) {
      continue;
    }
    if (morph.object == null) {
      continue;
    }
    if (!morph.object.isMesh) {
      continue;
    }
    if (morph.object.morphTargetInfluences == null) {
      continue;
    }

    morph.object.morphTargetInfluences[morph.key] = inputvalue;
  }
}

export function ClipMeshWithDashedEffectAfterMorph(mesh, step = 1, gap = 0.3) {
  if (
    !mesh ||
    !mesh.geometry ||
    !(mesh.geometry instanceof THREE.BufferGeometry)
  ) {
    console.error("Невалідний меш для обрізання.");
    return;
  }

  mesh.geometry.applyMatrix4(mesh.matrixWorld);
  mesh.geometry = mesh.geometry.toNonIndexed(); // Робимо геометрію неіндексованою
  const geometry = mesh.geometry.clone(); // Клонування геометрії для роботи

  const positions = geometry.attributes.position.array; // Масив позицій
  if (!positions) {
    console.error("Геометрія не містить позицій вершин.");
    return;
  }

  const newPositions = [];
  const vertexStepMap = [];

  const totalLength = step; // Довжина одного сегмента (зубчик + прогалина)
  const gapStart = step - gap; // Межа початку прогалини

  // Обробка вершин для створення штрихованого ефекту по осі Z
  for (let i = 0; i < positions.length; i += 3) {
    const zPos = positions[i + 2]; // Координата Z для поточної вершини

    // Округлення для усунення похибок плаваючої точки
    const normalizedPosition =
      zPos - Math.floor(zPos / totalLength) * totalLength;

    // Перевіряємо, чи вершина знаходиться в зоні штриха
    if (normalizedPosition < gapStart) {
      newPositions.push(positions[i], positions[i + 1], positions[i + 2]);
      vertexStepMap.push(newPositions.length / 3 - 1); // Маркуємо як частину штриха
    } else {
      vertexStepMap.push(-1); // Прогалина
    }
  }

  // Створення нових індексів
  const newIndices = [];
  const oldIndices = geometry.index ? geometry.index.array : null;

  if (oldIndices) {
    for (let j = 0; j < oldIndices.length; j += 3) {
      const v1 = vertexStepMap[oldIndices[j]];
      const v2 = vertexStepMap[oldIndices[j + 1]];
      const v3 = vertexStepMap[oldIndices[j + 2]];

      // Додаємо тільки трикутники, які не містять прогалини
      if (v1 >= 0 && v2 >= 0 && v3 >= 0) {
        newIndices.push(v1, v2, v3);
      }
    }
  }

  // Створення фінальної геометрії
  const dashedGeometry = new THREE.BufferGeometry();
  dashedGeometry.setAttribute(
    "position",
    new THREE.BufferAttribute(new Float32Array(newPositions), 3)
  );

  if (newIndices.length > 0) {
    dashedGeometry.setIndex(newIndices);
  }

  // Оновлення геометрії у меші
  mesh.geometry.dispose(); // Звільнити стару геометрію
  mesh.geometry = dashedGeometry;
  mesh.geometry.computeBoundingBox();
  mesh.geometry.computeBoundingSphere();
}

export function ConvertMorphValue(
  inputval,
  srcStart,
  srcEnd,
  destStart = 0,
  destEnd = 1
) {
  const result =
    destStart +
    ((inputval - srcStart) * (destEnd - destStart)) / (srcEnd - srcStart);
  return result;
}

export function ConvertMorphValueReverse(
  outputVal,
  srcStart,
  srcEnd,
  destStart = 0,
  destEnd = 1
) {
  const result =
    srcStart +
    ((outputVal - destStart) * (srcEnd - srcStart)) / (destEnd - destStart);
  return result;
}

//#endregion

//#region PROJECT FUNCTIONS PERGOLA

export function generateMidpoints(
  vectorA,
  vectorB,
  numPoints,
  isFirstLastPointAdded = false
) {
  const points = [];

  if (isFirstLastPointAdded) {
    points.push(vectorA.clone());
  }

  for (let i = 1; i <= numPoints; i++) {
    const t = i / (numPoints + 1);
    const point = new THREE.Vector3().lerpVectors(vectorA, vectorB, t);

    points.push(point);
  }

  if (isFirstLastPointAdded) {
    points.push(vectorB.clone());
  }

  return points;
}

export function generateCenterMidpoints(
  vectorA,
  vectorB,
  numPoints,
  isFirstLastPointAdded = false,
  divide = 1
) {
  const points = [];

  if (isFirstLastPointAdded) {
    points.push(vectorA);
  }

  for (let i = 1; i <= numPoints; i++) {
    const t = i / (numPoints + 1);
    const point = new THREE.Vector3().lerpVectors(vectorA, vectorB, t);
    points.push(point);
  }

  if (isFirstLastPointAdded) {
    points.push(vectorB);
  }

  if (points.length == 1) {
    return points;
  }

  var dividePoints = points;
  for (let index = 0; index < divide; index++) {
    dividePoints = pointDivideProcess(dividePoints);
  }

  return dividePoints;
}

function pointDivideProcess(points) {
  const dividePoint = [];

  for (let i = 0; i < points.length; i++) {
    if (i + 1 >= points.length) {
      continue;
    }

    var point1 = points[i];
    var point2 = points[i + 1];
    const centerPoint = new THREE.Vector3().lerpVectors(point1, point2, 0.5);

    dividePoint.push(centerPoint);
  }

  return dividePoint;
}

function setValueToCoordinates(points, axis, value) {
  for (let i = 0; i < points.length; i++) {
    points[i][axis] = value;
  }
}

var pointLights = [];
var ledLights = [];
var moodLeds = [];

export function getSubsystemSummary(type) {
  const spans = pergola.span?.objects || [];
  const activeSides = [];
  const seenSides = new Set();

  spans.forEach(span => {
    if (span.isSystemSet && span.activeSystemType === type && !seenSides.has(span.side)) {
      seenSides.add(span.side);
      activeSides.push(span.side);
    }
  });

  return activeSides;
}

export function getSideLabel(side) {
  switch (side) {
    case pergolaConst.side.Front: return 'Front';
    case pergolaConst.side.Back: return 'Back';
    case pergolaConst.side.Left: return 'Left';
    case pergolaConst.side.Right: return 'Right';
    default: return '';
  }
}

export function removeAllSubsystems() {
  const allTypes = [
    pergolaConst.systemType.slidingGlassDoor,
    pergolaConst.systemType.privacyWall,
    pergolaConst.systemType.autoShade,
  ];

  // Remove all 3D clones
  const clonesToRemove = [];
  scene.traverse((o) => {
    if (o.userData?.clonedDoor || o.userData?.clonedShutter || o.userData?.clonedShade) {
      clonesToRemove.push(o);
    }
  });
  clonesToRemove.forEach(c => c.parent?.remove(c));

  // Clear all span states
  if (pergola?.span?.objects) {
    pergola.span.objects.forEach(span => {
      span.systems?.forEach(system => {
        if (system) {
          system.active = false;
          if (system.object) pergola.changeObjectVisibility(false, system.object);
        }
      });
      span.active = true;
      span.isLocked = false;
      span.isSystemSet = false;
      span.activeSystemType = null;
    });
  }

  // Clear state
  state.subSystemUrl.clear();
  state.subSystem.clear();
  state.currentActiveSystems = null;

  // UI cleanup
  allTypes.forEach(type => hideIcon(type));
  $(`#last-group`).closest(".interface__group").find(".interface__group__head__param").text("-");
  $(`#last-group .option`).removeClass("type_interface_electronic_item--active");
  $(`#last-group input[type='radio']`).prop("checked", false);
  $(".portal-container").hide();
  $(".interface-container").removeClass("interface-container-portal");
}

export function resetToDefaults() {
  state.typePergola = 0;
  state.roofType = 0;
  state.retractOption = 'oneSide';
  state.louvreType = 0;
  state.postSize = 0;
  state.currentRotationZ = 30;
  state.isRotated = false;
  state.height = 2;
  state.length = 2;
  state.width = 4;
  state.backWall = false;
  state.colorRoof = "#3A3A3A";
  state.colorBody = "#3A3A3A";
  state.colorSladditec = "#3A3A3A";
  state.colorShutters = "#3A3A3A";
  state.colorZip = "#3A3A3A";
  state.directionRoof = 0;
  state.roofColorType = 0;
  state.louversOpeningInput = 0;
  state.heaters = false;
  state.moodLight = false;
  state.ledLights = false;
  state.lightingEnabled = false;
  state.recessedLighting = 4;
  state.wallOption = false;
  state.slatsSize = false;
  state.zipInput = 20;
  state.slidingDoorInput = 35;
  state.slidingShuttersInput = 30;
  state.slidingShuttersRotate = 0;
  state.slidingFixShuttersRotate = 0;
  state.biFoldDoorShattersInput = 0;
  state.biFoldDoorShattersRotate = 0;
  state.transparency = "10";
  state.portalOption = 0;
  state.dayMode = true;
  state.louverInterval = 16.5;
  state.postDepthInterval = 23.5;
  state.postWidthInterval = 23.5;
  state.electro.clear();

  // Reset subsystems (clears subSystem, subSystemUrl, currentActiveSystems + 3D clones)
  removeAllSubsystems();

  if (typeof window.updateHeaterVisibility === 'function') {
    window.updateHeaterVisibility(false);
  }
  // Reset all UI elements 
  resetUIToDefaults();

  applyAllColors();
  pergola.update();
}

//for summary info
export function getDoorPanelInfo(side) {
  const isXAxis = (side === pergolaConst.side.Front || side === pergolaConst.side.Back);
  const spanSize = isXAxis ? state.width : state.length;
  const maxSingle = state.roofType === 0 ? 6 : 4;
  const isDouble = Math.round(spanSize) > maxSingle;
  const spanPerSet = isDouble ? (spanSize / 2) : spanSize;

  let numPanels;
  if (spanPerSet < 2.4) numPanels = 2;
  else if (spanPerSet < 3.5) numPanels = 3;
  else if (spanPerSet < 4.5) numPanels = 4;
  else numPanels = 5;

  const panelWidth = (spanPerSet / numPanels).toFixed(2);
  const sets = isDouble ? 2 : 1;
  const totalPanels = numPanels * sets;

  return {
    spanSize,
    sets,
    panelsPerSet: numPanels,
    totalPanels,
    panelWidth,
    isDouble
  };
}

export function getShutterInfo(side) {
  const isXAxis = (side === pergolaConst.side.Front || side === pergolaConst.side.Back);
  const spanSize = isXAxis ? state.width : state.length;
  const shutterHasCentralPosts = state.roofType === 1 && (state.width >= 5.0 || state.length >= 4.0);
  const maxSingleSpan = state.roofType === 1
    ? (isXAxis ? (shutterHasCentralPosts ? 1.9 : 4) : 10)
    : 10;
  const isDouble = spanSize > maxSingleSpan;
  const spanPerSet = isDouble ? spanSize / 2 : spanSize;
  const numPanelsRaw = spanSize === 10 ? 10 : Math.max(2, Math.ceil(spanSize / 1.2));
  const numPanelsPerSet = isDouble ? Math.max(2, Math.ceil(spanPerSet / 1.2)) : numPanelsRaw;
  const numPanels = isDouble ? numPanelsPerSet * 2 : numPanelsRaw;
  const panelWidth = spanSize === 10 ? (1.0).toFixed(2) : (spanPerSet / numPanelsPerSet).toFixed(2);

  return {
    spanSize,
    numPanels,
    panelWidth
  };
}

export function getBlindInfo(side) {
  const isXAxis = (side === pergolaConst.side.Front || side === pergolaConst.side.Back);
  const spanSize = isXAxis ? state.width : state.length;
  const maxWidth = 4.5;
  let numFrames;
  if (spanSize <= maxWidth) numFrames = 1;
  else if (spanSize <= maxWidth * 2) numFrames = 2;
  else numFrames = 3;
  const frameWidth = (spanSize / numFrames).toFixed(2);

  return {
    spanSize,
    numFrames,
    frameWidth
  };
}

export class PergolaObject {
  constructor(settings) {
    this.productId = "";
    this.name = "";
    this.dimensions = new PergolaDimensions();
    this.post = new PergolaPost();
    this.span = new PergolaSpan();
    this.roof = new PergolaRoof();
    this.system = new PergolaSystem();
    this.mountingWall = new PergolaMountingWall();
    this.extraOptions = new PergolaExtraOptions();
    this.labelObject = null;
    this.settings = settings;
    this.lastSettings = new PergolaSettings();
    this.theModel = null;
    this.totalWidth = 0;
    this.totalHeight = 0;
    this.totalLength = 0;
    this.heatersFront = [];
    this.heatersBack = [];
    this.isUpdatingPergola = false;
    this.pendingPergolaUpdate = false;
  }

  createFrom3DModel(model) {
    pointLights = [];
    ledLights = [];
    moodLeds = [];

    this.theModel = model;
    window.model = model;

    const urlParams = window.location.search;
    const hasUrlConfig = urlParams.includes('config=');
    let decodedSubSystemUrl = null;

    if (hasUrlConfig) {
      const stateParam = urlParams.substring(urlParams.indexOf('config=') + 7);
      if (stateParam) {
        const decodedState = decodeURLToState(stateParam);
        decodedSubSystemUrl = decodedState.subSystemUrl ? [...decodedState.subSystemUrl] : [];
        Object.assign(state, decodedState);
      }
    }

    model.traverse((o) => {
      if (o.name.includes("lable")) {
        this.labelObject = o;
      }

      // POSTS
      if (o.name.includes("post")) {
        const prefix = `post_${state.postSize === 0 ? "100" : "150"}_retr`;

        if (o.name === `${prefix}_FR`) {
          this.post.postFR = o;
        } else if (o.name === `${prefix}_FL`) {
          this.post.postFL = o;
        } else if (o.name === `${prefix}_BL`) {
          this.post.postBL = o;
        } else if (o.name === `${prefix}_BR`) {
          this.post.postBR = o;
        } else if (o.name === `${prefix}_FC`) {
          this.post.postFC = o;
        } else if (o.name === `${prefix}_BC`) {
          this.post.postBC = o;
        }

        // hide all center posts initially
        if (o.name.includes("_FC") || o.name.includes("_BC")) {
          o.visible = false;
          o.traverse((child) => { child.visible = false; });
        }
      }

      // Opening Roof frames
      if (o.name === "frame_pivot_y") {
        o.visible = (state.roofType === 0 && !state.directionRoof);
        o.traverse((child) => { child.visible = o.visible; });
      }
      if (o.name === "frame_pivot_x") {
        o.visible = (state.roofType === 0 && !!state.directionRoof);
        o.traverse((child) => { child.visible = o.visible; });
      }

      // Retractable frames
      if (o.name === "frame_retr_2_y") {
        o.visible = (state.roofType === 1 && !state.directionRoof);
        o.traverse((child) => { child.visible = o.visible; });
      }
      if (o.name === "frame_retr_2_x") {
        o.visible = (state.roofType === 1 && !!state.directionRoof);
        o.traverse((child) => { child.visible = o.visible; });
      }

      // WALLS
      if ((o.name.includes("wall_back_door")) || (o.name.includes("wall_back_no_door"))) {
        var mountingWall = new PergolaMountingWallElement();
        mountingWall.object = o;
        mountingWall.side = PergolaElementOrientSide.Back;
        this.mountingWall.elements.push(mountingWall);
      }

      // Heater
      if (o.name.includes("UFO")) {
        var heater = new PergolaExtraOptionElement();

        heater.type = PergolaExtraOptionType.heater;
        heater.object = o;

        this.extraOptions.elements.push(heater);
      }

      // LED Strip
      if (o.name.includes("frame") && o.name.includes("LED")) {
        const ledLight = new PergolaExtraOptionElement();

        ledLight.type = PergolaExtraOptionType.led;
        ledLight.object = o;

        this.extraOptions.elements.push(ledLight);
      }

      // LED Strip MOOD LIGHTING
      if (o.name.includes("frame") && o.name.includes("001")) {
        const ledMood = new PergolaExtraOptionElement();

        ledMood.type = PergolaExtraOptionType.moodLed;
        ledMood.object = o;

        this.extraOptions.elements.push(ledMood);
      }
    });

    // ROOF 
    var roofTypeLouvered = new PergolaRoofTypeLouvered();
    model.traverse((o) => {
      if ((o.name.includes("louver") || o.name.includes("louvre")) && !o.name.includes("frame")) {
        var louveredObject = new PergolaRoofTypeLouveredObject();
        louveredObject.object = o;
        roofTypeLouvered.objects.push(louveredObject);
      }
    });

    //* SYSTEM
    const systemElements = {
      // Sliding glass doors
      slidetec_system: {
        type: pergolaConst.systemType.slidingGlassDoor,
        name: pergolaConst.systemNameString.slidingGlassDoor,
      },
      sliding_glass_panel: {
        type: pergolaConst.systemType.slidingGlassDoor,
        name: pergolaConst.systemNameString.slidingGlassDoor,
      },
      // Aluminum Sliding Shutters
      top_hung_sliding_track: {
        type: pergolaConst.systemType.privacyWall,
        name: pergolaConst.systemNameString.privacyWall,
      },
      //Outdoor Blinds
      blind_frame: {
        type: pergolaConst.systemType.autoShade,
        name: pergolaConst.systemNameString.autoShade,
      },
    };


    model.traverse((o) => {
      Object.keys(systemElements).forEach((key) => {
        if (o.name.includes(key)) {
          const systemObject = new PergolaSystemObject();
          systemObject.name = systemElements[key].name;
          systemObject.object = o;
          systemObject.type = systemElements[key].type;
          systemObject.direction = pergolaConst.direction.Straight;
          systemObject.openingside = true;
          systemObject.side = pergolaConst.side.Front;

          // _y = side (Left/Right), _x = front/back
          if (o.name.includes("_y")) {
            systemObject.direction = pergolaConst.direction.Perpendicular;
            systemObject.side = pergolaConst.side.Left;
          }

          this.system.objects.push(systemObject);
        }
      });
    });

    // this.prepareBeams();
    this.preparePosts();
    this.prepareRoof();
    this.prepareOptions();
    // this.prepareFrames();
    this.prepareLouvereds();
    this.prepareSystems();
    this.prepareSpans();
    updateHotspots(hotspots);

    ParseMorphByModel(scene);

    this.initializeLogos();

    setTimeout(() => {
      state.currentActiveSystems = null;

      this.changeDimensions(state.width, state.length, state.height);
      this.switchFrame();
      this.switchPostSize();
      this.setPosts();
      this.setCenterPosts();
      applyAllColors();

      this._lastLouverKey = null;
      this.setLouver();
      this.updateLogoPositions();

      if (state.backWall && typeof toggleBackWall === 'function') {
        toggleBackWall(true);
      }

      const limits = state.roofType === 0 ? MORPH_DATA.opening : MORPH_DATA.retractable;
      $('.range').each(function () {
        const label = $(this).find('.range__label').text().trim();
        const $input = $(this).find('.range__input__dimensions');
        const $min = $(this).find('.range__value--min');
        const $max = $(this).find('.range__value--max');

        if (label === 'Pivot (m)') {
          $input.attr('min', limits.width.min);
          $input.attr('max', limits.width.max);
          $input.val(state.width);
          if ($min.length) $min.text(limits.width.min);
          if ($max.length) $max.text(limits.width.max);
          $input.trigger('input');
        }
        if (label === 'Louvre Span (m)') {
          $input.attr('min', limits.length.min);
          $input.attr('max', limits.length.max);
          $input.val(state.length);
          if ($min.length) $min.text(limits.length.min);
          if ($max.length) $max.text(limits.length.max);
          $input.trigger('input');
        }
      });

      pergola.update();
      initURLSystem();

      const tryInitSubSystem = () => {
        if (theModel && Math.abs(theModel.scale.x - 1.0) < 0.01) {
          initSubSystem();
        } else {
          requestAnimationFrame(tryInitSubSystem);
        }
      };
      requestAnimationFrame(tryInitSubSystem);
    }, 500);
  }

  initializeLogos() {
    const textureLoader = new THREE.TextureLoader();
    const self = this;

    this.logoWhite = null;
    this.logoBlack = null;
    this.logoPlanes = [];

    const getLogoTexture = (hexColor) => {
      const hex = hexColor.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance < 0.5 ? self.logoWhite : self.logoBlack;
    };

    // MeshStandardMaterial is required — the USDZ exporter (iOS AR) skips MeshBasicMaterial.
    // emissiveMap makes the logo appear unlit (same brightness in web and AR).
    const createLogoMaterial = (texture) => {
      return new THREE.MeshStandardMaterial({
        map: texture,
        emissiveMap: texture,
        emissive: new THREE.Color(1, 1, 1),
        transparent: true,
        depthWrite: false,
        side: THREE.DoubleSide,
        roughness: 1,
        metalness: 0,
      });
    };

    const addLogoToPost = (postMesh, texture, postKey, inner = false) => {
      if (!postMesh) return;

      const logoSize = 0.32;
      const aspectRatio = 0.18;
      const geometry = new THREE.PlaneGeometry(logoSize, logoSize * aspectRatio);
      const material = createLogoMaterial(texture);

      const logoPlane = new THREE.Mesh(geometry, material);
      logoPlane.name = inner ? 'logoPlane_post_inner' : 'logoPlane_post';
      logoPlane.renderOrder = 999;
      logoPlane.userData.postKey = postKey;
      logoPlane.userData.inner = inner;
      // Store original UV array so it can be restored after AR exit
      const uvAttr = geometry.attributes.uv;
      logoPlane.userData.originalUVs = new Float32Array(uvAttr.array);

      theModel.add(logoPlane);
      self.logoPlanes.push(logoPlane);
    };

    const addLogoToFrame = (texture, side, inner = false) => {
      const logoSize = 0.065;
      const aspectRatio = 4.8;
      const geometry = new THREE.PlaneGeometry(logoSize * aspectRatio, logoSize);
      const material = createLogoMaterial(texture);

      const logoPlane = new THREE.Mesh(geometry, material);
      logoPlane.name = inner ? 'logoPlane_frame_inner' : 'logoPlane_frame';
      logoPlane.renderOrder = 999;
      logoPlane.userData.side = side;
      logoPlane.userData.inner = inner;
      // Store original UV array so it can be restored after AR exit
      const uvAttr = geometry.attributes.uv;
      logoPlane.userData.originalUVs = new Float32Array(uvAttr.array);

      theModel.add(logoPlane);
      self.logoPlanes.push(logoPlane);
    };

    let loadedCount = 0;

    const onTexturesLoaded = () => {
      const texture = getLogoTexture(state.colorBody || '#333333');

      // Post logos:
      const postKeys = ['postFR'];
      postKeys.forEach(key => {
        addLogoToPost(self.post[key], texture, key);        // outer post
        addLogoToPost(self.post[key], texture, key, true);  // inner post
      });

      // Frame logos:
      ['front', 'back'].forEach(side => {
        addLogoToFrame(texture, side);        // outer
        addLogoToFrame(texture, side, true);  // inner
      });

      self.updateLogoPositions();
    };

    textureLoader.load('public/img/water-mark-white.png', (texture) => {
      self.logoWhite = texture;
      self.logoWhite.colorSpace = THREE.SRGBColorSpace;
      loadedCount++;
      if (loadedCount === 2) onTexturesLoaded();
    });

    textureLoader.load('public/img/water-mark-black.png', (texture) => {
      self.logoBlack = texture;
      self.logoBlack.colorSpace = THREE.SRGBColorSpace;
      loadedCount++;
      if (loadedCount === 2) onTexturesLoaded();
    });
  }

  updateLogoPositions() {
    if (!this.logoPlanes || this.logoPlanes.length === 0) return;

    const postOffset = 0.0625;

    const halfWidth = state.width / 2;
    const halfLength = state.length / 2;
    const halfHeight = state.height / 2;

    // Height-dependent Y position
    const visualHeight = getHeightMorph(state.height) * 3.0;
    const frameTopY = visualHeight - 0.35;
    const postFROffset = getHeightMorph(state.height)

    const yOffset = -theModel.position.y;

    this.logoPlanes.forEach((logoPlane) => {
      if (logoPlane.name === 'logoPlane_post') {
        const postKey = logoPlane.userData.postKey;
        const postMesh = this.post[postKey];

        if (postMesh && postMesh.visible) {
          logoPlane.visible = true;

          let x, z;
          switch (postKey) {
            case 'postFR': x = halfWidth - postOffset; z = halfLength - postOffset; break;
            // case 'postFL': x = -halfWidth + postOffset; z = halfLength - postOffset; break;
            // case 'postBR': x = halfWidth + postOffset - 0.1; z = -halfLength + postOffset - 0.1; break;
            // case 'postBL': x = -halfWidth + postOffset + 0.01; z = -halfLength + postOffset - 0.1; break;
          }

          logoPlane.position.set(x, frameTopY - 0.35 + yOffset, z + postOffset);
          if (postKey === 'postBR' || postKey === 'postBL') {
            logoPlane.rotation.set(0, Math.PI, Math.PI / 2);
          } else {
            logoPlane.rotation.set(0, 0, Math.PI / 2);
          }
        } else {
          logoPlane.visible = false;
        }

      } else if (logoPlane.name === 'logoPlane_frame') {
        const side = logoPlane.userData.side;

        // Position logo at ~30% from right edge of each frame side
        const frontBackOffset = Math.max(0, halfWidth - 0.2);

        switch (side) {
          case 'front':
            logoPlane.position.set(frontBackOffset, frameTopY + yOffset, halfLength + 0.0025);
            logoPlane.rotation.set(0, 0, 0);
            break;
          case 'back':
            logoPlane.position.set(-frontBackOffset, frameTopY + yOffset, -(halfLength + 0.005));
            logoPlane.rotation.set(0, Math.PI, 0);
            break;
        }

      } else if (logoPlane.name === 'logoPlane_post_inner') {
        const postKey = logoPlane.userData.postKey;
        const postMesh = this.post[postKey];

        if (postMesh && postMesh.visible) {
          logoPlane.visible = true;

          const postDepth = state.postSize === 0 ? 0.105 : 0.158;
          logoPlane.position.set(halfWidth - postOffset, frameTopY - 0.35 + yOffset, halfLength - postDepth - 0.0010);
          logoPlane.rotation.set(0, Math.PI, Math.PI / 2);
        } else {
          logoPlane.visible = false;
        }

      } else if (logoPlane.name === 'logoPlane_frame_inner') {
        const side = logoPlane.userData.side;

        const hasCentralPosts = (state.roofType === 1) && (state.width >= 5.0 || state.length >= 4.0);
        const frontBackOffset = Math.max(0, (hasCentralPosts ? 0.12 : 0.05) * halfWidth);

        switch (side) {
          case 'front':
            logoPlane.position.set(frontBackOffset, frameTopY - 0.028 + yOffset, halfLength - 0.065);
            logoPlane.rotation.set(0, Math.PI, 0);
            break;
          case 'back':
            logoPlane.position.set(-frontBackOffset, frameTopY - 0.055 + yOffset, -(halfLength - 0.07));
            logoPlane.rotation.set(0, 0, 0);
            break;
        }
      }
    });
  }

  updateLogos() {
    if (!this.logoWhite || !this.logoBlack || !this.logoPlanes) {
      console.log('updateLogos: not ready', !!this.logoWhite, !!this.logoBlack, !!this.logoPlanes);
      return;
    }

    const hex = state.colorBody.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    const texture = luminance < 0.5 ? this.logoWhite : this.logoBlack;

    this.logoPlanes.forEach((logoPlane) => {
      logoPlane.material.map = texture;
      logoPlane.material.emissiveMap = texture;
      logoPlane.material.needsUpdate = true;
    });

    this.updateLogoPositions();
  }

  restoreLogoUVs() {
    if (!this.logoPlanes) return;
    this.logoPlanes.forEach((logoPlane) => {
      const uvAttr = logoPlane.geometry.attributes.uv;
      const original = logoPlane.userData.originalUVs;
      if (uvAttr && original) {
        uvAttr.array.set(original);
        uvAttr.needsUpdate = true;
      }
    });
  }

  preparePosts() {
    const countPosts = 1;

    // const qtyMiddlePostsWidth = Math.floor(
    //   this.settings.maxWidth / minInterval
    // );

    this.clonePostObject(countPosts, "leftCenter");
    this.clonePostObject(countPosts, "rightCenter");
    this.clonePostObject(countPosts, "frontCenter");
    this.clonePostObject(countPosts, "backCenter");
    this.clonePostObject(countPosts, "centerCenter");
  }

  getPostPoints(xOffset, zOffset) {
    const offsetX = 0.075;
    const offsetZ = 0;

    const qtyWidth = Math.floor(state.width / state.postWidthInterval);

    const qtyWidthLouver = Math.floor(state.width / state.louverInterval);
    const qtyLengthLouver = Math.floor(state.length / state.louverInterval);

    const qtyLength = Math.floor(state.length / state.postDepthInterval);

    const { FL_point, FR_point, RR_point } = this.getCornerPoints();

    const point_post_width = generateMidpoints(FL_point, FR_point, qtyWidth);

    const point_louver_width = generateMidpoints(
      FL_point,
      FR_point,
      qtyWidthLouver
    );

    const point_post_length = generateMidpoints(FR_point, RR_point, qtyLength);
    const point_louver_length = generateMidpoints(
      FR_point,
      RR_point,
      qtyLengthLouver
    );

    return {
      point_post_width,
      point_louver_width,
      point_post_length,
      point_louver_length,
    };
  }

  switchFrame() {
    const model = this.theModel;
    if (!model) return;
    model.traverse((o) => {
      // Opening Roof 
      if (o.name === "frame_pivot_y") {
        const vis = (state.roofType === 0 && !state.directionRoof);
        o.visible = vis;
        o.traverse((child) => { child.visible = vis; });
      }
      if (o.name === "frame_pivot_x") {
        const vis = (state.roofType === 0 && !!state.directionRoof);
        o.visible = vis;
        o.traverse((child) => { child.visible = vis; });
      }
      // Retractable 
      if (o.name === "frame_retr_2_y") {
        const vis = (state.roofType === 1 && !state.directionRoof && state.retractOption !== 'oneSide');
        o.visible = vis;
        o.traverse((child) => { child.visible = vis; });
      }
      if (o.name === "frame_retr_1_y_R") {
        const vis = (state.roofType === 1 && !state.directionRoof && state.retractOption === 'oneSide');
        o.visible = vis;
        o.traverse((child) => { child.visible = vis; });
      }
    });
  }

  switchPostSize() {
    const prefix = this.getPostNamePrefix();

    // clean old center post clones from scene
    const oldPosts = ["leftCenter", "rightCenter", "frontCenter", "backCenter", "centerCenter"];
    oldPosts.forEach((side) => {
      if (this.post[side]) {
        this.post[side].forEach((postObj) => {
          if (postObj.object && postObj.object.parent) {
            postObj.object.parent.remove(postObj.object);
          }
        });
        this.post[side] = [];
      }
    });

    model.traverse((o) => {
      if (o.name.startsWith("post_")) {
        o.visible = false;
      }
    });

    // Reassign corner posts to new size
    model.traverse((o) => {
      if (o.name === `${prefix}_FR`) this.post.postFR = o;
      if (o.name === `${prefix}_FL`) this.post.postFL = o;
      if (o.name === `${prefix}_BL`) this.post.postBL = o;
      if (o.name === `${prefix}_BR`) this.post.postBR = o;
    });

    // Re-clone center posts from new size templates
    this.preparePosts();

    // Re-register all morphs so the new clones and freshly-assigned templates
    // are included in the morphs array before changeDimensions() runs.
    ParseMorphByModel(scene);
  }

  changeRoofVisibility(status, arrayName = null, type = null, reset = false) {
    if (this.roof == null || !arrayName) {
      return;
    }
    if (!this.roof[arrayName]) {
      return;
    }

    for (let i = 0; i < this.roof[arrayName].length; i++) {
      let element = this.roof[arrayName][i];

      if (type != null && element.type !== type) {
        continue;
      }

      if (Array.isArray(element)) {
        element.forEach((item) => {
          if (item.object) {
            item.object.visible = status;

            if (item.object.isGroup) {
              item.object.children.forEach((child) => (child.visible = status));
            }

            if (status === false && reset === true) {
              item.active = false;
            }
          }
        });
      } else if (element.object) {
        element.object.visible = status;

        if (element.object.isGroup) {
          element.object.children.forEach((child) => (child.visible = status));
        }

        if (status === false && reset === true) {
          element.active = false;
        }
      }
    }
  }

  setRoofBeam() {
    this.changeRoofVisibility(false, "beamX", null, true);
    this.changeRoofVisibility(false, "beamY", null, true);
    this.changeRoofVisibility(false, "beamXLed", null, true);
    this.changeRoofVisibility(false, "beamYLed", null, true);

    const {
      point_post_length,
      point_post_width,
      point_louver_width,
      point_louver_length,
    } = this.getPostPoints();

    if (state.directionRoof) {
      this.setBeamsPosition(point_louver_length, this.roof.beamX);
      this.setBeamsPosition(point_post_width, this.roof.beamY, true);
      if (state.electro.has(pergolaConst.optionNameString.LEDStrip)) {
        this.setBeamsPosition(point_louver_length, this.roof.beamXLed);
        this.setBeamsPosition(point_post_width, this.roof.beamYLed, true);
      }
    } else {
      this.setBeamsPosition(point_post_length, this.roof.beamX);
      this.setBeamsPosition(point_louver_width, this.roof.beamY, true);
      if (state.electro.has(pergolaConst.optionNameString.LEDStrip)) {
        this.setBeamsPosition(point_post_length, this.roof.beamXLed);
        this.setBeamsPosition(point_louver_width, this.roof.beamYLed, true);
      }
    }
  }

  addOffset(target, direction, offset) {
    if (Array.isArray(target)) {
      return target.map((el) => {
        return {
          ...el,
          [direction]: el[direction] + offset,
        };
      });
    } else {
      return {
        ...target,
        [direction]: target[direction] + offset,
      };
    }
  }

  generateCenterPoints(points) {
    const centerPoints = [];

    for (let i = 0; i < points.length - 1; i++) {
      const midX = (points[i].x + points[i + 1].x) / 2;
      const midY = (points[i].y + points[i + 1].y) / 2;
      const midZ = (points[i].z + points[i + 1].z) / 2;

      centerPoints.push(new THREE.Vector3(midX, midY, midZ));
    }

    return centerPoints;
  }

  interpolateValue(inputval, rangeMin, rangeMax, kMin = 0, kMax = 1) {
    return (
      kMin + ((inputval - rangeMin) * (kMax - kMin)) / (rangeMax - rangeMin)
    );
  }

  changeRoofVisibilityRest(
    status,
    arrayName = null,
    type = null,
    reset = false
  ) {
    if (this == null || !arrayName) {
      return;
    }
    if (!this[arrayName]) {
      return;
    }

    for (let i = 0; i < this[arrayName].length; i++) {
      let element = this[arrayName][i];

      if (type != null && element.type !== type) {
        continue;
      }

      if (Array.isArray(element)) {
        element.forEach((item) => {
          if (item.object) {
            item.object.visible = status;

            if (item.object.isGroup) {
              item.object.children.forEach((child) => (child.visible = status));
            }

            if (status === false && reset === true) {
              item.active = false;
            }
          }
        });
      } else if (element.object) {
        element.object.visible = status;

        if (element.object.isGroup) {
          element.object.children.forEach((child) => (child.visible = status));
        }

        if (status === false && reset === true) {
          element.active = false;
        }
      }
    }
  }


  cloneWithMorphs(doorGroup) {
    const clonedGroup = doorGroup.clone();

    clonedGroup.traverse((child) => {
      if (child.isMesh && child.geometry && child.geometry.morphAttributes) {
        // Клонування геометрії та морфів
        child.geometry = child.geometry.clone();

        if (child.morphTargetInfluences) {
          // Копіюємо всі морфи, щоб вони застосовувались коректно
          child.morphTargetInfluences = [...child.morphTargetInfluences];
        }

        if (child.morphTargetDictionary) {
          // Також копіюємо словник морфів, якщо він є
          child.morphTargetDictionary = { ...child.morphTargetDictionary };
        }

        // Переконайтеся, що всі атрибути морфів копіюються в новий об'єкт
        if (child.geometry.morphAttributes.position) {
          child.geometry.morphAttributes.position = [
            ...child.geometry.morphAttributes.position,
          ];
        }
      }
    });

    return clonedGroup;
  }

  cloneMeshWithMorphs(originalMesh) {
    const clonedMesh = originalMesh.clone(true);

    clonedMesh.geometry = originalMesh.geometry.clone();
    clonedMesh.geometry.morphAttributes = {
      ...originalMesh.geometry.morphAttributes,
    };

    clonedMesh.material = originalMesh.material.clone();
    clonedMesh.material.morphTargets = true;

    // Якщо були morphTargetInfluences — скопіювати
    if (originalMesh.morphTargetInfluences) {
      clonedMesh.morphTargetInfluences = [
        ...originalMesh.morphTargetInfluences,
      ];
    }

    return clonedMesh;
  }

  getPergolaBounds() {
    return {
      minX: -state.width / 2,
      maxX: state.width / 2,
      minZ: -state.length / 2,
      maxZ: state.length / 2
    };
  }

  getSideTargetWorldPos(side, offsets = {}) {
    const bounds = this.getPergolaBounds();
    if (!bounds) return new THREE.Vector3(0, 0, 0);

    const {
      front = 0,
      back = 0,
      left = 0,
      right = 0
    } = offsets;

    const pos = new THREE.Vector3(0, 0, 0);

    switch (side) {
      case pergolaConst.side.Front:
        pos.z = bounds.maxZ - front;
        break;

      case pergolaConst.side.Back:
        pos.z = bounds.minZ + back;
        break;

      case pergolaConst.side.Left:
        pos.x = bounds.minX + left;
        break;

      case pergolaConst.side.Right:
        pos.x = bounds.maxX - right;
        break;
    }

    return pos;
  }

  getSideTargetLocalPos(parent, side, offsets = {}) {
    parent.updateWorldMatrix(true, false);
    const worldPos = this.getSideTargetWorldPos(side, offsets);
    return parent.worldToLocal(worldPos.clone());
  }

  updateSubsystems() {
    const { span_width, span_depth } = this.getSpanPoints();
    const spans = this.span.objects;
    const processedSides = new Set();

    for (let i = 0; i < spans.length; i++) {
      const span = spans[i];

      if (span.isSystemSet && span.activeSystemType !== null) {
        const system = span.systems.find((s) => s && s.type === span.activeSystemType);
        if (system && !processedSides.has(span.side)) {
          processedSides.add(span.side);

          switch (system.type) {
            case pergolaConst.systemType.slidingGlassDoor:
              const doorSide = span.side;
              this.cleanOtherSystemsOnSide(doorSide, pergolaConst.systemType.slidingGlassDoor);
              const isXAxis = (doorSide === pergolaConst.side.Front || doorSide === pergolaConst.side.Back);
              const doorSuffix = isXAxis ? '_x' : '_y';
              const doorSpanSize = isXAxis ? state.width : state.length;

              const halfWidth = state.width / 2;
              const halfLength = state.length / 2;

              const railStep = 0.024;

              const pickSlideTecConfig = (spanMeters) => {
                if (spanMeters <= 1.2) return { systemNum: 2, letters: ['a'] };
                if (spanMeters <= 2.4) return { systemNum: 2, letters: ['a', 'b'] };
                if (spanMeters < 3.5) return { systemNum: 3, letters: ['a', 'b', 'c'] };
                if (spanMeters < 4.5) return { systemNum: 4, letters: ['a', 'b', 'c', 'd'] };
                return { systemNum: 5, letters: ['a', 'b', 'c', 'd', 'e'] }; // <= 6.0
              };

              const ensureVisible = (o) => {
                o.visible = true;

                o.traverse((ch) => {
                  ch.visible = true;
                })
              };

              const markClone = (o) => {
                o.userData = o.userData || {};
                o.userData.clonedDoor = true;
                o.userData.doorSide = doorSide;
              };

              const getInwardSign = (side) => {
                switch (side) {
                  case pergolaConst.side.Front: return -1; // inside is -Z
                  case pergolaConst.side.Back: return +1; // inside is +Z
                  case pergolaConst.side.Left: return +1; // inside is +X
                  case pergolaConst.side.Right: return -1; // inside is -X
                  default: return -1;
                }
              };

              // let doorTargetPos = { x: 0, z: 0 };
              // switch (doorSide) {
              //   case pergolaConst.side.Front:
              //     doorTargetPos.z = halfLength - 0.075;
              //     break;
              //   case pergolaConst.side.Back:
              //     doorTargetPos.z = -(halfLength - 0.06);
              //     break;
              //   case pergolaConst.side.Left:
              //     doorTargetPos.x = -(halfWidth - 0.07);
              //     break;
              //   case pergolaConst.side.Right:
              //     doorTargetPos.x = halfWidth - 0.01;
              //     break;
              // }

              const doorOffsets = {
                front: 0.075,
                back: 0.06,
                left: 0.07,
                right: 0.07
              };

              const isChildOfClone = (obj) => {
                let parent = obj.parent;
                while (parent) {
                  if (parent.userData?.clonedDoor) return true;
                  parent = parent.parent;
                }
                return false;
              };

              const oldClones = [];
              scene.traverse((o) => {
                if (isChildOfClone(o)) return;

                if (
                  (o.name.startsWith('slidetec_system_') || o.name.startsWith('sliding_glass_panel_x_') || o.name.startsWith('sliding_glass_panel_y_')) &&
                  o.name.includes(doorSuffix)
                ) {
                  if (!o.userData?.clonedDoor) {
                    o.visible = false;
                    o.traverse(child => { child.visible = false; });
                  } else if (o.userData?.doorSide === doorSide) {
                    oldClones.push(o);
                  }
                }
              });
              oldClones.forEach(c => c.parent?.remove(c));

              const applyDoorColor = (obj) => {
                obj.traverse(child => {
                  if (child.isMesh && child.material) {
                    const materials = Array.isArray(child.material) ? child.material : [child.material];
                    materials.forEach(mat => {
                      if (mat.name === 'powder_coat') {
                        mat = mat.clone();
                        mat.color.set(state.colorSladditec);
                        if (Array.isArray(child.material)) {
                          const idx = child.material.findIndex(m => m.name === 'powder_coat');
                          if (idx !== -1) child.material[idx] = mat;
                        } else {
                          child.material = mat;
                        }
                      }
                    });
                  }
                });
              };

              if (doorSpanSize > 1.2 && doorSpanSize < 1.6) {
                const clonesToRemove = [];
                scene.traverse(o => {
                  if (o.userData?.clonedDoor && o.userData?.doorSide === doorSide) clonesToRemove.push(o);
                });
                clonesToRemove.forEach(c => c.parent?.remove(c));
                break;
              }

              const hasCentralPosts = state.roofType === 1 && (state.width >= 5.0 || state.length >= 4.0);

              if (isXAxis && state.roofType === 1 && hasCentralPosts && ((doorSpanSize >= 2.0 && doorSpanSize <= 2.4) || (doorSpanSize >= 2.7 && doorSpanSize <= 2.9))) {
                const clonesToRemove = [];
                scene.traverse(o => {
                  if (o.userData?.clonedDoor && o.userData?.doorSide === doorSide) clonesToRemove.push(o);
                });
                clonesToRemove.forEach(c => c.parent?.remove(c));
                break;
              }
              const maxSingleSpan = state.roofType === 0 ? 6 : (isXAxis && hasCentralPosts ? 1.9 : 6);
              const isDouble = doorSpanSize > maxSingleSpan;

              const spanPerSet = isDouble ? (doorSpanSize / 2) : doorSpanSize;
              const { systemNum: doorSystemNum, letters: doorPanelLetters_raw } = pickSlideTecConfig(spanPerSet);
              const doorPanelLetters = (isXAxis && state.roofType === 1 && hasCentralPosts && doorSpanSize >= 2.5 && doorSpanSize <= 2.6)
                ? ['a']
                : doorPanelLetters_raw;

              const doorFrameName = `slidetec_system_${doorSystemNum}${doorSuffix}`;
              const doorPanelNames = doorPanelLetters.map(l => `sliding_glass_panel${doorSuffix}_${l}`);


              const doorHeightMorph = getDoorHeightMorph(state.height);
              const frameWidthBonus = (isDouble && doorSpanSize > 6 && doorSpanSize < 7)
                ? 0.12 * (7 - doorSpanSize)
                : 0;
              const _fwIsCP29 = isXAxis && state.roofType === 1 && hasCentralPosts && doorSpanSize >= 2.5 && doorSpanSize <= 2.6;
              const _fwCP29Offset = 0.08 + ((doorSpanSize - 2.5) / 0.4) * 0.05;
              const doorFrameWidthMorph = state.roofType === 0
                ? getDoorFrameWidthMorph(spanPerSet - 0.015 + frameWidthBonus)
                : _fwIsCP29
                  ? getDoorFrameWidthMorph(spanPerSet + _fwCP29Offset)
                  : (isXAxis && state.roofType === 1 && hasCentralPosts && doorSpanSize >= 3.0 && doorSpanSize < 5.0)
                    ? getDoorFrameWidthMorph(spanPerSet + 0.15)
                    : (isXAxis && state.roofType === 1 && doorSpanSize === 5)
                      ? getDoorFrameWidthMorph(spanPerSet + 0.15)
                      : (!isXAxis && state.roofType === 1 && doorSpanSize === 5)
                        ? getDoorFrameWidthMorph(spanPerSet - 0.07)
                        : getDoorFrameWidthMorph(spanPerSet);
              const panelWidthBase = spanPerSet === 1.0 ? 0.85
                : spanPerSet === 2 ? (spanPerSet / doorPanelLetters.length) * 0.92
                  : (spanPerSet / doorPanelLetters.length);
              let panelWidth = state.roofType === 1 ? panelWidthBase * 0.99 : panelWidthBase;
              const dim = isXAxis ? state.width : state.length;
              if (!isXAxis && dim >= 3.5 && dim <= 4.4) panelWidth = panelWidthBase * 1.01;
              else if (!isXAxis && dim === 2.9) panelWidth = panelWidthBase * 1.01;
              else if (dim >= 1.1 && dim <= 1.2) panelWidth = panelWidthBase * 0.9;
              else if (dim >= 1.6 && dim <= 1.9) panelWidth = panelWidthBase * 0.95;
              else if (isXAxis && state.roofType === 1 && hasCentralPosts && dim >= 2.5 && dim <= 2.6) panelWidth = panelWidthBase * 0.97;
              else if (isXAxis && state.roofType === 1 && hasCentralPosts && dim === 4.0) panelWidth = panelWidthBase * 1.02;
              else if ((state.roofType === 1 || !isXAxis) && dim >= 2.1 && dim <= 3.9) panelWidth = panelWidthBase * 0.98;
              else if ((state.roofType === 1 || !isXAxis) && dim >= 4.5 && dim <= 4.7) panelWidth = panelWidthBase * 0.99;
              else if ((state.roofType === 1 || !isXAxis) && dim >= 6.1 && dim <= 6.9) panelWidth = panelWidthBase * 0.999;
              else if (dim >= 11.0 && dim < 12.0) panelWidth = panelWidthBase * 1.02;
              const doorPanelWidthMorph = getDoorPanelWidthMorph(panelWidth);

              const applyFrameMorphs = (obj) => {
                obj.traverse(child => {
                  if (child.isMesh && child.morphTargetDictionary && child.morphTargetInfluences) {
                    const h = child.morphTargetDictionary['height'];
                    if (h !== undefined) child.morphTargetInfluences[h] = doorHeightMorph;

                    const w = child.morphTargetDictionary['width'];
                    if (w !== undefined) child.morphTargetInfluences[w] = doorFrameWidthMorph;

                    const l = child.morphTargetDictionary['lenth'];
                    if (l !== undefined) child.morphTargetInfluences[l] = doorFrameWidthMorph;
                  }
                });

              };

              const applyPanelMorphs = (obj) => {
                obj.traverse(child => {
                  if (child.isMesh && child.morphTargetDictionary && child.morphTargetInfluences) {
                    const h = child.morphTargetDictionary['height'];
                    if (h !== undefined) child.morphTargetInfluences[h] = doorHeightMorph;

                    const w = child.morphTargetDictionary['width'];
                    if (w !== undefined) child.morphTargetInfluences[w] = doorPanelWidthMorph;

                    const l = child.morphTargetDictionary['lenth'];
                    if (l !== undefined) child.morphTargetInfluences[l] = doorPanelWidthMorph;
                  }
                });
              };

              let frameTemplate = null;
              scene.traverse((o) => {
                if (o.name === doorFrameName && !o.userData?.clonedDoor) frameTemplate = o;
              });

              const panelTemplates = new Map();
              scene.traverse((o) => {
                if (!o.userData?.clonedDoor && doorPanelNames.includes(o.name)) {
                  panelTemplates.set(o.name, o);
                }
              });

              let setOffsets = isDouble ? [-doorSpanSize / 4, doorSpanSize / 4] : [0];
              const framesBySetOffset = new Map();
              const inset = 0.07;

              if (frameTemplate) {
                const tempFrame = frameTemplate.clone(true);
                applyFrameMorphs(tempFrame);
                tempFrame.updateWorldMatrix(true, true);
                const tempBox = new THREE.Box3().setFromObject(tempFrame);
                const frameGeoWidth = isXAxis ? (tempBox.max.x - tempBox.min.x) : (tempBox.max.z - tempBox.min.z);
                const frameGeoCenter = isXAxis
                  ? (tempBox.max.x + tempBox.min.x) / 2
                  : (tempBox.max.z + tempBox.min.z) / 2;
                const frameCenterOffset = frameGeoCenter;

                if (isDouble) {
                  const tempFrame = frameTemplate.clone(true);
                  applyFrameMorphs(tempFrame);
                  tempFrame.updateWorldMatrix(true, true);
                  const tempBox = new THREE.Box3().setFromObject(tempFrame);
                  const frameGeoWidth = isXAxis
                    ? (tempBox.max.x - tempBox.min.x)
                    : (tempBox.max.z - tempBox.min.z);

                  const interpDivisor = (map, defaultVal, val) => {
                    const keys = Object.keys(map).map(Number).sort((a, b) => a - b);
                    if (!keys.length) return defaultVal;
                    if (val <= keys[0]) return map[keys[0]];
                    if (val >= keys[keys.length - 1]) return map[keys[keys.length - 1]];
                    if (map[val] !== undefined) return map[val];
                    for (let i = 0; i < keys.length - 1; i++) {
                      if (val >= keys[i] && val <= keys[i + 1]) {
                        const t = (val - keys[i]) / (keys[i + 1] - keys[i]);
                        return map[keys[i]] + t * (map[keys[i + 1]] - map[keys[i]]);
                      }
                    }
                    return defaultVal;
                  };

                  let divisor;
                  if (state.roofType === 0) {
                    divisor = interpDivisor(
                      { 6: 4.2, 7: 3.55, 8: 3.075, 9: 2.73, 10: 2.45, 11: 2.22, 12: 2.02 },
                      2.4,
                      doorSpanSize
                    );
                    if (doorSpanSize > 6 && doorSpanSize < 7) {
                      divisor -= 0.1 * (7 - doorSpanSize);
                    }
                  } else {
                    if (isXAxis) {
                      divisor = interpDivisor(
                        { 2: 11.0, 3: 8.5, 4: 6.20, 5: 4.875, 6: 4.05, 7: 3.55 },
                        4.0,
                        doorSpanSize
                      );
                    } else {
                      divisor = interpDivisor(
                        { 5: 4.9 },
                        5.0,
                        doorSpanSize
                      );
                    }
                  }

                  const frameHalfGeo = frameGeoWidth / divisor;
                  setOffsets[0] = -frameHalfGeo;
                  setOffsets[1] = frameHalfGeo;
                }

                // setOffsets.forEach((setOffset) => {
                //   const frameObj = frameTemplate.clone(true);
                //   markClone(frameObj);
                //   frameTemplate.parent.add(frameObj);

                //   ensureVisible(frameObj);
                //   applyFrameMorphs(frameObj);
                //   applyDoorColor(frameObj);

                //   if (isXAxis) {
                //     frameObj.position.z = doorTargetPos.z;
                //     frameObj.position.x = setOffset;
                //   } else {
                //     frameObj.position.x = doorTargetPos.x;
                //     frameObj.position.z = setOffset;
                //   }

                //   framesBySetOffset.set(setOffset, frameObj);
                // });

                setOffsets.forEach((setOffset) => {
                  const frameObj = frameTemplate.clone(true);
                  markClone(frameObj);
                  frameTemplate.parent.add(frameObj);

                  ensureVisible(frameObj);
                  applyFrameMorphs(frameObj);
                  applyDoorColor(frameObj);

                  const doorTargetPos = this.getSideTargetLocalPos(frameTemplate.parent, doorSide, doorOffsets);

                  if (isXAxis) {
                    frameObj.position.z = doorTargetPos.z;
                    frameObj.position.x = setOffset;
                    if ((state.width >= 1.0) && (state.width <= 1.9)) {
                      frameObj.position.z += doorSide === pergolaConst.side.Front ? -inset : inset / 2;
                    }
                  } else {
                    frameObj.position.x = doorTargetPos.x;
                    frameObj.position.z = setOffset;
                    if ((state.length >= 1.0) && (state.length <= 1.9)) {
                      frameObj.position.x += doorSide === pergolaConst.side.Right ? -inset / 3 : inset;
                    } else if (state.roofType === 1 && state.length === 5) {
                      frameObj.position.z = setOffset - 0.05
                    }
                  }

                  theModel.attach(frameObj);
                  framesBySetOffset.set(setOffset, frameObj);
                });
              }
              //panels
              const inward = getInwardSign(doorSide);
              const outsideDir = -inward;
              let depthToRail;
              switch (doorSide) {
                case pergolaConst.side.Front:
                  depthToRail = -(doorPanelLetters.length * railStep) + 0.08;
                  break;
                case pergolaConst.side.Back:
                  depthToRail = -((doorPanelLetters.length * railStep) - 0.04);
                  if ((state.width >= 1.0) && (state.width <= 1.9)) {
                    depthToRail = -((doorPanelLetters.length * railStep) - 0.01);
                  }
                  break;
                case pergolaConst.side.Left:
                  depthToRail = -(doorPanelLetters.length * railStep) + 0.08;
                  if ((state.length >= 1.0) && (state.length <= 1.9)) {
                    depthToRail = (doorPanelLetters.length * railStep);
                  }
                  break;
                case pergolaConst.side.Right:
                  if ((state.length >= 1.0) && (state.length <= 1.9)) {
                    depthToRail = -(doorPanelLetters.length * railStep) - 0.01;
                  } else if ((state.length >= 2.0) && (state.length <= 2.4)) {
                    depthToRail = -(doorPanelLetters.length * railStep) + 0.01;
                  } else if ((state.length >= 2.5) && (state.length <= 3.3)) {
                    depthToRail = -(doorPanelLetters.length * railStep) + 0.02;
                  } else if ((state.length >= 3.4) && (state.length <= 4.4)) {
                    depthToRail = -(doorPanelLetters.length * railStep) + 0.04;
                  } else if ((state.length >= 4.5) && (state.length <= 5.0)) {
                    depthToRail = -(doorPanelLetters.length * railStep) + 0.06;
                  } else {
                    depthToRail = -(doorPanelLetters.length * railStep) + 0.02;
                  }
                  break;
              }

              const openPercent = 1 - (state.slidingDoorInput / 100);

              doorPanelLetters.forEach((l, index) => {
                const panelName = `sliding_glass_panel${doorSuffix}_${l}`;
                const panelTemplate = panelTemplates.get(panelName);
                if (!panelTemplate) return;

                const railOffset = index * railStep;

                // setOffsets.forEach((setOffset) => {
                //   const panelObj = panelTemplate.clone(true);
                //   markClone(panelObj);
                //   panelTemplate.parent.add(panelObj);

                //   ensureVisible(panelObj);
                //   applyPanelMorphs(panelObj);
                //   applyDoorColor(panelObj);

                //   panelObj.updateWorldMatrix(true, true);
                //   const panelBox = new THREE.Box3().setFromObject(panelObj);
                //   const panelGeoMin = isXAxis ? panelBox.min.x : panelBox.min.z;
                //   const panelOriginPos = isXAxis ? panelObj.position.x : panelObj.position.z;

                //   const baseOffset = panelGeoMin - panelOriginPos;
                //   let panelLeftOffset;
                //   const isMaxSpan = (spanPerSet === 6.0) && (state.roofType === 0);
                //   const isOddDouble = isDouble && (Math.round(doorSpanSize) === 5 || Math.round(doorSpanSize) === 7 || Math.round(doorSpanSize) === 9);

                //   if (isXAxis) {
                //     if (isMaxSpan) {
                //       const firstPanelExtra = -(0.01 + (doorPanelWidthMorph * 0.01));
                //       const otherPanelExtra = (0.01 + (doorPanelWidthMorph * 0.02));
                //       panelLeftOffset = index === 0 ? baseOffset + firstPanelExtra : baseOffset + otherPanelExtra;
                //     } else if (isOddDouble) {
                //       panelLeftOffset = baseOffset + 0.2;
                //     } else {
                //       panelLeftOffset = baseOffset + 0.1;
                //     }
                //   } else {
                //     //left/right
                //     panelLeftOffset = baseOffset + 0.08;
                //   }

                //   const frameLeftEdge = -(spanPerSet / 2);

                //   // Open (slidingDoorInput = 0)
                //   const openPos = frameLeftEdge - panelLeftOffset;

                //   // Closed 
                //   const closedPos = frameLeftEdge + (index * panelWidth) - panelLeftOffset;

                //   const closePercent = state.slidingDoorInput / 100;
                //   const panelPosAlongSpan = openPos + closePercent * (closedPos - openPos);

                //   if (isXAxis) {
                //     panelObj.position.z = doorTargetPos.z + outsideDir * depthToRail + outsideDir * railOffset;
                //     panelObj.position.x = setOffset + panelPosAlongSpan;
                //   } else {
                //     panelObj.position.x = doorTargetPos.x + outsideDir * depthToRail + outsideDir * railOffset;
                //     panelObj.position.z = setOffset + panelPosAlongSpan;
                //   }
                // });

                setOffsets.forEach((setOffset) => {
                  const panelObj = panelTemplate.clone(true);
                  markClone(panelObj);
                  panelTemplate.parent.add(panelObj);

                  ensureVisible(panelObj);
                  applyPanelMorphs(panelObj);
                  applyDoorColor(panelObj);
                  const highestLetter = doorPanelLetters[doorPanelLetters.length - 1];
                  const isWinningPanel = l === highestLetter;

                  const updateDoorAccessoryVisibility = (root, isWinning) => {
                    root.traverse((node) => {
                      if (!node.name) return;

                      const isAccessoryGroup =
                        node.name.startsWith("sliding_door_accessories_x_") ||
                        node.name.startsWith("sliding_door_accessories_y_");

                      if (!isAccessoryGroup) return;

                      node.traverse((child) => {
                        if (!child.isMesh || !child.material) return;
                        const materials = Array.isArray(child.material) ? child.material : [child.material];
                        const isRubber = materials.some((mat) => mat && mat.name === "rubber");
                        child.visible = isRubber;
                      });
                    });
                  };

                  updateDoorAccessoryVisibility(panelObj, isWinningPanel);

                  const doorTargetPos = this.getSideTargetLocalPos(panelTemplate.parent, doorSide, doorOffsets);

                  panelObj.updateWorldMatrix(true, true);
                  const panelBox = new THREE.Box3().setFromObject(panelObj);
                  const panelGeoMin = isXAxis ? panelBox.min.x : panelBox.min.z;
                  const panelOriginPos = isXAxis ? panelObj.position.x : panelObj.position.z;

                  const baseOffset = panelGeoMin - panelOriginPos;
                  let panelLeftOffset;
                  const isMaxSpan = (spanPerSet === 6.0) && (state.roofType === 0) && (spanPerSet < 6.1);
                  const isOddDouble = isDouble && (Math.round(doorSpanSize) === 7 || Math.round(doorSpanSize) === 9);

                  if (isXAxis) {
                    switch (true) {
                      case isMaxSpan: {
                        const firstPanelExtra = -(0.02 + (doorPanelWidthMorph * 0.03));
                        const otherPanelExtra = -(0.06 + (doorPanelWidthMorph * 0.036));
                        panelLeftOffset = index === 0 ? baseOffset + firstPanelExtra : baseOffset + otherPanelExtra;
                        break;
                      }
                      case state.roofType === 1 && hasCentralPosts && state.width >= 6.5 && state.width <= 6.9: panelLeftOffset = baseOffset + 0.05; break;
                      case state.roofType === 1 && hasCentralPosts && state.width >= 5.3 && state.width <= 5.6: panelLeftOffset = baseOffset + 0.15; break;
                      case state.roofType === 1 && hasCentralPosts && state.width >= 5.1 && state.width <= 5.2: panelLeftOffset = baseOffset + 0.13; break;
                      case state.roofType === 1 && hasCentralPosts && state.width >= 5.7 && state.width <= 5.9: panelLeftOffset = baseOffset + 0.12; break;
                      case state.roofType === 1 && hasCentralPosts && state.width >= 4.1 && state.width <= 4.2: panelLeftOffset = baseOffset + 0.10; break;
                      case state.roofType === 1 && hasCentralPosts && state.width === 4.9: panelLeftOffset = baseOffset + 0.16; break;
                      case state.roofType === 1 && hasCentralPosts && state.width === 4.8: panelLeftOffset = baseOffset + 0.01; break;
                      case state.roofType === 1 && hasCentralPosts && state.width === 4.7: panelLeftOffset = baseOffset + 0.03; break;
                      case state.roofType === 1 && hasCentralPosts && state.width === 4.6: panelLeftOffset = baseOffset + 0.03; break;
                      case state.roofType === 1 && hasCentralPosts && state.width === 4.5: panelLeftOffset = baseOffset + 0.03; break;
                      case state.roofType === 1 && hasCentralPosts && state.width === 4.0: panelLeftOffset = baseOffset + 0.05; break;
                      case state.roofType === 1 && hasCentralPosts && state.width >= 3.0 && state.width <= 3.3: panelLeftOffset = baseOffset + 0.20; break;
                      case state.roofType === 1 && hasCentralPosts && state.width >= 3.4 && state.width <= 3.9: panelLeftOffset = baseOffset + 0.15; break;
                      case state.width >= 1.1 && state.width <= 1.2: panelLeftOffset = baseOffset; break;
                      case state.width === 1.6: panelLeftOffset = baseOffset + 0.14; break;
                      case state.width >= 1.7 && state.width <= 1.9: panelLeftOffset = baseOffset + 0.06; break;
                      case state.width === 2.2: panelLeftOffset = baseOffset + 0.05; break;
                      case state.width === 2.3: panelLeftOffset = baseOffset + 0.02; break;
                      case state.width === 2.4: panelLeftOffset = baseOffset - 0.005; break;
                      case state.width === 3.2: panelLeftOffset = baseOffset + 0.01; break;
                      case state.width === 4.3: panelLeftOffset = baseOffset + 0.01; break;
                      case state.width === 4.4: panelLeftOffset = baseOffset + 0.01; break;
                      case state.roofType === 0 && state.width === 3.3 || state.width === 3.4: panelLeftOffset = baseOffset + 0.02; break;
                      case state.roofType === 0 && state.width >= 2.5 && state.width <= 2.7: panelLeftOffset = baseOffset + 0.11; break;
                      case state.roofType === 0 && state.width >= 5.4 && state.width <= 5.9: panelLeftOffset = baseOffset - 0.01; break;
                      case state.roofType === 0 && state.width >= 6.1 && state.width <= 6.9: panelLeftOffset = baseOffset + 0.03; break;
                      case state.width >= 7.1 && state.width <= 7.5: panelLeftOffset = baseOffset + 0.11; break;
                      case state.width >= 7.6 && state.width <= 7.9: panelLeftOffset = baseOffset + 0.09; break;
                      case state.width >= 8.3 && state.width <= 8.6: panelLeftOffset = baseOffset + 0.010; break;
                      case state.width >= 8.7 && state.width <= 8.9: panelLeftOffset = 1.1 * baseOffset; break;
                      case state.width >= 9.2 && state.width <= 9.6: panelLeftOffset = baseOffset + 0.06; break;
                      case state.width >= 9.7 && state.width <= 9.9: panelLeftOffset = baseOffset + 0.045; break;
                      case isOddDouble:
                        panelLeftOffset = Math.round(doorSpanSize) === 7 ? baseOffset + 0.15 : baseOffset + 0.095;
                        break;
                      case state.width >= 10.1 && state.width <= 10.3: panelLeftOffset = baseOffset + 0.03; break;
                      case state.width >= 10.4 && state.width <= 10.6: panelLeftOffset = baseOffset - 0.0005; break;
                      case state.width >= 10.7 && state.width <= 10.9: panelLeftOffset = baseOffset - 0.01; break;
                      case Math.round(doorSpanSize) === 10: panelLeftOffset = baseOffset + 0.04; break;
                      case state.width >= 11.0 && state.width <= 12.0: {
                        const t = state.width - 11.0;
                        panelLeftOffset = baseOffset + (0.01 + t * t * t * 0.010);
                        break;
                      }
                      default: panelLeftOffset = baseOffset + 0.07;
                    }
                  } else {
                    switch (true) {
                      case state.length === 1.0: panelLeftOffset = baseOffset - 0.03; break;
                      case state.length >= 1.1 && state.length <= 1.2: panelLeftOffset = baseOffset + 0.07; break;
                      case state.length === 1.0: panelLeftOffset = baseOffset + 0.04; break;
                      case state.length === 1.6: panelLeftOffset = baseOffset + 0.10; break;
                      case state.length >= 1.7 && state.length <= 1.9: panelLeftOffset = baseOffset + 0.06; break;
                      case state.length === 2.0: panelLeftOffset = baseOffset + 0.05; break;
                      case state.length === 2.3: panelLeftOffset = baseOffset + 0.05; break;
                      case state.length === 2.4: panelLeftOffset = baseOffset + 0.02; break;
                      case state.length === 2.5: panelLeftOffset = baseOffset + 0.05; break;
                      case state.length >= 2.6 && state.length <= 2.8: panelLeftOffset = baseOffset + 0.02; break;
                      case state.length === 2.9: panelLeftOffset = baseOffset + 0.10; break;
                      case state.length >= 3.2 && state.length <= 3.4: panelLeftOffset = baseOffset + 0.02; break;
                      case state.length >= 3.5 && state.length <= 3.8: panelLeftOffset = baseOffset + 0.08; break;
                      case state.length === 3.9: panelLeftOffset = baseOffset + 0.02; break;
                      case state.length >= 4.0 && state.length <= 4.1: panelLeftOffset = baseOffset + 0.08; break;
                      case state.length === 4.2: panelLeftOffset = baseOffset + 0.03; break;
                      case state.length >= 4.3 && state.length <= 4.4: panelLeftOffset = baseOffset + 0.08; break;
                      case state.length >= 4.5 && state.length <= 4.9: panelLeftOffset = baseOffset - 0.03; break;
                      case state.length === 5: panelLeftOffset = baseOffset - 0.01; break;
                      case state.roofType === 1 && state.length === 2: panelLeftOffset = baseOffset + 0.033; break;
                      default: panelLeftOffset = baseOffset + 0.08;
                    }
                  }

                  const frameLeftEdge = -(spanPerSet / 2);
                  const openPos = frameLeftEdge - panelLeftOffset;
                  const closedPos = doorPanelLetters.length === 1
                    ? -(panelWidth / 2) - baseOffset
                    : frameLeftEdge + (index * panelWidth) - panelLeftOffset;
                  const closePercent = state.slidingDoorInput / 100;
                  const panelPosAlongSpan = openPos + closePercent * (closedPos - openPos);

                  if (isXAxis) {
                    panelObj.position.z = doorTargetPos.z + outsideDir * depthToRail + outsideDir * railOffset;
                    panelObj.position.x = setOffset + panelPosAlongSpan;
                    if ((state.width >= 1.0) && (state.width <= 1.9)) {
                      panelObj.position.z += doorSide === pergolaConst.side.Front ? -inset : inset;
                      panelObj.position.x = setOffset + panelPosAlongSpan - 0.07;
                    } else if (state.roofType === 1 && state.width === 5) {
                      panelObj.position.x = setOffset + panelPosAlongSpan - 0.07;
                    }
                  } else {
                    panelObj.position.x = doorTargetPos.x + outsideDir * depthToRail + outsideDir * railOffset;
                    panelObj.position.z = setOffset + panelPosAlongSpan;
                    if ((state.length >= 1.0) && (state.width <= 1.9)) {
                      panelObj.position.x += doorSide === pergolaConst.side.Right ? -inset : inset;
                    } else if (state.length === 5) {
                      panelObj.position.z = setOffset + panelPosAlongSpan;
                    }
                    switch (true) {
                      case state.length === 1.0: panelObj.position.z -= 0.2; break;
                      case state.length >= 1.1 && state.length <= 1.2: panelObj.position.z -= 0.08; break;
                      case state.length >= 1.3 && state.length <= 1.8: panelObj.position.z -= 0.09; break;
                      case state.length >= 2.0 && state.length <= 2.4: panelObj.position.z += 0.02; break;
                      case state.length >= 2.5 && state.length <= 2.8: panelObj.position.z -= 0.07; break;
                      case state.length === 3.3: panelObj.position.z += 0.005; break;
                      case state.length >= 3.5 && state.length <= 3.9: panelObj.position.z -= 0.055; break;
                      case state.length >= 4.3 && state.length <= 4.4: panelObj.position.z += 0.03; break;
                      case state.length >= 4.5 && state.length <= 4.9: panelObj.position.z -= 0.12; break;
                      case state.length === 5.0: panelObj.position.z -= 0.02; break;
                    }
                  }
                  theModel.attach(panelObj);
                });
              });
              break;

            case pergolaConst.systemType.privacyWall:
              const shutterSide = span.side;
              this.cleanOtherSystemsOnSide(shutterSide, pergolaConst.systemType.privacyWall);
              const isShutterXAxis = (shutterSide === pergolaConst.side.Front || shutterSide === pergolaConst.side.Back);
              const shutterSuffix = isShutterXAxis ? '_x' : '_y';
              const shutterSpanSize = isShutterXAxis ? state.width : state.length;

              // const shutterHalfWidth = state.width / 2;
              // const shutterHalfLength = state.length / 2;

              // // Position on side edge
              // let shutterTargetPos = { x: 0, z: 0 };
              // switch (shutterSide) {
              //   case pergolaConst.side.Front:
              //     shutterTargetPos.z = shutterHalfLength - 0.075;
              //     break;
              //   case pergolaConst.side.Back:
              //     shutterTargetPos.z = -(shutterHalfLength - 0.06);
              //     break;
              //   case pergolaConst.side.Left:
              //     shutterTargetPos.x = -(shutterHalfWidth - 0.07);
              //     break;
              //   case pergolaConst.side.Right:
              //     shutterTargetPos.x = shutterHalfWidth - 0.08;
              //     break;
              // }

              const shutterOffsets = {
                front: 0.076,
                back: 0.06,
                left: 0.07,
                right: 0.08
              };

              const ensureShutterVisible = (o) => {
                o.visible = true;
                o.traverse(ch => { ch.visible = true; });
              };

              const markShutterClone = (o) => {
                o.userData = o.userData || {};
                o.userData.clonedShutter = true;
                o.userData.shutterSide = shutterSide;
              };

              const isChildOfShutterClone = (obj) => {
                let parent = obj.parent;
                while (parent) {
                  if (parent.userData?.clonedShutter) return true;
                  parent = parent.parent;
                }
                return false;
              };

              const oldShutterClones = [];
              scene.traverse((o) => {
                if (isChildOfShutterClone(o)) return;

                if (
                  (o.name.startsWith('top_hung_sliding_track_') || o.name.startsWith('top_hung_panel_')) &&
                  o.name.includes(shutterSuffix)
                ) {
                  if (!o.userData?.clonedShutter) {
                    o.visible = false;
                    o.traverse(child => { child.visible = false; });
                  } else if (o.userData?.shutterSide === shutterSide) {
                    oldShutterClones.push(o);
                  }
                }
              });
              oldShutterClones.forEach(c => c.parent?.remove(c));

              // --- Color ---
              const applyShutterColor = (obj) => {
                obj.traverse(child => {
                  if (child.isMesh) {
                    if (Array.isArray(child.material)) {
                      child.material = child.material.map(mat => {
                        if (mat.name === 'powder_coat') {
                          const cloned = mat.clone();
                          cloned.color.set(state.colorShutters);
                          return cloned;
                        }
                        return mat;
                      });
                    } else if (child.material.name === 'powder_coat') {
                      child.material = child.material.clone();
                      child.material.color.set(state.colorShutters);
                    }
                  }
                });
              };

              const trackName = `top_hung_sliding_track${shutterSuffix}`;
              let trackTemplate = null;
              scene.traverse((o) => {
                if (!isChildOfShutterClone(o) && o.name === trackName && !o.userData?.clonedShutter) trackTemplate = o;
              });

              const shutterPanelName = `top_hung_panel${shutterSuffix}`;
              let shutterPanelTemplate = null;
              scene.traverse((o) => {
                if (!isChildOfShutterClone(o) && o.name === shutterPanelName && !o.userData?.clonedShutter) shutterPanelTemplate = o;
              });

              if (!trackTemplate && !shutterPanelTemplate) break;

              const numPanels = shutterSpanSize <= 1 ? 1 : shutterSpanSize === 10 ? 10 : Math.max(2, Math.ceil(shutterSpanSize / 1.2));
              const shutterRailStep = 0.004;

              const shutterHasCentralPosts = state.roofType === 1 && (state.width >= 5.0 || state.length >= 4.0);
              let maxShutterSingleSpan;
              if (state.roofType === 1) {
                // With central posts: Front/Back doubles from width >= 2.0; without: from width >= 5
                maxShutterSingleSpan = isShutterXAxis ? (shutterHasCentralPosts ? 1.9 : 10) : 10;
              } else {
                maxShutterSingleSpan = 10;
              }
              const isShutterDouble = shutterSpanSize > maxShutterSingleSpan;

              const shutterSpanPerSet = isShutterDouble ? (shutterSpanSize / 2) : shutterSpanSize;

              const trackSpanForMorph = (isShutterDouble && state.roofType === 1)
                ? shutterSpanPerSet - 0.05
                : shutterSpanPerSet;

              const shutterFrameWidthMorph = (() => {
                if (isShutterXAxis && state.roofType === 0 && state.width >= 10 && state.width <= 12)
                  return getShutterFrameWidthMorph(trackSpanForMorph - 0.05);
                if (isShutterXAxis && state.roofType === 1 && shutterHasCentralPosts) {
                  const _fwCP29 = shutterSpanSize >= 2.5 && shutterSpanSize <= 2.6;
                  const _fwCP29Offset = 0.08 + ((shutterSpanSize - 2.5) / 0.4) * 0.05;
                  if (_fwCP29) return getShutterFrameWidthMorph(shutterSpanPerSet + _fwCP29Offset);
                  if (shutterSpanSize >= 3.0) return getShutterFrameWidthMorph(shutterSpanPerSet + 0.15);
                  // 2.0–2.4 and 2.7–2.9: growing offset from 0 at 2.0 toward 0.12 at 2.9
                  const _fwGrow = (shutterSpanSize - 2.0) * 0.13;
                  return getShutterFrameWidthMorph(shutterSpanPerSet + _fwGrow);
                }
                return getShutterFrameWidthMorph(trackSpanForMorph - 0.15);
              })();

              const numPanelsPerSet = isShutterDouble
                ? Math.max(2, Math.ceil(shutterSpanPerSet / 1.2))
                : numPanels;
              const _isSmallLengthSide = !isShutterXAxis && (
                state.length === 2.1 || state.length === 2.2 ||
                state.length === 2.6 || state.length === 2.7 || state.length === 2.8
              );
              const shutterPanelWidthPerSet = shutterSpanSize <= 1 ? 0.8
                : (shutterSpanSize >= 1.1 && shutterSpanSize <= 1.9) ? (shutterSpanPerSet / numPanelsPerSet) * 0.95
                  : shutterSpanSize === 2 ? (shutterSpanPerSet / numPanelsPerSet) * 0.915
                    : _isSmallLengthSide ? (shutterSpanPerSet / numPanelsPerSet) * 0.95
                      : (shutterSpanSize === 2.3 || shutterSpanSize === 2.4) ? (shutterSpanPerSet / numPanelsPerSet) * 0.95
                        : shutterSpanSize === 2.5 ? (shutterSpanPerSet / numPanelsPerSet) * 0.97
                          : (shutterSpanSize >= 8.9 && shutterSpanSize <= 9.9) ? (shutterSpanPerSet / numPanelsPerSet) * 1.01
                            : shutterSpanSize === 10 ? 1.0
                              : (state.roofType === 1 && shutterHasCentralPosts && (shutterSpanSize === 3.3 || shutterSpanSize === 3.4 || shutterSpanSize === 3.5))
                                ? (shutterSpanPerSet / numPanelsPerSet) * 0.96
                                : (isShutterXAxis && (state.roofType === 0 || (state.roofType === 1 && !shutterHasCentralPosts)) && state.width >= 4.6 && state.width <= 4.9)
                                  ? (shutterSpanPerSet / numPanelsPerSet) * 1.01
                                  : (isShutterXAxis && state.roofType === 0 && state.width >= 5.0 && state.width <= 8.9)
                                    ? (shutterSpanPerSet / numPanelsPerSet) * 1.005
                                    : (isShutterXAxis && state.roofType === 0 && state.width > 10.0 && state.width <= 12.0)
                                      ? (shutterSpanPerSet / numPanelsPerSet) * 1.005
                                      : (!isShutterXAxis && shutterSpanSize > 4.9)
                                        ? (shutterSpanPerSet / numPanelsPerSet) * 0.975
                                        : (!isShutterXAxis && state.roofType === 0 && shutterSpanSize > 3.8)
                                          ? (shutterSpanPerSet / numPanelsPerSet)
                                          : (state.roofType === 0 || (state.roofType === 1 && !shutterHasCentralPosts))
                                            ? (shutterSpanPerSet / numPanelsPerSet) * 0.97
                                            : (shutterSpanPerSet / numPanelsPerSet);

              const shutterTrackHeightMorph = getShutterTrackHeightMorph(state.height);
              const shutterPanelHeightMorph = getShutterTrackHeightMorph(state.height);
              const _shutterMorphWidth = (shutterSpanSize >= 10.5 && shutterSpanSize <= 12.0)
                ? shutterPanelWidthPerSet * 1.03
                : shutterPanelWidthPerSet;
              const shutterPanelWidthMorph = getShutterPanelWidthMorph(_shutterMorphWidth);

              const applyShutterTrackMorphs = (obj) => {
                obj.traverse(child => {
                  if (child.isMesh && child.morphTargetDictionary && child.morphTargetInfluences) {
                    const h = child.morphTargetDictionary['height'];
                    if (h !== undefined) child.morphTargetInfluences[h] = shutterTrackHeightMorph;
                    const w = child.morphTargetDictionary['width'];
                    if (w !== undefined) child.morphTargetInfluences[w] = shutterFrameWidthMorph;
                    const l = child.morphTargetDictionary['lenth'];
                    if (l !== undefined) child.morphTargetInfluences[l] = shutterFrameWidthMorph;
                  }
                });
              };

              const applyShutterPanelMorphs = (obj) => {
                obj.traverse(child => {
                  if (child.isMesh && child.morphTargetDictionary && child.morphTargetInfluences) {
                    const h = child.morphTargetDictionary['height'];
                    if (h !== undefined) child.morphTargetInfluences[h] = shutterPanelHeightMorph;
                    const w = child.morphTargetDictionary['width'];
                    if (w !== undefined) child.morphTargetInfluences[w] = shutterPanelWidthMorph;
                    const l = child.morphTargetDictionary['lenth'];
                    if (l !== undefined) child.morphTargetInfluences[l] = shutterPanelWidthMorph;
                  }
                });
              };

              const shutterInward = (() => {
                switch (shutterSide) {
                  case pergolaConst.side.Front: return -1;
                  case pergolaConst.side.Back: return -1;
                  case pergolaConst.side.Left: return -1;
                  case pergolaConst.side.Right: return +1;
                  default: return -1;
                }
              })();
              const shutterOutsideDir = -shutterInward;

              let shutterDepthToRail;
              switch (shutterSide) {
                case pergolaConst.side.Front:
                  shutterDepthToRail = -(numPanelsPerSet * shutterRailStep) + 0.02;
                  break;
                case pergolaConst.side.Back:
                  shutterDepthToRail = -((numPanelsPerSet * shutterRailStep) - 0.04);
                  break;
                case pergolaConst.side.Left:
                  shutterDepthToRail = -(numPanelsPerSet * shutterRailStep) + 0.08;
                  break;
                case pergolaConst.side.Right:
                  shutterDepthToRail = -(numPanelsPerSet * shutterRailStep) - 0.04;
                  break;
              }

              //single or double
              let shutterSetOffsets = isShutterDouble ? [-shutterSpanSize / 4, shutterSpanSize / 4] : [0];

              if (trackTemplate && isShutterDouble) {
                const tempTrack = trackTemplate.clone(true);
                applyShutterTrackMorphs(tempTrack);
                tempTrack.updateWorldMatrix(true, true);
                const tempBox = new THREE.Box3().setFromObject(tempTrack);
                const trackGeoWidth = isShutterXAxis
                  ? (tempBox.max.x - tempBox.min.x)
                  : (tempBox.max.z - tempBox.min.z);

                let divisor;
                const w = Math.floor(shutterSpanSize);

                if (isShutterXAxis && state.roofType === 1 && shutterHasCentralPosts) {
                  const _interpDivCP = (map, defaultVal, val) => {
                    const keys = Object.keys(map).map(Number).sort((a, b) => a - b);
                    if (!keys.length) return defaultVal;
                    if (val <= keys[0]) return map[keys[0]];
                    if (val >= keys[keys.length - 1]) return map[keys[keys.length - 1]];
                    if (map[val] !== undefined) return map[val];
                    for (let i = 0; i < keys.length - 1; i++) {
                      if (val >= keys[i] && val <= keys[i + 1]) {
                        const t = (val - keys[i]) / (keys[i + 1] - keys[i]);
                        return map[keys[i]] + t * (map[keys[i + 1]] - map[keys[i]]);
                      }
                    }
                    return defaultVal;
                  };
                  divisor = _interpDivCP(
                    { 2: 20.0, 3: 15.0, 4: 10.0, 5: 7.85, 6: 7.0, 7: 6.0, 8: 5.3 },
                    7.0,
                    shutterSpanSize
                  );
                  if (shutterSpanSize >= 3.3 && shutterSpanSize <= 6.0) {
                    const _t = shutterSpanSize <= 3.6
                      ? (shutterSpanSize - 3.3) / 0.2
                      : shutterSpanSize >= 4.7
                        ? (6.0 - shutterSpanSize) / 1.3
                        : 1.0;
                    divisor += 1.5 * _t;
                  }
                } else if (isShutterXAxis && (state.roofType === 0 || (state.roofType === 1 && !shutterHasCentralPosts))) {
                  switch (w) {
                    case 10: divisor = 3.9; break;
                    case 11: divisor = 3.75; break;
                    case 12: divisor = 3.4; break;
                    default: divisor = 3.8; break;
                  }
                  if (shutterSpanSize > 10 && shutterSpanSize <= 10.5) {
                    divisor += 0.17 * Math.pow(11 - shutterSpanSize, 2);
                  } else if (shutterSpanSize > 10.5 && shutterSpanSize < 11.0) {
                    divisor -= 0.40 * (shutterSpanSize - 10.5);
                  } else if (shutterSpanSize > 11.1 && shutterSpanSize < 12.0) {
                    divisor -= 0.43 * (shutterSpanSize - 11.1);
                  }
                } else {
                  // !isShutterXAxis double spans — interpDivisor approach
                  const _interpDivShutter = (map, defaultVal, val) => {
                    const keys = Object.keys(map).map(Number).sort((a, b) => a - b);
                    if (!keys.length) return defaultVal;
                    if (val <= keys[0]) return map[keys[0]];
                    if (val >= keys[keys.length - 1]) return map[keys[keys.length - 1]];
                    if (map[val] !== undefined) return map[val];
                    for (let i = 0; i < keys.length - 1; i++) {
                      if (val >= keys[i] && val <= keys[i + 1]) {
                        const t = (val - keys[i]) / (keys[i + 1] - keys[i]);
                        return map[keys[i]] + t * (map[keys[i + 1]] - map[keys[i]]);
                      }
                    }
                    return defaultVal;
                  };
                  divisor = _interpDivShutter({ 10: 3.99, 11: 3.729, 12: 3.413 }, 3.5, shutterSpanSize);
                  if (shutterSpanSize > 10 && shutterSpanSize < 11) {
                    divisor -= 0.1 * (shutterSpanSize - 10);
                  }
                }

                const trackHalfGeo = trackGeoWidth / divisor;
                shutterSetOffsets[0] = -trackHalfGeo;
                shutterSetOffsets[1] = trackHalfGeo;
              }

              // tracks
              if (trackTemplate) {
                const shutterTargetPos = this.getSideTargetLocalPos(trackTemplate.parent, shutterSide, shutterOffsets);
                shutterSetOffsets.forEach((setOffset) => {
                  const trackObj = trackTemplate.clone(true);
                  markShutterClone(trackObj);
                  trackTemplate.parent.add(trackObj);

                  ensureShutterVisible(trackObj);
                  applyShutterTrackMorphs(trackObj);
                  applyShutterColor(trackObj);

                  trackObj.traverse(child => {
                    if (child !== trackObj && child.name !== trackObj.name) {
                      child.visible = false;
                    }
                  });

                  if (isShutterXAxis) {
                    trackObj.position.z = shutterTargetPos.z;
                    trackObj.position.x = setOffset - 0.005;
                  } else {
                    //for right side:
                    if (shutterSide === pergolaConst.side.Right) {
                      trackObj.position.x = shutterTargetPos.x + 0.03;
                      trackObj.position.z = setOffset - 0.005;
                    } else {
                      trackObj.position.x = shutterTargetPos.x + 0.02;
                      trackObj.position.z = setOffset + 0.005;
                    }
                  }

                  if (shutterSpanSize <= 1) {
                    const inset = 0.075;
                    if (isShutterXAxis) {
                      trackObj.position.z += shutterSide === pergolaConst.side.Front ? -inset / 1.5 : inset / 1.5;
                    } else {
                      trackObj.position.x += shutterSide === pergolaConst.side.Right ? -inset / 1.2 : inset / 4;
                    }
                  }

                  theModel.attach(trackObj);
                });
              }

              // Clone panels
              if (shutterPanelTemplate) {
                const shutterClosePercent = Math.min(state.slidingShuttersInput / 100, 0.97);
                const shutterParent = trackTemplate ? trackTemplate.parent : shutterPanelTemplate.parent.parent;
                const shutterTargetPos = this.getSideTargetLocalPos(shutterParent, shutterSide, shutterOffsets);

                // louvers
                const louverName = `louvre${shutterSuffix}`;
                let louverTemplate = null;
                scene.traverse((o) => {
                  if (!isChildOfShutterClone(o) && o.name === louverName && !o.userData?.clonedShutter) louverTemplate = o;
                });

                if (louverTemplate) {
                  louverTemplate.visible = false;
                  louverTemplate.traverse(ch => { ch.visible = false; });
                }

                for (let index = 0; index < numPanelsPerSet; index++) {
                  const railOffset = index * shutterRailStep;

                  shutterSetOffsets.forEach((setOffset) => {
                    const panelObj = shutterPanelTemplate.clone(true);
                    markShutterClone(panelObj);
                    shutterParent.add(panelObj);

                    ensureShutterVisible(panelObj);

                    panelObj.traverse(child => {
                      if (child.name.includes('top_hung_mullion')) {
                        child.visible = false;
                      }
                    });

                    applyShutterPanelMorphs(panelObj);
                    applyShutterColor(panelObj);

                    const shutterFrameLeftEdge = -(shutterSpanPerSet / 2);

                    panelObj.updateWorldMatrix(true, true);
                    const panelBox = new THREE.Box3().setFromObject(panelObj);
                    const panelGeoMin = isShutterXAxis ? panelBox.min.x : panelBox.min.z;
                    const panelOriginPos = isShutterXAxis ? panelObj.position.x : panelObj.position.z;
                    const baseOffset = panelGeoMin - panelOriginPos;
                    let panelLeftOffset;
                    const interpOffset = (map, defaultVal, val) => {
                      const keys = Object.keys(map).map(Number).sort((a, b) => a - b);
                      if (!keys.length) return defaultVal;
                      if (val <= keys[0]) return map[keys[0]];
                      if (val >= keys[keys.length - 1]) return map[keys[keys.length - 1]];
                      if (map[val] !== undefined) return map[val];
                      for (let i = 0; i < keys.length - 1; i++) {
                        if (val >= keys[i] && val <= keys[i + 1]) {
                          const t = (val - keys[i]) / (keys[i + 1] - keys[i]);
                          return map[keys[i]] + t * (map[keys[i + 1]] - map[keys[i]]);
                        }
                      }
                      return defaultVal;
                    };

                    if (isShutterXAxis) {
                      if (isShutterDouble && state.roofType === 1 && shutterHasCentralPosts) {
                        const _cpOffsetLeft = interpOffset(
                          { 2: 0.48, 2.1: 0.49, 2.3: 0.49, 2.4: 0.41, 2.5: 0.4, 2.6: 0.4, 2.7: 0.4, 2.8: 0.365, 2.9: 0.36, 3: 0.35, 3.1: 0.335, 3.2: 0.318, 3.3: 0.37, 3.4: 0.4, 3.5: 0.42, 3.6: 0.42, 3.8: 0.40, 3.9: 0.38, 4.0: 0.36, 4.1: 0.35, 4.2: 0.34, 4.3: 0.33, 4.6: 0.32, 4.7: 0.30, 4.7: 0.29, 4.9: 0.44, 5.0: 0.43, 5.1: 0.42, 5.3: 0.40, 5.5: 0.38, 5.8: 0.36, 5.9: 0.34, 6.0: 0.32, 6.1: 0.30, 6.4: 0.29, 6.5: 0.28, 6.6: 0.27, 6.7: 0.25, 7.0: 0.23, },
                          0.2,
                          state.width
                        );
                        if (state.width >= 3.3 && setOffset > 0) {
                          // Right set:
                          panelLeftOffset = baseOffset + interpOffset(
                            { 3.3: 0.26, 3.4: 0.20, 3.5: 0.15, 3.8: 0.14, 3.9: 0.15, 4: 0.15, 4.2: 0.13, 4.3: 0.11, 4.4: 0.09, 4.5: 0.06, 4.6: 0.04, 4.7: 0.02, 4.8: 0.00, 4.9: 0.20, 5: 0.22, 5.9: 0.14, 6: 0.14, 6.2: 0.12, 6.3: 0.11, 6.4: 0.10, 6.4: 0.09, 6.8: 0.07, 6.8: 0.06 },
                            0.12,
                            state.width
                          );
                        } else {
                          panelLeftOffset = baseOffset + _cpOffsetLeft;
                        }
                      } else if ((state.roofType === 0) || (state.roofType === 1 && !shutterHasCentralPosts)) {
                        panelLeftOffset = baseOffset + interpOffset(
                          { 1.0: 0.20, 1.1: 0.40, 1.5: 0.38, 1.7: 0.28, 1.8: 0.25, 2: 0.20, 2.3: 0.16, 2.4: 0.12, 2.5: 0.27, 3.1: 0.19, 3.3: 0.17, 3.3: 0.13, 3.5: 0.12, 3.6: 0.10, 3.7: 0.20, 4: 0.16, 4.2: 0.14, 4.3: 0.12, 4.4: 0.11, 4.5: 0.095, 4.6: 0.13, 4.7: 0.12, 4.8: 0.13, 4.9: 0.20, 5: 0.18, 6: 0.1, 6.1: 0.2, 7: 0.1, 7.1: 0.04, 7.3: 0.15, 8: 0.08, 8.1: 0.06, 8.2: 0.08, 8.3: 0.08, 8.4: 0.12, 8.8: 0.08, 9.4: 0.08, 9.7: 0.12, 10: 0.12, 10.1: 0.19, 10.3: 0.195, 11: 0.14, 11.4: 0.125, 12: 0.075 },
                          0.2,
                          state.width
                        );
                        // } else {
                        //   // roofType === 1, single span (width ≤ 4)
                        //   switch (true) {
                        //     case state.width === 1.0:                              panelLeftOffset = baseOffset + 0.18; break;
                        //     case state.width >= 1.1 && state.width <= 1.2:        panelLeftOffset = baseOffset + 0.72; break;
                        //     case state.width >= 1.3 && state.width <= 1.5:        panelLeftOffset = baseOffset + 0.20; break;
                        //     case state.width === 1.6:                              panelLeftOffset = baseOffset + 0.28; break;
                        //     case state.width >= 1.7 && state.width <= 1.9:        panelLeftOffset = baseOffset + 0.22; break;
                        //     case state.width === 2.0:                              panelLeftOffset = baseOffset + 0.20; break;
                        //     case state.width >= 2.1 && state.width <= 2.2:        panelLeftOffset = baseOffset + 0.22; break;
                        //     case state.width === 2.3:                              panelLeftOffset = baseOffset + 0.20; break;
                        //     case state.width === 2.4:                              panelLeftOffset = baseOffset + 0.18; break;
                        //     case state.width >= 2.5 && state.width <= 2.8:        panelLeftOffset = baseOffset + 0.20; break;
                        //     case state.width === 2.9:                              panelLeftOffset = baseOffset + 0.26; break;
                        //     case state.width >= 3.0 && state.width <= 3.2:        panelLeftOffset = baseOffset + 0.26; break;
                        //     case state.width === 3.3:                              panelLeftOffset = baseOffset + 0.14; break;
                        //     case state.width >= 3.4 && state.width <= 4.0:        panelLeftOffset = baseOffset + 0.24; break;
                        //     default:                                               panelLeftOffset = baseOffset + 0.20;
                        //   }
                      }
                    } else {
                      panelLeftOffset = baseOffset + interpOffset(
                        { 1.0: 0.30, 1.1: 0.50, 1.7: 0.35, 2: 0.25, 2.3: 0.16, 2.4: 0.12, 2.5: 0.32, 3.4: 0.20, 3.5: 0.18, 3.6: 0.16, 3.7: 0.26, 4: 0.25, 4.7: 0.2, 4.8: 0.2, 4.9: 0.25, 5: 0.19, },
                        0.2,
                        state.length
                      );
                      // } else if (state.roofType === 1) {
                      // switch (true) {
                      //   case state.length === 1.0:                              panelLeftOffset = baseOffset + 0.28; break;
                      //   case state.length >= 1.1 && state.length <= 1.2:       panelLeftOffset = baseOffset + 0.02; break;
                      //   case state.length >= 1.3 && state.length <= 1.5:       panelLeftOffset = baseOffset + 0.30; break;
                      //   case state.length === 1.6:                              panelLeftOffset = baseOffset + 0.38; break;
                      //   case state.length >= 1.7 && state.length <= 1.9:       panelLeftOffset = baseOffset + 0.32; break;
                      //   case state.length === 2.0:                              panelLeftOffset = baseOffset + 0.30; break;
                      //   case state.length >= 2.1 && state.length <= 2.2:       panelLeftOffset = baseOffset + 0.32; break;
                      //   case state.length === 2.3:                              panelLeftOffset = baseOffset + 0.30; break;
                      //   case state.length === 2.4:                              panelLeftOffset = baseOffset + 0.28; break;
                      //   case state.length === 2.5:                              panelLeftOffset = baseOffset + 0.30; break;
                      //   case state.length >= 2.6 && state.length <= 2.8:       panelLeftOffset = baseOffset + 0.28; break;
                      //   case state.length === 2.9:                              panelLeftOffset = baseOffset + 0.36; break;
                      //   case state.length >= 3.0 && state.length <= 3.2:       panelLeftOffset = baseOffset + 0.36; break;
                      //   case state.length === 3.3:                              panelLeftOffset = baseOffset + 0.24; break;
                      //   case state.length >= 3.4 && state.length <= 4.4:       panelLeftOffset = baseOffset + 0.34; break;
                      //   case state.length >= 4.5 && state.length <= 4.9:       panelLeftOffset = baseOffset + 0.24; break;
                      //   case state.length === 5.0:                              panelLeftOffset = baseOffset + 0.30; break;
                      //   default:                                                panelLeftOffset = baseOffset + 0.30;
                      // }
                    }

                    const openPos = shutterFrameLeftEdge - panelLeftOffset;
                    const closedPos = numPanels === 1
                      ? -(shutterPanelWidthPerSet / 2) - baseOffset
                      : shutterFrameLeftEdge + (index * shutterPanelWidthPerSet) - panelLeftOffset;
                    const panelPosAlongSpan = openPos + shutterClosePercent * (closedPos - openPos);

                    if (isShutterXAxis) {
                      panelObj.position.z = shutterTargetPos.z + shutterOutsideDir * shutterDepthToRail + shutterOutsideDir * railOffset;
                      panelObj.position.x = setOffset + panelPosAlongSpan;
                    } else {
                      panelObj.position.x = shutterTargetPos.x + shutterOutsideDir * shutterOutsideDir * railOffset;
                      panelObj.position.z = setOffset + panelPosAlongSpan + 0.05;
                    }

                    if (shutterSpanSize <= 1) {
                      const inset = 0.07;
                      if (isShutterXAxis) {
                        panelObj.position.z += shutterSide === pergolaConst.side.Front ? -inset / 1.5 : inset / 1.5;
                        panelObj.position.x -= setOffset === pergolaConst.side.Front ? 2 * inset : 2 * inset;
                      } else {
                        panelObj.position.x += shutterSide === pergolaConst.side.Right ? -inset / 1.2 : inset / 2;
                        panelObj.position.z -= shutterSide === pergolaConst.side.Right ? 1.5 * inset : 1.5 * inset;
                      }
                    }

                    //  louvers to panel
                    if (louverTemplate) {
                      const louverWidthMorph = shutterPanelWidthMorph;
                      const louverHeight = 0.11;
                      const bottomCount = 6;
                      let topCount;
                      const roundedHeight = Math.round(state.height * 2) / 2;
                      switch (roundedHeight) {
                        case 1.0: topCount = 2; break;
                        case 1.5: topCount = 7; break;
                        case 2.0: topCount = 12; break;
                        case 2.5: topCount = 13; break;
                        case 3.0: topCount = 16; break;
                        case 3.5: topCount = 16; break;
                        default: topCount = Math.max(0, Math.round((state.height - 1.0) * 8)); break;
                      }
                      const bottomStart = 0.18;
                      const transomGap = 0.20;

                      // Bottom section:
                      const topStart = bottomStart + (bottomCount * louverHeight) + transomGap;

                      const totalLouvers = bottomCount + topCount;

                      for (let li = 0; li < totalLouvers; li++) {
                        const louver = louverTemplate.clone(true);
                        louver.userData = louver.userData || {};
                        louver.userData.clonedShutter = true;
                        louver.userData.shutterSide = shutterSide;

                        louver.visible = true;
                        louver.traverse(ch => {
                          ch.visible = true;
                          if (ch.isMesh && ch.morphTargetDictionary && ch.morphTargetInfluences) {
                            const w = ch.morphTargetDictionary['width'];
                            if (w !== undefined) ch.morphTargetInfluences[w] = louverWidthMorph;
                          }
                        });

                        //applyShutterColor(louver);

                        louver.position.set(0, 0, 0);
                        louver.rotation.set(0, 0, 0);
                        louver.position.y = li < bottomCount
                          ? bottomStart + (li * louverHeight)
                          : topStart + ((li - bottomCount) * louverHeight);

                        if (shutterSide === pergolaConst.side.Right) {
                          louver.rotation.set(0, Math.PI, 0);
                        } else if (shutterSide === pergolaConst.side.Back) {
                          louver.rotation.set(0, Math.PI, 0);
                        }

                        if (isShutterXAxis) {
                          // Front/Back — shift along X
                          louver.position.x = (shutterSide === pergolaConst.side.Front) ? 0.25 : 0.25;
                          louver.position.z = (shutterSide === pergolaConst.side.Front) ? 0.00 : -0.05;
                        } else {
                          // Left/Right — shift along Z
                          louver.position.z = (shutterSide === pergolaConst.side.Left) ? 0.25 : 0.25;
                          louver.position.x = (shutterSide === pergolaConst.side.Left) ? -0.03 : 0.03;
                        }

                        panelObj.add(louver);
                      }
                    }

                    theModel.attach(panelObj);
                  });
                }
              }

              break;

            case pergolaConst.systemType.autoShade:
              const shadeSide = span.side;
              this.cleanOtherSystemsOnSide(shadeSide, pergolaConst.systemType.autoShade);
              const isShadeXAxis = (shadeSide === pergolaConst.side.Front || shadeSide === pergolaConst.side.Back);
              const shadeSuffix = isShadeXAxis ? '_x' : '_y';
              const shadeSpanSize = isShadeXAxis ? state.width : state.length;

              // const shadeHalfWidth = state.width / 2;
              // const shadeHalfLength = state.length / 2;

              // let shadeTargetPos = { x: 0, z: 0 };
              // switch (shadeSide) {
              //   case pergolaConst.side.Front:
              //     shadeTargetPos.z = shadeHalfLength + 0.01;
              //     break;
              //   case pergolaConst.side.Back:
              //     shadeTargetPos.z = -(shadeHalfLength + 0.01);
              //     break;
              //   case pergolaConst.side.Left:
              //     shadeTargetPos.x = -(shadeHalfWidth + 0.01);
              //     break;
              //   case pergolaConst.side.Right:
              //     shadeTargetPos.x = shadeHalfWidth + 0.01;
              //     break;
              // }

              const shadeOffsets = {
                front: -0.01,
                back: -0.01,
                left: -0.01,
                right: -0.01
              };

              const ensureShadeVisible = (o) => {
                o.visible = true;
                o.traverse(ch => { ch.visible = true; });
              };

              const markShadeClone = (o) => {
                o.userData = o.userData || {};
                o.userData.clonedShade = true;
                o.userData.shadeSide = shadeSide;
              };

              const isChildOfShadeClone = (obj) => {
                let parent = obj.parent;
                while (parent) {
                  if (parent.userData?.clonedShade) return true;
                  parent = parent.parent;
                }
                return false;
              };

              const oldShadeClones = [];
              scene.traverse((o) => {
                if (isChildOfShadeClone(o)) return;

                if (
                  (o.name.startsWith('blind_frame_') || o.name.startsWith('blind_')) &&
                  o.name.includes(shadeSuffix)
                ) {
                  if (!o.userData?.clonedShade) {
                    o.visible = false;
                    o.traverse(child => { child.visible = false; });
                  } else if (o.userData?.shadeSide === shadeSide) {
                    oldShadeClones.push(o);
                  }
                }
              });
              oldShadeClones.forEach(c => c.parent?.remove(c));

              const applyShadeColor = (obj) => {
                obj.traverse(child => {
                  if (child.isMesh) {
                    if (Array.isArray(child.material)) {
                      child.material = child.material.map(mat => {
                        if (mat.name === 'powder_coat') {
                          const cloned = mat.clone();
                          cloned.color.set(state.colorZip);
                          return cloned;
                        }
                        return mat;
                      });
                    } else if (child.material.name === 'powder_coat') {
                      child.material = child.material.clone();
                      child.material.color.set(state.colorZip);
                    }
                  }
                });
              };

              const blindFrameName = `blind_frame${shadeSuffix}`;
              let blindFrameTemplate = null;
              scene.traverse((o) => {
                if (o.name === blindFrameName && !o.userData?.clonedShade) blindFrameTemplate = o;
              });

              if (!blindFrameTemplate) break;

              const maxShadeWidth = 4.5;
              let numShadeFrames;
              if (shadeSpanSize <= maxShadeWidth) {
                numShadeFrames = 1;
              } else if (shadeSpanSize <= maxShadeWidth * 2) {
                numShadeFrames = 2;
              } else {
                numShadeFrames = 3;
              }
              const shadeFrameWidth = shadeSpanSize / numShadeFrames;

              const getShadeWidthMorph = (spanMeters) => {
                const minWidth = 1.0;
                const maxWidth = 4.5;
                return Math.max(0, Math.min(1, (spanMeters - minWidth) / (maxWidth - minWidth)));
              };

              const shadeWidthMorph = getShadeWidthMorph(shadeFrameWidth);
              const shadeHeightMorph = getShadeHeightMorph(state.height);
              const shadeClosingMorph = (state.zipInput / 100) * getShadeClosingScale(state.height);

              const applyBlindFrameMorphs = (obj) => {
                obj.traverse(child => {
                  if (child.isMesh && child.morphTargetDictionary && child.morphTargetInfluences) {
                    const w = child.morphTargetDictionary['width'];
                    if (w !== undefined) child.morphTargetInfluences[w] = shadeWidthMorph;

                    const h = child.morphTargetDictionary['height'];
                    if (h !== undefined) child.morphTargetInfluences[h] = shadeHeightMorph;

                    const l = child.morphTargetDictionary['lenth'];
                    if (l !== undefined) child.morphTargetInfluences[l] = shadeWidthMorph;

                    const c = child.morphTargetDictionary['closing'];
                    if (c !== undefined) child.morphTargetInfluences[c] = shadeClosingMorph;
                  }
                });
              };

              let shadeSetOffsets;
              if (numShadeFrames === 1) {
                shadeSetOffsets = [0];
              } else if (numShadeFrames === 2) {
                shadeSetOffsets = [-shadeSpanSize / 4, shadeSpanSize / 4];
              } else {
                shadeSetOffsets = [-shadeSpanSize / 3, 0, shadeSpanSize / 3];
              }

              if (numShadeFrames >= 2) {
                const tempFrame = blindFrameTemplate.clone(true);
                applyBlindFrameMorphs(tempFrame);
                tempFrame.updateWorldMatrix(true, true);
                const tempBox = new THREE.Box3().setFromObject(tempFrame);
                const frameGeoWidth = isShadeXAxis
                  ? (tempBox.max.x - tempBox.min.x)
                  : (tempBox.max.z - tempBox.min.z);

                const _interpDivShade = (map, defaultVal, val) => {
                  const keys = Object.keys(map).map(Number).sort((a, b) => a - b);
                  if (!keys.length) return defaultVal;
                  if (val <= keys[0]) return map[keys[0]];
                  if (val >= keys[keys.length - 1]) return map[keys[keys.length - 1]];
                  if (map[val] !== undefined) return map[val];
                  for (let i = 0; i < keys.length - 1; i++) {
                    if (val >= keys[i] && val <= keys[i + 1]) {
                      const t = (val - keys[i]) / (keys[i + 1] - keys[i]);
                      return map[keys[i]] + t * (map[keys[i + 1]] - map[keys[i]]);
                    }
                  }
                  return defaultVal;
                };

                if (numShadeFrames === 2 && !isShadeXAxis && shadeSpanSize >= 4.6 && shadeSpanSize <= 5.0) {
                  const divisor = _interpDivShade(
                    { 4.5: 4.0, 5.0: 3.6 },
                    4.0,
                    shadeSpanSize
                  );
                  const frameHalfGeo = frameGeoWidth / divisor;
                  shadeSetOffsets = [-frameHalfGeo, frameHalfGeo];
                } else if (numShadeFrames === 2) {
                  const divisor = _interpDivShade(
                    { 4.5: 4.0, 5: 3.6, 6: 3.0, 7: 2.6, 8: 2.3, 9: 2.0 },
                    3.0,
                    shadeSpanSize
                  );
                  const frameHalfGeo = frameGeoWidth / divisor;
                  shadeSetOffsets = [-frameHalfGeo, frameHalfGeo];
                } else {
                  // 3 frames
                  const divisor = _interpDivShade(
                    { 9: 1.5, 10: 1.4, 11: 1.25, 12: 1.15 },
                    1.2,
                    shadeSpanSize
                  );
                  const frameThirdGeo = frameGeoWidth / divisor;
                  shadeSetOffsets = [-frameThirdGeo, 0, frameThirdGeo];
                }
              }

              shadeSetOffsets.forEach((setOffset) => {
                const frameObj = blindFrameTemplate.clone(true);
                markShadeClone(frameObj);
                blindFrameTemplate.parent.add(frameObj);
                const shadeTargetPos = this.getSideTargetLocalPos(blindFrameTemplate.parent, shadeSide, shadeOffsets);

                ensureShadeVisible(frameObj);
                applyBlindFrameMorphs(frameObj);
                applyShadeColor(frameObj);

                if (isShadeXAxis) {
                  frameObj.position.z = shadeTargetPos.z;
                  frameObj.position.x = setOffset;
                  if (shadeSide === pergolaConst.side.Back) {
                    frameObj.rotation.set(0, Math.PI, 0);
                  }
                } else {
                  frameObj.position.x = shadeTargetPos.x;
                  frameObj.position.z = setOffset;
                  if (shadeSide === pergolaConst.side.Left) {
                    frameObj.rotation.set(0, Math.PI, 0);
                  }
                }
                theModel.attach(frameObj);
              });

              break;

            // case pergolaConst.systemType.privacyWall:
            //   const frame = system.object;

            //   // system.object.position.x = span.posX;
            //   // system.object.position.z = span.posZ;

            //   const isDirectionX = !system.direction;

            //   // const mesh = post.children[0];
            //   let post = isDirectionX
            //     ? scene.getObjectByName("privacy_wall_post_3x3")
            //     : scene.getObjectByName("privacy_wall_post_3x3_side");

            //   post.material.color.set(state.colorBody);

            //   let blade30 = isDirectionX
            //     ? scene.getObjectByName("privacy_wall_2x2")
            //     : scene.getObjectByName("privacy_wall_2x2_side");

            //   let blade60 = isDirectionX
            //     ? scene.getObjectByName("privacy_wall_2x6")
            //     : scene.getObjectByName("privacy_wall_2x6_side");

            //   const finalBlade = state.slatsSize ? blade30 : blade60;

            //   const intervalPost = 2.5;
            //   const half = system.spanWidth / 2;
            //   const countPosts = Math.floor(system.spanWidth / intervalPost);
            //   const direction = isDirectionX ? "x" : "z";

            //   const mirroredPoints = generateMidpoints(
            //     this.addOffset(post.position, direction, half),
            //     this.addOffset(post.position, direction, -half),
            //     countPosts
            //   );

            //   // 🧹 Очистка старих постів
            //   for (let i = frame.children.length - 1; i >= 0; i--) {
            //     const child = frame.children[i];
            //     if (
            //       child.name &&
            //       child.name.includes("slats_post") &&
            //       child.uuid !== post.uuid
            //     ) {
            //       frame.remove(child);
            //     }
            //   }

            //   // ✨ Генерація нових постів
            //   const generatedPosts = [];

            //   for (let i = 0; i < mirroredPoints.length; i++) {
            //     const newPost = post.clone();
            //     newPost.position.x = post.position.x;
            //     newPost.position.z = post.position.z;

            //     if (isDirectionX) {
            //       newPost.position.x = mirroredPoints[i].x;
            //     } else {
            //       newPost.position.z = mirroredPoints[i].z;
            //     }

            //     newPost.name = "slats_post_clone";
            //     this.changeObjectVisibility(true, newPost);
            //     frame.add(newPost);
            //     generatedPosts.push(newPost);
            //   }

            //   // remove slats
            //   for (let i = frame.children.length - 1; i >= 0; i--) {
            //     const child = frame.children[i];
            //     if (child.name && child.name.includes("slat_clone")) {
            //       frame.remove(child);
            //     }
            //   }

            //   const gapShutter = !state.slatsSize ? 0 : 0.03;
            //   const heightShutter = !state.slatsSize ? 0.15 : 0.06;
            //   const fullShutterHeight = heightShutter + gapShutter;
            //   const totalHeight = state.height;
            //   const countShutter = Math.floor(
            //     totalHeight / fullShutterHeight
            //   );

            //   for (let p = 0; p < generatedPosts.length; p++) {
            //     for (let i = 1; i < countShutter; i++) {
            //       const newBlade = finalBlade.clone();
            //       newBlade.position.y = i * fullShutterHeight;

            //       newBlade.name = "slat_clone";
            //       this.changeObjectVisibility(true, newBlade);
            //       frame.add(newBlade);
            //     }
            //   }

            //   if (!generatedPosts.length) {
            //     for (let i = 1; i < countShutter; i++) {
            //       const newBlade = finalBlade.clone();
            //       newBlade.position.y = i * fullShutterHeight;

            //       newBlade.name = "slat_clone";
            //       this.changeObjectVisibility(true, newBlade);
            //       frame.add(newBlade);
            //     }
            //   }

            //   break;


            default:
              break;
          }
        }
      }
    }
  }

  setOptions() {
    this.changeRoofVisibilityRest(false, "heatersFront", null, true);
    this.changeRoofVisibilityRest(false, "heatersBack", null, true);
    this.changeRoofVisibility(false, "pointLED", null, true);
    this.changeRoofVisibility(false, "rampLEDX", null, true);
    this.changeRoofVisibility(false, "rampLEDY", null, true);

    pointsBeamX = [];
    pointsBeamZ = [];

    if (pergola.roof.headerLed && pergola.roof.headerLed.length > 0) {
      pergola.roof.headerLed[0].object.visible = false;
    }

    if (state.electro.has(pergolaConst.optionNameString.LEDStrip)) {
      if (pergola.roof.headerLed && pergola.roof.headerLed.length > 0) {
        pergola.roof.headerLed[0].object.visible = true;
      }
    }
  }

  cleanOtherSystemsOnSide(side, currentType) {
    const toRemove = [];

    scene.traverse(o => {
      if (o.userData?.clonedDoor && o.userData?.doorSide === side && currentType !== pergolaConst.systemType.slidingGlassDoor) {
        toRemove.push(o);
      }
      if (o.userData?.clonedShutter && o.userData?.shutterSide === side && currentType !== pergolaConst.systemType.privacyWall) {
        toRemove.push(o);
      }
      if (o.userData?.clonedShade && o.userData?.shadeSide === side && currentType !== pergolaConst.systemType.autoShade) {
        toRemove.push(o);
      }
    });

    toRemove.forEach(o => {
      if (o.parent) o.parent.remove(o);
    });
  };

  setPointLight() {
    const {
      point_post_width,
      point_post_length,
      point_louver_width,
      point_louver_length,
    } = this.getPostPoints();

    const { FL_point, FR_point, RR_point } = this.getCornerPoints();
    const countPointLight = 5;

    const cornerAndBeamPointZ = [
      FR_point,
      ...this.addOffset(point_post_length, "z", 0),
      RR_point,
    ];

    const cornerAndBeamPointX = [
      FL_point,
      ...this.addOffset(point_post_width, "x", 0),
      FR_point,
    ];

    let allPointsForLouversZ = [];
    let allPointsForLouversX = [];

    for (let i = 0; i < cornerAndBeamPointZ.length - 1; i++) {
      const spanPoints = generateMidpoints(
        cornerAndBeamPointZ[i],
        cornerAndBeamPointZ[i + 1],
        countPointLight
      );

      allPointsForLouversZ.push(...spanPoints);
    }

    for (let i = 0; i < cornerAndBeamPointX.length - 1; i++) {
      const spanPoints = generateMidpoints(
        cornerAndBeamPointX[i],
        cornerAndBeamPointX[i + 1],
        countPointLight
      );

      allPointsForLouversX.push(...spanPoints);
    }

    const offset = 0.07;

    //#region SET POINT LED ON BEAM
    if (state.directionRoof) {
      for (let i = 0; i < pointsBeamX.length; i++) {
        const pointX = pointsBeamX[i];

        for (let i = 0; i < allPointsForLouversZ.length; i++) {
          const pointZ = allPointsForLouversZ[i].z;

          const element = this.getAvaliableObjectFromOneArray(
            this.roof.pointLED
          );

          element.object.position.z = pointZ;
          element.object.position.x = pointX;

          element.object.visible = true;
          element.object.children.forEach((child) => (child.visible = true));
          element.active = true;
        }
      }
    } else {
      for (let i = 0; i < pointsBeamZ.length; i++) {
        const pointZ = pointsBeamZ[i];

        for (let i = 0; i < allPointsForLouversX.length; i++) {
          const pointX = allPointsForLouversX[i].x;

          const element = this.getAvaliableObjectFromOneArray(
            this.roof.pointLED
          );

          element.object.position.z = pointZ;
          element.object.position.x = pointX;

          element.object.visible = true;
          element.object.children.forEach((child) => (child.visible = true));
          element.active = true;
        }
      }
    }

  }

  setLEDramp() {
    const {
      point_post_width,
      point_post_length,
      point_louver_width,
      point_louver_length,
    } = this.getPostPoints();
    const { span_width, span_depth } = this.getSpanPoints();

    const { FL_point, FR_point, RR_point } = this.getCornerPoints();
    const countPointLightSpanZ = Math.ceil(span_width / 3);
    const countPointLightSpanX = Math.ceil(span_width / 3);

    const cornerAndBeamPointZ = [
      FR_point,
      ...this.addOffset(point_post_length, "z", 0),
      RR_point,
    ];

    const cornerAndBeamPointX = [
      FL_point,
      ...this.addOffset(point_post_width, "x", 0),
      FR_point,
    ];

    let allPointsForLouversZ = [];
    let allPointsForLouversX = [];

    for (let i = 0; i < cornerAndBeamPointZ.length - 1; i++) {
      const spanPoints = generateMidpoints(
        cornerAndBeamPointZ[i],
        cornerAndBeamPointZ[i + 1],
        countPointLightSpanZ
      );

      allPointsForLouversZ.push(...spanPoints);
    }

    for (let i = 0; i < cornerAndBeamPointX.length - 1; i++) {
      const spanPoints = generateMidpoints(
        cornerAndBeamPointX[i],
        cornerAndBeamPointX[i + 1],
        countPointLightSpanX
      );

      allPointsForLouversX.push(...spanPoints);
    }

    const offset = 0.07 * 2.3;
    const offseBeam = 0.08;
    // let height = this.getMeters(state.height) - 0.9;

    //#region SET RAM LED ON BEAM
    //SOLID
    // if (!state.roofType) {
    //   //X BEAM
    //   for (let i = 0; i < point_post_length.length; i++) {
    //     const pointZ = point_post_length[i].z;

    //     //FIRT SIDE
    //     for (let i = 0; i < allPointsForLouversX.length; i++) {
    //       const pointX = allPointsForLouversX[i].x;

    //       const element = this.getAvaliableObjectFromOneArray(
    //         this.roof.rampLEDX
    //       );

    //       element.object.position.z = pointZ - offseBeam;
    //       element.object.position.x = pointX;

    //       element.object.visible = true;
    //       element.object.children.forEach((child) => (child.visible = true));
    //       element.active = true;
    //     }
    //     //SECOND SIDE
    //     for (let i = 0; i < allPointsForLouversX.length; i++) {
    //       const pointX = allPointsForLouversX[i].x;

    //       const element = this.getAvaliableObjectFromOneArray(
    //         this.roof.rampLEDX
    //       );

    //       element.object.position.z = pointZ + offseBeam;
    //       element.object.position.x = pointX;

    //       element.object.visible = true;
    //       element.object.children.forEach((child) => (child.visible = true));
    //       element.active = true;
    //     }
    //   }

    //   //Y BEAM
    //   for (let i = 0; i < point_post_width.length; i++) {
    //     const pointX = point_post_width[i].x;

    //     //FIRT SIDE
    //     for (let i = 0; i < allPointsForLouversZ.length; i++) {
    //       const pointZ = allPointsForLouversZ[i].z;

    //       const element = this.getAvaliableObjectFromOneArray(
    //         this.roof.rampLEDY
    //       );

    //       element.object.position.z = pointZ;
    //       element.object.position.x = pointX - offseBeam;

    //       element.object.visible = true;
    //       element.object.children.forEach((child) => (child.visible = true));
    //       element.active = true;
    //     }
    //     //SECOND SIDE
    //     for (let i = 0; i < allPointsForLouversZ.length; i++) {
    //       const pointZ = allPointsForLouversZ[i].z;

    //       const element = this.getAvaliableObjectFromOneArray(
    //         this.roof.rampLEDY
    //       );

    //       element.object.position.z = pointZ;
    //       element.object.position.x = pointX + offseBeam;

    //       element.object.visible = true;
    //       element.object.children.forEach((child) => (child.visible = true));
    //       element.active = true;
    //     }
    //   }
    // } else {
    //   const pointBeamLenght = state.directionRoof
    //     ? point_louver_length
    //     : point_post_length;

    //   const pointBeamWidth = state.directionRoof
    //     ? point_post_width
    //     : point_louver_width;

    //   //X BEAM
    //   for (let i = 0; i < pointBeamLenght.length; i++) {
    //     const pointZ = pointBeamLenght[i].z;

    //     //FIRT SIDE
    //     for (let i = 0; i < allPointsForLouversX.length; i++) {
    //       const pointX = allPointsForLouversX[i].x;

    //       const element = this.getAvaliableObjectFromOneArray(
    //         this.roof.rampLEDX
    //       );

    //       element.object.position.z = pointZ - offseBeam;
    //       element.object.position.x = pointX;

    //       element.object.visible = true;
    //       element.object.children.forEach((child) => (child.visible = true));
    //       element.active = true;
    //     }
    //     //SECOND SIDE
    //     for (let i = 0; i < allPointsForLouversX.length; i++) {
    //       const pointX = allPointsForLouversX[i].x;

    //       const element = this.getAvaliableObjectFromOneArray(
    //         this.roof.rampLEDX
    //       );

    //       element.object.position.z = pointZ + offseBeam;
    //       element.object.position.x = pointX;

    //       element.object.visible = true;
    //       element.object.children.forEach((child) => (child.visible = true));
    //       element.active = true;
    //     }
    //   }

    //   //Y BEAM
    //   for (let i = 0; i < pointBeamWidth.length; i++) {
    //     const pointX = pointBeamWidth[i].x;

    //     //FIRT SIDE
    //     for (let i = 0; i < allPointsForLouversZ.length; i++) {
    //       const pointZ = allPointsForLouversZ[i].z;

    //       const element = this.getAvaliableObjectFromOneArray(
    //         this.roof.rampLEDY
    //       );

    //       element.object.position.z = pointZ;
    //       element.object.position.x = pointX + offseBeam;

    //       element.object.visible = true;
    //       element.object.children.forEach((child) => (child.visible = true));
    //       element.active = true;
    //     }
    //     //SECOND SIDE
    //     for (let i = 0; i < allPointsForLouversZ.length; i++) {
    //       const pointZ = allPointsForLouversZ[i].z;

    //       const element = this.getAvaliableObjectFromOneArray(
    //         this.roof.rampLEDY
    //       );

    //       element.object.position.z = pointZ;
    //       element.object.position.x = pointX - offseBeam;

    //       element.object.visible = true;
    //       element.object.children.forEach((child) => (child.visible = true));
    //       element.active = true;
    //     }
    //   }
    // }

    //LOVERS:
    const pointBeamLenght = state.directionRoof
      ? point_louver_length
      : point_post_length;

    const pointBeamWidth = state.directionRoof
      ? point_post_width
      : point_louver_width;

    //X BEAM
    for (let i = 0; i < pointBeamLenght.length; i++) {
      const pointZ = pointBeamLenght[i].z;

      //FIRT SIDE
      for (let i = 0; i < allPointsForLouversX.length; i++) {
        const pointX = allPointsForLouversX[i].x;

        const element = this.getAvaliableObjectFromOneArray(
          this.roof.rampLEDX
        );

        element.object.position.z = pointZ - offseBeam;
        element.object.position.x = pointX;

        element.object.visible = true;
        element.object.children.forEach((child) => (child.visible = true));
        element.active = true;
      }
      //SECOND SIDE
      for (let i = 0; i < allPointsForLouversX.length; i++) {
        const pointX = allPointsForLouversX[i].x;

        const element = this.getAvaliableObjectFromOneArray(
          this.roof.rampLEDX
        );

        element.object.position.z = pointZ + offseBeam;
        element.object.position.x = pointX;

        element.object.visible = true;
        element.object.children.forEach((child) => (child.visible = true));
        element.active = true;
      }
    }

    //Y BEAM
    for (let i = 0; i < pointBeamWidth.length; i++) {
      const pointX = pointBeamWidth[i].x;

      //FIRT SIDE
      for (let i = 0; i < allPointsForLouversZ.length; i++) {
        const pointZ = allPointsForLouversZ[i].z;

        const element = this.getAvaliableObjectFromOneArray(
          this.roof.rampLEDY
        );

        element.object.position.z = pointZ;
        element.object.position.x = pointX + offseBeam;

        element.object.visible = true;
        element.object.children.forEach((child) => (child.visible = true));
        element.active = true;
      }
      //SECOND SIDE
      for (let i = 0; i < allPointsForLouversZ.length; i++) {
        const pointZ = allPointsForLouversZ[i].z;

        const element = this.getAvaliableObjectFromOneArray(
          this.roof.rampLEDY
        );

        element.object.position.z = pointZ;
        element.object.position.x = pointX - offseBeam;

        element.object.visible = true;
        element.object.children.forEach((child) => (child.visible = true));
        element.active = true;
      }
    }
    // #endregion

    //#region LEFT
    for (let i = 0; i < allPointsForLouversZ.length; i++) {
      const point = allPointsForLouversZ[i];
      // console.log(this.pointLights);
      const element = this.getAvaliableObjectFromOneArray(this.roof.rampLEDY);
      // height = element.object.position.y -;

      // console.log(element);

      element.object.position.z = point.z;
      element.object.position.x = -point.x + offset;

      element.object.visible = true;
      element.object.children.forEach((child) => (child.visible = true));
      element.active = true;
    }
    //#endregion

    //#region RIGHT
    for (let i = 0; i < allPointsForLouversZ.length; i++) {
      const point = allPointsForLouversZ[i];
      // console.log(this.pointLights);
      const element = this.getAvaliableObjectFromOneArray(this.roof.rampLEDY);

      // console.log(element);

      element.object.position.z = point.z;
      element.object.position.x = point.x - offset;

      element.object.visible = true;
      element.object.children.forEach((child) => (child.visible = true));
      element.active = true;
    }

    //#endregion

    //#region BACK
    for (let i = 0; i < allPointsForLouversX.length; i++) {
      const point = allPointsForLouversX[i];
      const element = this.getAvaliableObjectFromOneArray(this.roof.rampLEDX);

      element.object.position.z = -point.z + offset;
      element.object.position.x = point.x;

      element.object.visible = true;
      element.object.children.forEach((child) => (child.visible = true));
      element.active = true;
    }

    //#endregion

    //#region FRONT
    for (let i = 0; i < allPointsForLouversX.length; i++) {
      const point = allPointsForLouversX[i];
      const element = this.getAvaliableObjectFromOneArray(this.roof.rampLEDX);

      element.object.position.z = point.z - offset;
      element.object.position.x = point.x;

      element.object.visible = true;
      element.object.children.forEach((child) => (child.visible = true));
      element.active = true;
    }

    //#endregion
  }

  setHeaters() {
    const { RL_point, FR_point, FL_point, RR_point } = this.getCornerPoints();
    const { point_post_length, point_louver_width, point_post_width } =
      this.getPostPoints();

    const pointsXforLouver = this.generateCenterPoints([
      ...this.addOffset([RL_point], "x", 0),
      ...point_post_width,
      ...this.addOffset([RR_point], "x", 0),
    ]);

    //BACK SIDE
    const backActiveSpan = pergola.span.objects.filter(
      (span) => span.side === pergolaConst.side.Back && span.isSystemSet
    );

    if (!state.backWall) {
      for (
        let j = 0;
        j < pointsXforLouver.length - backActiveSpan.length;
        j++
      ) {
        const pointX = pointsXforLouver[j].x;
        const pointZ = FR_point.z;
        const element = this.getAvaliableObjectFromOneArray(this.heatersBack);

        element.object.position.x = pointX;
        element.object.position.z = -pointZ;

        this.changeObjectVisibility(true, element.object);
        element.active = true;
      }
    }

    // FRONT SIDE
    const frontActiveSpan = pergola.span.objects.filter(
      (span) => span.side === pergolaConst.side.Front && span.isSystemSet
    );

    for (let j = 0; j < pointsXforLouver.length - frontActiveSpan.length; j++) {
      const point = pointsXforLouver[j];
      const pointX = point.x;
      const pointZ = FR_point.z;

      const element = this.getAvaliableObjectFromOneArray(this.heatersFront);

      // element.object.rotation.set(
      //   3.68,
      //   1.5707963267948966,
      //   element.object.rotation.z
      // );

      // mirrorObject(element.object, true);

      element.object.position.x = pointX;
      element.object.position.z = pointZ;

      this.changeObjectVisibility(true, element.object);
      element.active = true;
    }

    // }
  }


  setSolidRoof() {

    this.changeRoofVisibility(false, "solidRoof", null, true);
  }

  setLouver() {
    const currentLouverKey = `${state.roofType}_${state.louvreType}_${state.directionRoof}_${state.retractOption}_${state.width}_${state.length}`;

    if (this._lastLouverKey !== currentLouverKey) {
      this.roof.louverX.forEach(l => {
        this.changeObjectVisibility(false, l.object);
        if (l.object.parent) l.object.parent.remove(l.object);
      });
      this.roof.louverY.forEach(l => {
        this.changeObjectVisibility(false, l.object);
        if (l.object.parent) l.object.parent.remove(l.object);
      });
      this.roof.louverX = [];
      this.roof.louverY = [];
      this._lastLouverKey = currentLouverKey;
    }


    this.changeRoofVisibility(false, "louverX", null, true);
    this.changeRoofVisibility(false, "louverY", null, true);

    const countSolidRoofX = Math.ceil(
      (state.directionRoof ? state.length : state.width)
    ); //size Louver

    // ── Louver positioning from state dimensions ──
    const halfWidth = state.width / 2;
    const halfLength = state.length / 2;

    let alpineLouver = state.roofType === 0 && state.louvreType === 4;
    let currentLouverType = state.louvreType;

    let bladeSpacing;
    switch (`${state.roofType}_${state.louvreType}`) {
      case "0_0": bladeSpacing = 0.180; break; // 180/30 Slimline
      case "0_1": bladeSpacing = 0.193; break; // 200/35 Slimline
      case "0_2": bladeSpacing = 0.205; break; // 200 Suburban
      case "0_3": bladeSpacing = 0.221; break; // 220/35 Slimline
      case "0_4": bladeSpacing = 0.2224; break; // 220/45 Alpine
      case "0_5": bladeSpacing = 0.270; break; // 270 translucent
      case "1_0": bladeSpacing = 0.237; break; // 220/35 Slimline Retract
      case "1_1": bladeSpacing = 0.237; break; // 220/45 Alpine Retract
      default: bladeSpacing = 0.180;
    }

    let heightOffset;
    switch (`${state.roofType}_${state.louvreType}`) {
      case "0_0": heightOffset = 0.695; break; // 180/30 Slimline
      case "0_1": heightOffset = 0.69; break; // 200/35 Slimline
      case "0_2": heightOffset = 0.69; break; // 200 Suburban
      case "0_3": heightOffset = 0.69; break; // 220/35 Slimline
      case "0_4": heightOffset = 0.69; break; // 220/45 Alpine
      case "0_5": heightOffset = 0.71; break; // 270 translucent
      case "1_0": heightOffset = 0.73; break; // 220/35 Slimline Retract
      case "1_1": heightOffset = 0.73; break; // 220/45 Alpine Retract
      default: heightOffset = 0.69;
    }

    let CENTRAL_BEAM_HALF = 0.04;
    const hasCentralPosts = ((state.roofType === 1) && (state.width >= 5.0 || state.length >= 4.0));

    // Lighting frame 
    const visualHeight = getHeightMorph(state.height) * 3.0;
    const lightingY = visualHeight;

    // Determine which lighting suffix matches current frame
    let activeSuffix = '';
    if (state.roofType === 0) {
      // Opening roof
      activeSuffix = state.directionRoof ? 'pivot_x' : 'pivot_y';
    } else {
      // Retractable
      if (state.retractOption === 'oneSide') {
        activeSuffix = state.directionRoof ? 'retr_1_x' : 'retr_1_y_R';
      } else {
        activeSuffix = state.directionRoof ? 'retr_2_x' : 'retr_2_y';
      }
    }

    scene.traverse((o) => {
      if (o.name.startsWith("lighting_front_face") || o.name.startsWith("lighting_inside_face")) {
        const isActive = o.name.includes(activeSuffix);
        if (state.roofType === 0) {
          o.position.x = 0.0;
        } else {
          o.position.x = 0.0;
        }
        o.position.y = lightingY - 0.04;
        o.visible = !!state.lightingEnabled && isActive;
        o.traverse(child => {
          child.visible = o.visible;
          if (child.isMesh && child.material && child.material.name === 'emissive') {
            child.material = child.material.clone();
            child.material.emissive = new THREE.Color(0xffffee);
            child.material.emissiveIntensity = 0.8;
            child.material.toneMapped = false;
            child.material.needsUpdate = true;
          }
        });
      }
    });

    // translucent louvres transparent
    if (state.louvreType === 5 && state.roofType === 0) {
      const activeLouvers = state.directionRoof ? this.roof.louverX : this.roof.louverY;
      activeLouvers.forEach(l => {
        if (!l.active) return;
        l.object.traverse((child) => {
          if (child.isMesh && child.material && child.material.name === 'white_translucent') {
            if (!child.userData.translucent) {
              o.material.transparent = true;
              o.material.opacity = 0.45;
              o.material.depthWrite = false;
              o.material.needsUpdate = true;
              o.userData.translucent = true;
            }
          }
        });
      });
    }

    if (state.directionRoof) {
      // Rotated direction — louvers along length axis
      const louverCount = Math.ceil(state.length / bladeSpacing);
      const startZ = -halfLength + 0.1;
      const endZ = halfLength - 0.1;
      const step = (endZ - startZ) / louverCount;

      for (let i = 0; i < louverCount; i++) {
        let pointZ = startZ + step * i + step / 2;

        if (hasCentralPosts) {
          if (state.retractOption === 'oneSide') {
            pointZ -= CENTRAL_BEAM_HALF;
          } else {
            if (Math.abs(pointZ) < step / 2) continue;
            if (pointZ < 0) pointZ -= CENTRAL_BEAM_HALF;
            else pointZ += CENTRAL_BEAM_HALF;
          }
        }

        const element = this.getAvaliableObjectFromOneArray(this.roof.louverX);
        if (!element) break;

        const clampedRotationZ = Math.min(state.currentRotationZ, 158);
        let radians = (state.roofType === 1 && state.louversOpeningInput > 0)
          ? (90 * Math.PI / 180)
          : (clampedRotationZ * (Math.PI / 180));

        if ((state.roofType === 0 && currentLouverType === 0)) {
          element.object.rotation.set(-0.0316, 0, -(radians));
        } else {
          element.object.rotation.set(-0.0316, 0, (radians));
        }

        element.object.position.x = 0;
        const visualHeight = getHeightMorph(state.height) * 3.0;
        element.object.position.y = visualHeight + heightOffset;
        element.object.position.z = pointZ;

        this.changeObjectVisibility(true, element.object);
        element.active = true;
      }
    } else {

      let louverCount = Math.ceil(state.width / bladeSpacing) -
        (hasCentralPosts && state.width === 7 ? 1 : 0);
      // Even parity for 6.7–6.8 and 7.0: center gap = 1*step instead of 2*step
      if (hasCentralPosts &&
        ((state.width >= 6.7 && state.width <= 6.8) || state.width === 7.0)) {
        if (louverCount % 2 !== 0) louverCount += 1;
      }
      // Odd parity for extraLeft widths (halfL = halfR+1 split needs odd total)
      if (hasCentralPosts &&
        (state.width === 6.1 || state.width === 6.2 || state.width === 6.3 || state.width === 6.9)) {
        if (louverCount % 2 === 0) louverCount += 1;
      }

      const startX = state.roofType === 1 ? -halfWidth + 0.33 : -halfWidth + 0.1;
      const endX = state.roofType === 1 ? halfWidth - 0.33 : halfWidth - 0.1;
      const step = (endX - startX) / louverCount;

      const isStationary = Number(state.louversOpeningInput) === 0;
      const oneSideRightOffset = hasCentralPosts && state.width <= 6.0 && state.retractOption === 'oneSide' && isStationary ? (0.015 / state.width) : 0;
      const extraRight = hasCentralPosts && state.width <= 6.0 && state.retractOption === 'oneSide' && isStationary ? 1 : 0;

      for (let i = 0; i < louverCount + extraRight; i++) {
        let pointX = startX + step * i + step / 2;

        if (hasCentralPosts && isStationary) {
          if (state.width <= 6) {
            const halfCount = Math.floor(louverCount / 2);
            if (i < halfCount) {
              const leftStep = ((-CENTRAL_BEAM_HALF) - startX) / halfCount;
              pointX = startX + i * leftStep + leftStep / 2;
            } else if (i === halfCount && louverCount % 2 === 1) {
              continue; // skip center louver for odd count
            } else {
              const rightIdx = i - halfCount - (louverCount % 2 === 1 ? 1 : 0);
              const rightStep = (endX - CENTRAL_BEAM_HALF) / halfCount;
              pointX = CENTRAL_BEAM_HALF + oneSideRightOffset + rightIdx * rightStep + rightStep / 2;
            }
          } else {
            const isExtraLeft = state.width === 6.1 || state.width === 6.2 ||
              state.width === 6.3 || state.width === 6.9;
            if (isExtraLeft) {
              // Asymmetric split: left gets halfR+1, right gets halfR
              const halfR = Math.floor(louverCount / 2);
              const halfL = halfR + 1;
              if (i < halfL) {
                const leftStep = (-CENTRAL_BEAM_HALF - startX) / halfL;
                pointX = startX + i * leftStep + leftStep / 2;
              } else {
                const rightIdx = i - halfL;
                const rightStep = (endX - CENTRAL_BEAM_HALF) / halfR;
                pointX = CENTRAL_BEAM_HALF + rightIdx * rightStep + rightStep / 2;
              }
            } else {
              if (Math.abs(pointX) < step / 2) continue;
              pointX += pointX < 0 ? -CENTRAL_BEAM_HALF : CENTRAL_BEAM_HALF;
              if (state.width === 7 && state.roofType === 1 && i === 0) {
                pointX += CENTRAL_BEAM_HALF / 3;
              }
            }
          }
        }

        const element = this.getAvaliableObjectFromOneArray(this.roof.louverY);
        if (!element) break;

        element.object.traverse((child) => {
          if (child.isMesh && child.morphTargetInfluences && child.morphTargetDictionary) {
            const idx = child.morphTargetDictionary['lenth'];
            if (idx !== undefined) {
              const lenRange = state.roofType === 1 ? MORPH_DATA.retractable.length : MORPH_DATA.opening.length;
              child.morphTargetInfluences[idx] = ConvertMorphValue(
                state.length, lenRange.min, lenRange.max
              );
            }
            const idxWidth = child.morphTargetDictionary['width'];
            if (idxWidth !== undefined) {
              const widRange = state.roofType === 1 ? MORPH_DATA.retractable.width : MORPH_DATA.opening.width;
              child.morphTargetInfluences[idxWidth] = ConvertMorphValue(
                state.width, widRange.min, widRange.max
              );
            }
          }
        });

        const clampedRotationZ = Math.min(state.currentRotationZ, 158);
        let radians = (state.roofType === 1 && state.louversOpeningInput > 0)
          ? (90 * Math.PI / 180)
          : (clampedRotationZ * (Math.PI / 180));

        if (alpineLouver) {
          element.object.rotation.set(-0.0316, 0, radians);
          element.object.traverse((child) => {
            if (child.name === "connecting_bar_y" || child.name.startsWith("connecting_bar")) {
              if (child.userData.baseY === undefined) child.userData.baseY = child.position.y;
              const rotationFactor = clampedRotationZ / 158;
              child.position.y = child.userData.baseY + 0.065 - rotationFactor * 0.0005;
              child.rotation.set(0.0316, 0, -(radians));
            }
          });
        }
        element.object.rotation.set(-0.0316, 0, (radians));

        element.object.position.x = pointX;
        element.object.position.z = 0;
        const visualHeight = getHeightMorph(state.height) * 3.0;
        element.object.position.y = visualHeight + heightOffset;

        this.changeObjectVisibility(true, element.object);
        element.active = true;
      }
    }

    const activeLouvers = state.directionRoof ? this.roof.louverX : this.roof.louverY;

    getLouverMeshNames();

    // reset connecting bar width morph after global morphs
    if (alpineLouver) {
      const activeLouvers = state.directionRoof ? this.roof.louverX : this.roof.louverY;
      activeLouvers.forEach(l => {
        if (!l.active) return;
        l.object.traverse((child) => {
          if (child.name.startsWith("connecting_bar") ||
            (child.parent && child.parent.name.startsWith("connecting_bar"))) {
            if (child.isMesh && child.morphTargetDictionary) {
              const widthIdx = child.morphTargetDictionary["width"];
              if (widthIdx !== undefined) {
                child.morphTargetInfluences[widthIdx] = 0;
              }
            }
          }
        });
      });
    }

    // retractable opening animation
    if (state.roofType === 1 && state.louversOpeningInput > 0) {
      const openPercent = Math.min(state.louversOpeningInput / 100, 0.92);
      const activeLouvers = state.directionRoof ? this.roof.louverX : this.roof.louverY;
      const activeList = activeLouvers.filter(l => l.active);
      const totalLouvers = activeList.length;

      if (totalLouvers > 0) {
        const openRadians = 90 * (Math.PI / 180);

        if (state.retractOption === 'oneSide') {
          const stackX = -halfWidth + 0.32;
          const stackSpacing = 0.022;
          
          activeList.forEach((l, i) => {
            const originalX = l.object.position.x;
            const stackedX = stackX + (i * stackSpacing);

            // Slide from original to stacked based on slider
            l.object.position.x = originalX + (stackedX - originalX) * openPercent;
            l.object.rotation.set(0, 0, -(openRadians));

            // Counter-rotate connecting bar if alpine
            if (alpineLouver) {
              l.object.traverse((child) => {
                if (child.name.startsWith("connecting_bar")) {
                  child.rotation.set(0, 0, openRadians);
                }
              });
            }
          });
        } else {
          const midIndex = Math.floor(totalLouvers / 2);
          const stackLeftX = -halfWidth + 0.33;
          const stackRightX = halfWidth - 0.30;
          const stackSpacing = 0.022;

          activeList.forEach((l, i) => {
            const originalX = l.object.position.x;
            let stackedX;

            if (i < midIndex) {
              stackedX = stackLeftX + (i * stackSpacing);
            } else {
              stackedX = stackRightX - ((totalLouvers - 1 - i) * stackSpacing);
            }

            l.object.position.x = originalX + (stackedX - originalX) * openPercent;
            l.object.rotation.set(0, 0, -(openRadians));

            if (alpineLouver) {
              l.object.traverse((child) => {
                if (child.name.startsWith("connecting_bar")) {
                  child.rotation.set(0, 0, openRadians);
                }
              });
            }
          });
        }
      }
    }
  }

  rebuildLouverPool() {
    this.roof.louverX.forEach(l => {
      this.changeObjectVisibility(false, l.object);
      if (l.object.parent) l.object.parent.remove(l.object);
    });
    this.roof.louverY.forEach(l => {
      this.changeObjectVisibility(false, l.object);
      if (l.object.parent) l.object.parent.remove(l.object);
    });
    this.roof.louverX = [];
    this.roof.louverY = [];

    this.prepareLouvereds();
  }

  setBeamsPosition(points, array, rafter, rotate = false) {
    const beams = array;

    for (let i = 0; i < points.length; i++) {
      const beamPoint = points[i];
      const element = beams[i];

      if (element == null) {
        return;
      }

      if (rafter) {
        element.object.position.x = beamPoint.x;
      } else {
        element.object.position.z = beamPoint.z;
      }

      if (rotate) {
        element.object.rotation.y = Math.PI;
      }

      element.active = true;
      element.object.visible = true;
      this.changeObjectVisibility(true, element.object);
    }
  }

  setPosts() {
    if (this.post.postFL) this.post.postFL.visible = true;
    if (this.post.postFR) this.post.postFR.visible = true;
    if (this.post.postBL) this.post.postBL.visible = !state.backWall;
    if (this.post.postBR) this.post.postBR.visible = !state.backWall;


    this.changePostVisibility(false, "leftCenter", true);
    this.changePostVisibility(false, "rightCenter", true);
    this.changePostVisibility(false, "frontCenter", true);
    this.changePostVisibility(false, "backCenter", true);
    this.changePostVisibility(false, "centerCenter", true);

    const { FL_point, FR_point, RL_point, RR_point } = this.getCornerPoints();
    const { point_post_width, point_post_length } = this.getPostPoints();

    // console.log(point_post_width, point_post_length);

    const pointForCorner = [
      !pergola.settings.backWall ? RL_point : {},
      !pergola.settings.backWall ? RR_point : {},
    ];

    this.setPostsPosition("leftCenter", point_post_length, true);
    this.setPostsPosition("rightCenter", point_post_length, true);

    if (!state.backWall) {
      this.setPostsPosition("backCenter", point_post_width, true);
    }

    this.setPostsPosition("frontCenter", point_post_width, true);

    // center column
    if (point_post_width.length && point_post_length.length) {
      const posts = this.post.centerCenter;

      for (let i = 0; i < point_post_width.length; i++) {
        const point = point_post_width[i];

        for (let j = 0; j < point_post_length.length; j++) {
          const pointZ = point_post_length[j].z;

          const element = this.getAvaliableObjectFromOneArray(posts);

          element.object.position.x = point.x;
          element.object.position.z = pointZ;

          this.changeObjectVisibility(true, element.object);
          element.active = true;
        }
      }
    }
  }

  setCenterPosts() {
    const prefix = `post_${state.postSize === 0 ? "100" : "150"}_retr`;
    const otherPrefix = `post_${state.postSize === 0 ? "150" : "100"}_retr`;

    const showCentral = ((state.roofType === 1) && (state.width >= 5 || state.length >= 4));

    const showFC = showCentral;
    const showBC = showCentral;
    const showCY = showCentral;
    const showCX = false;

    scene.traverse((o) => {
      // Skip clones created by clonePostObject — they are managed by setPosts()
      if (o.userData && o.userData.isPostClone) return;

      if (o.name === `${prefix}_FC`) {
        o.visible = showFC;
        o.traverse((child) => { child.visible = showFC; });
      }
      if (o.name === `${prefix}_BC`) {
        o.visible = showBC;
        o.traverse((child) => { child.visible = showBC; });
      }
      if (o.name === `${prefix}_C_y`) {
        o.visible = showCY;
        o.traverse((child) => { child.visible = showCY; });
      }
      if (o.name === `${prefix}_C_x`) {
        o.visible = showCX;
        o.traverse((child) => { child.visible = showCX; });
      }
      if (o.name === `${otherPrefix}_FC` || o.name === `${otherPrefix}_BC` ||
        o.name === `${otherPrefix}_C_y` || o.name === `${otherPrefix}_C_x`) {
        o.visible = false;
        o.traverse((child) => { child.visible = false; });
      }
    });
  }

  setCentralBeam() {
    const hasCentral = ((state.roofType === 1) && (state.width >= 5 || state.length >= 4));
    const beamName = state.directionRoof ? "mid_beam_retr_x" : "mid_beam_retr_y";

    scene.traverse((o) => {
      if (o.name === "mid_beam_retr_x" || o.name === "mid_beam_retr_y") {
        const shouldShow = hasCentral && o.name === beamName;
        o.visible = shouldShow;
        o.traverse((child) => { child.visible = shouldShow; });
      }
    });
  }

  getAvaliableObjectFromOneArray(objects, propertyName = null, propertyValue = null) {
    for (let i = 0; i < objects.length; i++) {
      const element = objects[i];
      if (!element.active) {
        element.active = true;
        return element;
      }
    }

    // if no inactive element = create a new clone
    let type = null;
    if (objects === this.roof.louverY) type = "louverY";
    else if (objects === this.roof.louverX) type = "louverX";

    if (type) {
      const source = this.getRoofElement(type);
      if (!source) {
        console.warn("No source mesh found for", type);
        return undefined;
      }

      const clone = source.clone();
      clone.visible = false;

      const parent = scene.getObjectByName("Scene");
      if (parent) {
        parent.add(clone);
      } else {
        scene.add(clone);
      }

      // clone morphs registering
      clone.traverse((child) => {
        if (child.isMesh && child.morphTargetInfluences) {
          const dict = child.morphTargetDictionary;
          if (dict) {
            // for Alpine Roof bar
            const isConnBar = child.name.startsWith("connecting_bar") ||
              (child.parent && child.parent.name.startsWith("connecting_bar"));

            Object.keys(dict).forEach(key => {
              if (isConnBar && key === "width") return;
              morphs.push({ name: key, key: dict[key], object: child });
            });
          }
        }
      });

      const newElement = { object: clone, active: true };
      objects.push(newElement);
      return newElement;
    }

    return undefined;
  }

  setPostsPosition(nameArray, points, side = false) {
    const posts = this.post[nameArray];

    for (let i = 0; i < points.length; i++) {
      const point = points[i];
      const element = posts[i];

      if (element == null) {
        return;
      }

      if (!side) {
        element.object.position.set(point.x, point.y, point.z);
      } else {
        switch (nameArray) {
          case "leftCenter":
            element.object.position.z = point.z;
            // element.object.position.x = -point.x;

            break;

          case "rightCenter":
            element.object.position.z = point.z;
            // element.object.position.x = point.x;

            break;

          case "backCenter":
            element.object.position.x = point.x;
            // element.object.position.z = -point.z;

            break;

          case "frontCenter":
            element.object.position.x = point.x;
            // element.object.position.z = point.z;

            break;
        }
      }

      console.log(element);

      this.changeObjectVisibility(true, element.object);
      element.active = true;
    }
  }

  clonePostObject(count, side) {
    const element = this.getPost(side);

    if (!element) {
      return;
    }

    for (let i = 0; i < count; i++) {
      const clonedMesh = element.clone();
      clonedMesh.visible = false;
      clonedMesh.userData = { ...clonedMesh.userData, isPostClone: true };
      const parent = scene.getObjectByName("Scene");

      if (parent) {
        parent.add(clonedMesh);
      } else {
        scene.add(clonedMesh);
      }

      const postObject = new PergolaPostObject();
      postObject.name = element.name;
      postObject.object = clonedMesh;
      postObject.place = side;
      this.post[side].push(postObject);
    }
  }

  getPostNamePrefix() {
    const size = state.postSize === 0 ? "100" : "150";
    return `post_${size}_retr`;
  }

  getPost(side) {
    if (this.post == null) return;

    const prefix = this.getPostNamePrefix();
    let targetName;

    switch (side) {
      case "frontCenter":
        targetName = `${prefix}_FC`;
        break;
      case "backCenter":
        targetName = `${prefix}_BC`;
        break;
      case "leftCenter":
        targetName = `${prefix}_FL`;
        break;
      case "rightCenter":
        targetName = `${prefix}_FR`;
        break;
      case "centerCenter":
        targetName = state.directionRoof
          ? `${prefix}_C_y`
          : `${prefix}_C_x`;
        break;
    }

    let element;
    model.traverse((o) => {
      if (o.name === targetName && !element) {
        element = o;
      }
    });

    return element;
  }

  cloneLouveredObject(count) {
    var element = this.roof.louvered.objects[0];
    if (element == null) {
      return;
    }

    for (let index = 0; index < count; index++) {
      var clonedMesh = element.object.clone();
      clonedMesh.visible = false;

      var parent = scene.getObjectByName("Scene");

      if (parent != null) {
        parent.add(clonedMesh);
      } else {
        scene.add(clonedMesh);
      }

      var louveredObject = new PergolaRoofTypeLouveredObject();
      louveredObject.object = clonedMesh;

      this.roof.louvered.objects.push(louveredObject);
    }
  }

  cloneBeamObject(direction, count, isFanBeam = false) {
    var element = this.roof.beams.find(
      (item) => item.isFanBeam == isFanBeam && item.direction == direction
    );
    if (element == null) {
      return;
    }

    for (let index = 0; index < count; index++) {
      var clonedMesh = element.object.clone();
      clonedMesh.visible = false;

      var parent = scene.getObjectByName("Scene");

      if (parent != null) {
        parent.add(clonedMesh);
      } else {
        scene.add(clonedMesh);
      }

      var beamObject = new PergolaRoofBeam();
      beamObject.direction = direction;
      beamObject.object = clonedMesh;
      beamObject.isFanBeam = isFanBeam;

      this.roof.beams.push(beamObject);
    }
  }

  cloneFrameObject(count) {
    const element = this.roof.frames[0];
    if (element == null) {
      return;
    }

    for (let index = 0; index < count; index++) {
      const clonedMesh = element.object.clone();
      clonedMesh.visible = false;

      const parent = scene.getObjectByName("Scene");

      if (parent != null) {
        parent.add(clonedMesh);
      } else {
        scene.add(clonedMesh);
      }

      const frameObject = new PergolaRoofFrame();
      frameObject.object = clonedMesh;

      this.roof.frames.push(frameObject);
    }
  }

  cloneExtraOptionObject(type, count) {
    var element = this.extraOptions.elements.find((item) => item.type == type);
    if (element == null && type != PergolaExtraOptionType.moodLight) {
      return;
    }

    if (type != PergolaExtraOptionType.moodLight) {
      for (let index = 0; index < count; index++) {
        var extraOptionElement = new PergolaExtraOptionElement();
        extraOptionElement.type = element.type;

        var clonedMesh = element.object.clone();
        clonedMesh.visible = false;

        if (["Android", "iOS", "VisionPro"].includes(currentOS)) {
          if (type == PergolaExtraOptionType.light) {
            for (let l = 0; l < clonedMesh.children.length; l++) {
              const element = clonedMesh.children[l];
              if (!element.isLight) {
                continue;
              }
              pointLights.push(element);
            }
          }

          if (type == PergolaExtraOptionType.led) {
            for (let l = 0; l < clonedMesh.children.length; l++) {
              const element = clonedMesh.children[l];
              if (!element.isLight) {
                continue;
              }
              ledLights.push(element);
            }
          }

          if (type == PergolaExtraOptionType.moodLed) {
            for (let l = 0; l < clonedMesh.children.length; l++) {
              const element = clonedMesh.children[l];
              if (!element.isLight) {
                continue;
              }
              moodLeds.push(element);
            }
          }
        }

        var parent = scene.getObjectByName("Scene");

        if (parent != null) {
          parent.add(clonedMesh);
        } else {
          scene.add(clonedMesh);
        }

        extraOptionElement.object = clonedMesh;

        this.extraOptions.elements.push(extraOptionElement);
      }
    } else {
      // MOOD LIGHT
      for (let i = 0; i < count; i++) {
        const extraOptionElement = new PergolaExtraOptionElement();
        extraOptionElement.type = type;

        for (let j = 0; j < 4; j++) {
          const rectLight = new THREE.RectAreaLight(0xffffff, 1, 1, 0.05);
          rectLight.power = 3;
          rectLight.visible = false;

          // scene.add(new RectAreaLightHelper(rectLight)); //! TEMP for test

          const parent = scene.getObjectByName("Scene");
          if (parent != null) {
            parent.add(rectLight);
          } else {
            scene.add(rectLight);
          }

          extraOptionElement.objects[j] = rectLight;
        }
        this.extraOptions.elements.push(extraOptionElement);
      }
    }
  }

  prepareLouvereds() {
    // const count = 209; // 629;
    // this.cloneLouveredObject(count);
  }

  prepareOptions() {
    this.cloneInObject("heatersBack", 8 * 4);
    this.cloneInObject("fansBeamX", 8 * 4);
    this.cloneInObject("fansBeamY", 8 * 4);
  }

  cloneInObject(
    type = "baseBeams",
    count,
    needToAdd = true,
    parentName = "Scene"
  ) {
    const element = this.getRoofElement(type);

    if (!element) {
      return;
    }

    for (let i = 0; i < count; i++) {
      const clonedMesh = element.clone();
      clonedMesh.visible = false;
      const parent = scene.getObjectByName(parentName);
      if (needToAdd && parent) {
        parent.add(clonedMesh);
      }
      if (needToAdd && !parent) {
        scene.add(clonedMesh);
      }

      const roofObject = new PergolaRoofObject();
      roofObject.name = element.name;
      roofObject.type = element.type;
      roofObject.object = clonedMesh;
      this[type].push(roofObject);
    }
  }

  prepareRoof() {
    const prepareCountBeam = 5;
    const prepareCountLouver =
      Math.ceil((MORPH_DATA.width.max) / 0.17989) * 5;

    this.cloneRoofObject("headerLed", 1);

    // BEAM
    this.cloneRoofObject("beamX", prepareCountBeam);
    this.cloneRoofObject("beamXLed", prepareCountBeam);

    this.cloneRoofObject("beamY", prepareCountBeam);
    this.cloneRoofObject("beamYLed", prepareCountBeam);

    // LOUVER
    this.cloneRoofObject("louverY", prepareCountLouver);
    this.cloneRoofObject("louverX", prepareCountLouver);

    this.cloneRoofObject("solidRoof", 1);

    this.cloneRoofObject("pointLED", 500);
    this.cloneRoofObject("rampLEDX", 100);
    this.cloneRoofObject("rampLEDY", 100);
  }

  cloneRoofObject(
    type = "baseBeams",
    count,
    needToAdd = true,
    parentName = "Scene"
  ) {
    const element = this.getRoofElement(type);

    if (!element) {
      return;
    }

    for (let i = 0; i < count; i++) {
      const clonedMesh = element.clone();
      clonedMesh.visible = false;
      const parent = scene.getObjectByName(parentName);
      if (needToAdd && parent) {
        parent.add(clonedMesh);
        RegisterMorphsForObject(clonedMesh);
      }
      if (needToAdd && !parent) {
        scene.add(clonedMesh);
      }

      const roofObject = new PergolaRoofObject();
      roofObject.name = element.name;
      roofObject.type = element.type;
      roofObject.object = clonedMesh;
      this.roof[type].push(roofObject);
    }
  }

  animateGroup(group, startAnimation, animationStates) {
    const child = group.children[2] || group;
    //console.log(child);

    if (!child) return;

    const isAnimating = animationStates.get(group);

    if (startAnimation) {
      if (isAnimating) return;
      animationStates.set(group, true);

      const rotateChild = () => {
        if (!animationStates.get(group)) return;
        child.rotation.y += 0.05;
        child.rotation.y %= Math.PI * 2;
        requestAnimationFrame(rotateChild);
      };

      rotateChild();
    } else {
      animationStates.set(group, false);
    }
  }

  getRoofElement(type = "beams", name = null) {
    let element;

    //BEAM
    if (type === "beamX") {
      model.traverse((o) => {
        if (o.name === "beam_x") {
          element = o;
          console.log(o, "BEAM");
        }
      });
    }

    if (type === "beamY") {
      model.traverse((o) => {
        if (o.name === "beam_Y") {
          element = o;
        }
      });
    }

    if (type === "louverY") {
      const meshName = getLouverMeshNames(state.roofType, state.louvreType, "y");
      model.traverse((o) => {
        if (o.name === meshName) {
          element = o;
        }
      });
    }
    if (type === "louverX") {
      const meshName = getLouverMeshNames(state.roofType, state.louvreType, "x");
      model.traverse((o) => {
        if (o.name === meshName) {
          element = o;
        }
      });
    }

    // if (type === "pointLED") {
    //   model.traverse((o) => {
    //     if (o.name === "light_spot") {
    //       element = o;
    //     }
    //   });
    // }
    // if (type === "rampLEDX") {
    //   model.traverse((o) => {
    //     if (o.name === "light_conduit_x") {
    //       element = o;
    //     }
    //   });
    // }
    // if (type === "rampLEDY") {
    //   model.traverse((o) => {
    //     if (o.name === "light_conduit_y") {
    //       element = o;
    //     }
    //   });
    // }

    // if (type === "heatersFront") {
    //   model.traverse((o) => {
    //     if (o.name === "horizontal_heater_black") {
    //       element = o;
    //     }
    //   });
    // }
    if (type === "heatersBack") {
      model.traverse((o) => {
        if (o.name === "horizontal_heater_black") {
          element = o;
        }
      });
    }

    // if (type === "fansBeamX") {
    //   model.traverse((o) => {
    //     if (o.name === "beam_x_fan") {
    //       element = o;
    //     }
    //   });
    // }

    // if (type === "fansBeamY") {
    //   model.traverse((o) => {
    //     if (o.name === "beam_Y_fan") {
    //       element = o;
    //     }
    //   });
    // }

    if (type === "solidRoof") {
      model.traverse((o) => {
        if (o.name === "solid_roof") {
          element = o;
        }
      });
    }

    if (type === "headerLed") {
      model.traverse((o) => {
        if (o.name === "header_LED") {
          element = o;
        }
      });
    }

    if (type === "beamXLed") {
      model.traverse((o) => {
        if (o.name === "beam_x_LED") {
          element = o;
        }
      });
    }

    if (type === "beamYLed") {
      model.traverse((o) => {
        if (o.name === "beam_Y_LED") {
          element = o;
        }
      });
    }

    return element;
  }

  prepareBeams() {
    const count = 2;
    this.cloneBeamObject(PergolaRoofDirection.Straight, count + 1, false);
    this.cloneBeamObject(PergolaRoofDirection.Perpendicular, count, false);
    this.cloneBeamObject(PergolaRoofDirection.Straight, 17, true);
  }

  prepareFrames() {
    const count = 1; // 17;
    this.cloneFrameObject(count);
  }

  prepareExtraOptions() {
    const count_heater = 4;
    const count_led = 5; // 17;
    const count_mood = 6; // 18;
    const count_mood_led = 5; // 17;
    const count_light = 103; // 320;

    this.cloneExtraOptionObject(PergolaExtraOptionType.heater, count_heater);
    this.cloneExtraOptionObject(PergolaExtraOptionType.led, count_led);
    this.cloneExtraOptionObject(PergolaExtraOptionType.moodLight, count_mood);
    this.cloneExtraOptionObject(PergolaExtraOptionType.moodLed, count_mood_led);
    this.cloneExtraOptionObject(PergolaExtraOptionType.light, count_light);


    const fanObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.fan
    );
    rotateFans(fanObjects, autoRotateSpeed);
  }

  editSystem(span) {
    if (!span) {
      return;
    }
    const system = span.getCurrentSystem();
    if (!system) {
      return;
    }

    state.lastSpan = span;
    this.settings.currentSpan = span;
    this.settings.currentSubsystem = system;
    this.settings.currentSubsystemKey = system.name;

    triggerIconClick(system.type);
  }

  checkSystemInScene(typeSys, side = false) {
    return this.span.objects.some((span) =>
      span.systems.some((system) => {
        const isCorrectSide = this.checkSide(side, system.side);

        const compareGul = this.checkSystemType(typeSys, system.type);

        return system.active && compareGul && isCorrectSide;
      })
    );
  }

  checkSide(side, systemSide) {
    if (side === pergolaConst.side.Back) {
      return (
        systemSide === pergolaConst.side.Back ||
        systemSide === pergolaConst.side.Front
      );
    } else if (side === pergolaConst.side.Left) {
      return (
        systemSide === pergolaConst.side.Left ||
        systemSide === pergolaConst.side.Right
      );
    } else {
      return true;
    }
  }

  checkSystemType(typeSys, systemType) {
    return systemType === typeSys;
  }

  getLastActiveSpan(typeSys) {
    return this.span.objects.filter(
      (span) => span.isSystemSet && span.activeSystemType === typeSys
    );
  }

  checkSystemInAllSpans(typeSys) {
    return this.span.objects.some(
      (span) => span.isSystemSet && span.activeSystemType === typeSys
    );
  }

  resetSpans() {
    const spans = this.span.objects;
    for (let i = 0; i < spans.length; i++) {
      if (spans[i].isSystemSet) continue;
      spans[i].avatar.visible = false;
      spans[i].active = false;
      spans[i].isLocked = false;
    }
  }

  getSpanPoints() {
    const offsetX = -0.15;
    const offsetZ = -0.15; // зміщення по осі Z для Front/Back
    const offsetWidth = 0.159;
    const offsetDepth = 0.315;
    const offsetBackZ = 0;

    const { FL_point, FR_point, RL_point, RR_point } = this.getCornerPoints(
      offsetX,
      offsetZ
    );

    // const FL_post_point = FL_point.clone().add(
    //   new THREE.Vector3(0, 0, offsetZ) // Зміщуємо тільки по осі Z для фронту
    // );
    // const FR_post_point = FR_point.clone().add(
    //   new THREE.Vector3(offsetX, 0, 0) // Зміщуємо тільки по осі Z для фронту
    // );
    // const RL_post_point = RL_point.clone().add(
    //   new THREE.Vector3(0, 0, -offsetZ) // Зміщуємо тільки по осі Z для задньої частини
    // );
    // const RR_post_point = RR_point.clone().add(
    //   new THREE.Vector3(offsetX, 0, 0) // Зміщуємо тільки по осі Z для задньої частини
    // );

    const widthInterval = state.postWidthInterval;
    const depthInterval = state.postDepthInterval;
    const currentWidth = state.width;
    const currentDepth = state.length;

    const front_span_points = generateCenterMidpoints(
      FL_point,
      FR_point,
      Math.floor(currentWidth / widthInterval),
      true
    );
    const back_span_points = generateCenterMidpoints(
      RL_point.clone().add(new THREE.Vector3(0, 0, offsetBackZ)),
      RR_point.clone().add(new THREE.Vector3(0, 0, offsetBackZ)),
      Math.floor(currentWidth / widthInterval),
      true
    );
    const left_span_points = generateCenterMidpoints(
      FL_point,
      RL_point,
      Math.floor(currentDepth / depthInterval),
      true
    );
    const right_span_points = generateCenterMidpoints(
      FR_point,
      RR_point,
      Math.floor(currentDepth / depthInterval),
      true
    );

    const { point_post_length, point_post_width } = this.getPostPoints();
    // const { zAligned, xAligned } = this.getCornerPairs();

    function calculateDistance(point1, point2, correct) {
      const adjustedPoint1 = point1;
      const adjustedPoint2 = point2;

      let distance = Math.sqrt(Math.pow(adjustedPoint2 - adjustedPoint1, 2));

      if (correct) {
        const additionalOffset = 0.2;
        distance -= additionalOffset;
      }

      return distance;
    }

    const lenghtPoints = [FR_point, ...point_post_length, RR_point];
    const widthPoints = [FL_point, ...point_post_width, FR_point];

    const span_width = calculateDistance(widthPoints[0].x, widthPoints[1].x);
    const span_depth = calculateDistance(lenghtPoints[0].z, lenghtPoints[1].z);

    // console.log(span_width, span_depth, "CONSOLE LOG SPAN SIZE");

    return {
      front_span_points,
      back_span_points,
      left_span_points,
      right_span_points,
      span_width,
      span_depth,
    };
  }

  showAvailableSpans() {
    if (
      state.currentActiveSystems !== null &&
      state.currentActiveSystems !== undefined
    ) {
      const spans = this.span.objects;

      for (let i = 0; i < spans.length; i++) {
        setHotspotVisibility(spans[i].hotspot, spans[i].active);
      }
    }
  }

  outlineAvatar(object, active, animate = true) {
    if (!object) {
      return;
    }
    if (active && object.visible) {
      return;
    }
    if (!active && !object.visible) {
      return;
    }

    if (!active) {
      object.material.opacity = 0;
      object.material.needsUpdate = true;
      object.visible = false;
    } else {
      object.visible = true;

      if (animate) {
        object.material.opacity = 0;
        object.material.needsUpdate = true;
        animateProperty(
          object.material,
          "opacity",
          spanOpacity + 0.2,
          250,
          () => {
            object.material.needsUpdate = true;
          }
        );
      } else {
        object.material.opacity = spanOpacity + 0.2;
        object.material.needsUpdate = true;
      }
    }
  }

  //#region SPAN LOGIC

  putCurrentMenuSystemToCurrentSpan(span) {
    const currentSubsystem = state.currentActiveSystems;
    const targetSide = span.side;

    this.span.objects.forEach((otherSpan) => {
      if (otherSpan.side === targetSide) {
        otherSpan.activeSystemType = null;
        otherSpan.systems.forEach((system) => {
          const usedByOtherSide = this.span.objects.some(
            (s) => s.side !== targetSide && s.isSystemSet && s.activeSystemType === system.type && s.systems.includes(system)
          );
          if (!usedByOtherSide) {
            system.active = false;
            system.activeSide = null;
            this.changeObjectVisibility(false, system.object);
          }
        });
        otherSpan.isSystemSet = false;
      }
    });

    const activeSystem = span.systems.find((system) => {
      return system.type === currentSubsystem;
    });

    if (activeSystem) {
      activeSystem.active = true;
      activeSystem.activeSide = targetSide;
      state.currentActiveSystems = activeSystem.type;
      span.activeSystemType = currentSubsystem;
      span.isSystemSet = true;
      span.isLocked = true;
      this.changeObjectVisibility(true, activeSystem.object);

      state.subSystemUrl.add({
        spanNumber: span.number,
        type: activeSystem.type,
        side: targetSide,
      });
    }

    this.update();
  }

  putCurrentMenuSystemToAllFreeSpans() {
    const currentSubsystem = this.settings.currentSubsystem;
    const spans = this.span.objects;

    spans.forEach((span) => {
      if (span.active && !span.isSystemSet) {
        span.systems.forEach((system) => {
          system.active = false;
          this.changeObjectVisibility(false, system.object);
          this.changeObjectVisibility(false, system.windowObject);
        });

        const activeSystem = span.systems.find((system) => {
          return system.type === currentSubsystem;
        });

        if (activeSystem) {
          activeSystem.active = true;
          span.active = false;
          span.isSystemSet = true;
          this.changeObjectVisibility(true, activeSystem.object);
        }
      }
    });

    this.update();
  }

  getSpanBySideAndNumber(side, number) {
    return this.span.objects.find(
      (span) => span.side === side && span.number === number
    );
  }

  removeSystemFromSpanType(type) {
    const spans = this.span.objects;
    const sidesToRemove = new Set();
    spans.forEach(span => {
      if (span.isSystemSet && span.activeSystemType === type) {
        sidesToRemove.add(span.side);
      }
    });

    sidesToRemove.forEach(side => {
      const clonesToRemove = [];
      scene.traverse((o) => {
        // Sliding doors
        if (o.userData?.clonedDoor && o.userData?.doorSide === side) {
          clonesToRemove.push(o);
        }
        // shutters
        if (o.userData?.clonedShutter && o.userData?.shutterSide === side) {
          clonesToRemove.push(o);
        }
        // blinds
        if (o.userData?.clonedShade && o.userData?.shadeSide === side) {
          clonesToRemove.push(o);
        }
      });
      clonesToRemove.forEach(c => c.parent?.remove(c));
    });

    spans.forEach(span => {
      span.systems.forEach(system => {
        if (system && system.type === type) {
          system.active = false;
          system.openingside = true;
          system.openValue = 0;
          if (system.object) this.changeObjectVisibility(false, system.object);
        }
      });
      if (span.isSystemSet && span.activeSystemType === type && sidesToRemove.has(span.side)) {
        span.active = true;
        span.isLocked = false;
        span.isSystemSet = false;
        span.activeSystemType = null;
      }
    });
    this.update();
  }

  removeSystemFromSpan(spanRef) {
    // spanRef (state.lastSpan) may be stale after a setSpans() call — resolve to the live object
    const span = this.span.objects.find(
      (s) => s.side === spanRef.side && s.number === spanRef.number
    ) || spanRef;

    const type = span.activeSystemType;
    if (type === null || type === undefined) return;

    const side = span.side;
    const clonesToRemove = [];

    scene.traverse((o) => {
      if (o.userData?.clonedDoor && o.userData?.doorSide === side) clonesToRemove.push(o);
      if (o.userData?.clonedShutter && o.userData?.shutterSide === side) clonesToRemove.push(o);
      if (o.userData?.clonedShade && o.userData?.shadeSide === side) clonesToRemove.push(o);
    });
    clonesToRemove.forEach(c => c.parent?.remove(c));

    span.systems.forEach(system => {
      if (system && system.type === type) {
        system.active = false;
        system.openingside = true;
        system.openValue = 0;
        if (system.object) this.changeObjectVisibility(false, system.object);
        if (system.windowObject) this.changeObjectVisibility(false, system.windowObject);
      }
    });

    span.active = true;
    span.isLocked = false;
    span.isSystemSet = false;
    span.activeSystemType = null;

    this.update();
  }

  //#endregion

  setSpans() {
    const {
      front_span_points,
      back_span_points,
      left_span_points,
      right_span_points,
      span_width,
      span_depth,
    } = this.getSpanPoints();

    if (state.backWall) {
      this.span.objects.forEach((span) => {
        if (span.side === pergolaConst.side.Back) {
          span.isSystemSet = false;
          span.isLocked = false;
          span.systems.forEach((s) => { if (s) s.active = false; });
        }
      });
    }

    this.resetSpans();

    const height = getHeightMorph(state.height) * 3.0 + 0.5;
    const offsetZ =
      this.originZ == pergolaConst.side.Front ? (state.length * 0.0254) / 2 : 0;

    const configureSpan = (points, side, width, thickness) => {
      points.forEach((point, pointIndex) => {
        const span = this.getSpan(side);

        if (!span) {
          return;
        }

        span.active = span.isSystemSet ? false : true;

        if (
          (state.backWall && side === pergolaConst.side.Back)
        ) {
          span.active = false;
          span.isSystemSet = false;
          span.systems.forEach((system) => {
            if (!system) return;
            system.active = false;
            if (system.object) this.changeObjectVisibility(false, system.object);
          });
        }

        if (!span.isLocked && !span.isSystemSet) {
          span.isSystemSet = false;
          span.systems.forEach((system) => {
            if (!system) return;
            system.active = false;
            if (system.object) this.changeObjectVisibility(false, system.object);
          });
        }

        span.posX = point.x;
        span.posZ = point.z;
        span.width = width;
        span.height = height;

        if (span.systems.length > 0) {
          span.systems.forEach((system) => {
            if (system && system.object) {
              // console.log(span.posX, span.posY, span.posZ);
              system.object.position.set(span.posX, span.posY, span.posZ);
              system.spanWidth = width;
              system.spanHeight = height;
            }
          });
        }

        span.avatar.position.set(span.posX, span.height / 2, span.posZ);
        span.avatar.scale.set(
          side === pergolaConst.side.Left || side === pergolaConst.side.Right
            ? thickness
            : width,
          span.height,
          side === pergolaConst.side.Left || side === pergolaConst.side.Right
            ? width
            : thickness
        );
        span.avatar.visible = false;

        span.hotspot.position.set(span.posX, -1.0, span.posZ);
        setHotspotVisibility(span.hotspot, false);

        span.hotspot.setHoverFunction(() => {
          this.outlineAvatar(span.avatar, true);
        });

        span.hotspot.setNormalFunction(() => {
          this.outlineAvatar(span.avatar, false);
        });

        span.hotspot.setClickFunction(() => {
          state.lastSpan = span;
          this.putCurrentMenuSystemToCurrentSpan(span);
          triggerIconClick(state.currentActiveSystems);
        });

      });
    };

    configureSpan(
      front_span_points,
      pergolaConst.side.Front,
      span_width,
      spanAvatarThickness
    );
    configureSpan(
      back_span_points,
      pergolaConst.side.Back,
      span_width,
      spanAvatarThickness
    );
    configureSpan(
      left_span_points,
      pergolaConst.side.Left,
      span_depth,
      spanAvatarThickness
    );
    configureSpan(
      right_span_points,
      pergolaConst.side.Right,
      span_depth,
      spanAvatarThickness
    );

    this.checkAllSpans();

    if (state.backWall) {
      const backClones = [];
      scene.traverse(o => {
        if ((o.userData?.clonedDoor && o.userData?.doorSide === pergolaConst.side.Back) ||
          (o.userData?.clonedShutter && o.userData?.shutterSide === pergolaConst.side.Back) ||
          (o.userData?.clonedShade && o.userData?.shadeSide === pergolaConst.side.Back)) {
          backClones.push(o);
        }
      });
      backClones.forEach(o => o.parent?.remove(o));
    }
  }

  checkAllSpans() {
    const spans = this.span.objects;
    spans.forEach((span) => {
      if (!span.isLocked && !span.isSystemSet) {
        span.isSystemSet = false;
        span.systems.forEach((system) => {
          if (!system) return;
          system.active = false;
          if (system.object) this.changeObjectVisibility(false, system.object);
          if (system.windowObject) this.changeObjectVisibility(false, system.windowObject);
        });
      }
    });
  }

  getSpan(side) {
    const spans = this.span.objects;

    for (let i = 0; i < spans.length; i++) {
      const span = spans[i];

      if (span.side === side && !span.isLocked) {
        span.isLocked = true;
        return span;
      }
    }

    return null;
  }

  updateHotspots() {

    this.span.objects.forEach(span => {
      setHotspotVisibility(span.hotspot, false);
    });

    const sides = [pergolaConst.side.Left, pergolaConst.side.Right, pergolaConst.side.Front, pergolaConst.side.Back];
    const hw = state.width / 2;
    const hl = state.length / 2;

    const _fbSides = [pergolaConst.side.Front, pergolaConst.side.Back];
    const _lrSides = [pergolaConst.side.Left, pergolaConst.side.Right];
    const _isNarrow = state.width === 1 || state.length === 1;
    const _fbHasSystem = this.span.objects.some(s => _fbSides.includes(s.side) && s.isSystemSet);
    const _lrHasSystem = this.span.objects.some(s => _lrSides.includes(s.side) && s.isSystemSet);

    sides.forEach(side => {
      if (state.backWall && side === pergolaConst.side.Back) return;

      const sideHasSystem = this.span.objects.some(s => s.side === side && s.isSystemSet);
      const _isFB = _fbSides.includes(side);
      const isBlockedByNarrow = _isNarrow && (_isFB ? _lrHasSystem : _fbHasSystem);
      let firstShown = false;

      this.span.objects.forEach(span => {
        if (span.side === side) {
          if (!firstShown && !sideHasSystem && !isBlockedByNarrow && state.currentActiveSystems !== null) {
            const centerX = side === pergolaConst.side.Left ? -hw
              : side === pergolaConst.side.Right ? hw
                : 0;
            const centerZ = side === pergolaConst.side.Front ? hl
              : side === pergolaConst.side.Back ? -hl
                : 0;

            span.hotspot.position.set(centerX, -1.0, centerZ);
            setHotspotVisibility(span.hotspot, true);

            const self = this;
            span.hotspot.setClickFunction(() => {
              state.lastSpan = span;
              self.putCurrentMenuSystemToCurrentSpan(span);
              triggerIconClick(state.currentActiveSystems);
            });

            firstShown = true;
          }
        }
      });
    });
  }

  async update() {
    this.changeDimensions(state.width, state.length, state.height);
    this.switchFrame();
    this.setCenterPosts();
    this.setCentralBeam();
    this.setPosts();
    this.setRoofBeam();
    this.setLouver();

    if (state.heaters && window.updateHeaterVisibility) {
      window.updateHeaterVisibility(true);
    }

    if (window.updateSlidingRangesMax) {
      window.updateSlidingRangesMax();
    }

    this.setOptions();

    if (state.width < 1 && this.span.objects.some(s => s.isSystemSet)) {
      removeAllSubsystems();
    }

    if (state.width === 1 || state.length === 1) {
      const _fbSides = [pergolaConst.side.Front, pergolaConst.side.Back];
      const _lrSides = [pergolaConst.side.Left, pergolaConst.side.Right];
      const _fbHas = this.span.objects.some(s => _fbSides.includes(s.side) && s.isSystemSet);
      const _lrHas = this.span.objects.some(s => _lrSides.includes(s.side) && s.isSystemSet);
      if (_fbHas && _lrHas) removeAllSubsystems();
    }

    const savedSystems = [];
    this.span.objects.forEach((span) => {
      if (span.isSystemSet) {
        savedSystems.push({
          side: span.side,
          activeType: span.activeSystemType,
          isSystemSet: true,
          isLocked: true
        });
      }
    });

    this.setSpans();

    savedSystems.forEach((saved) => {
      if (state.backWall && saved.side === pergolaConst.side.Back) return;

      const span = this.span.objects.find((s) => s.side === saved.side);
      if (!span) return;

      span.isSystemSet = true;
      span.isLocked = true;
      span.activeSystemType = saved.activeType;
    });

    this.updateSubsystems();

    this.updateHotspots();
    WriteURLParameters();
    this.updateLogoPositions();

    if (window.updateBackWall) {
      window.updateBackWall();
    }

    requestDelayedRender();
  }

  reset() {
    //this.changeDimensions(8, 8);
  }

  changeWallMaterials() {
    const backWall = GetGroup("wall_back");
    const leftWall = GetGroup("wall_L");
    const rightWall = GetGroup("wall_R");

    const applyTextures = state.typePergola;

    const wallTextures = TEXTURES.inner.wallCommercial;

    [backWall, leftWall, rightWall].forEach((wall) => {
      wall.children.forEach((group) => {
        group.traverse((object) => {
          if (object.isMesh) {
            const material = object.material;

            if (!material.userData.originalMap) {
              material.userData.originalMap = material.map;
              material.userData.originalNormalMap = material.normalMap;
              material.userData.originalRoughnessMap = material.roughnessMap;
            }

            if (applyTextures) {
              setMaterialTexture(wall, [material.name], wallTextures, 0.4);
            } else {
              material.map = material.userData.originalMap;
              material.normalMap = material.userData.originalNormalMap;
              material.roughnessMap = material.userData.originalRoughnessMap;

              material.needsUpdate = true;
            }
          }
        });
      });
    });
  }

  setAddOptionWall() {
    ChangeGlobalMorph("on_roof", 0);

    $("#wall-option").show();

    if (state.wallOption) {
      $("#back").addClass("active");

      state.backWall = true;

      ChangeGlobalMorph("on_roof", 0.7);
    }
  }

  setColor() { }

  rgbToHex(rgb) {
    // Перевірка на формат rgb або rgba
    var result = rgb.match(/^rgba?\((\d+), (\d+), (\d+)(?:, (\d+\.?\d*))?\)$/);

    if (result) {
      var r = parseInt(result[1]);
      var g = parseInt(result[2]);
      var b = parseInt(result[3]);

      // Перетворення значень RGB в HEX
      var hex =
        "#" +
        ((1 << 24) | (r << 16) | (g << 8) | b)
          .toString(16)
          .slice(1)
          .toUpperCase();

      return hex;
    }

    // Якщо значення не підходить, просто повертаємо порожній рядок
    return null;
  }

  changeMountingWall(back, left, right, isPostsDepend = true) {
    this.changeMountingWallVisibility(back, PergolaElementOrientSide.Back);
    this.changeMountingWallVisibility(left, PergolaElementOrientSide.Left);
    this.changeMountingWallVisibility(right, PergolaElementOrientSide.Right);

    isPostsDepend && this.changePostVisibility(true, null, false);

    if (back) {
      this.changePostVisibility(false, PergolaPostSide.RL, false);
      this.changePostVisibility(false, PergolaPostSide.RR, false);
      this.changePostVisibility(false, PergolaPostSide.BC, true);
      this.lastSettings.mountingWall_Back = this.settings.mountingWall_Back;
    }

    if (left) {
      this.changePostVisibility(false, PergolaPostSide.RL, false);
      this.changePostVisibility(false, PergolaPostSide.FL, false);
      this.changePostVisibility(false, PergolaPostSide.LC, true);
      this.lastSettings.mountingWall_Left = this.settings.mountingWall_Left;
    }

    if (right) {
      this.changePostVisibility(false, PergolaPostSide.RR, false);
      this.changePostVisibility(false, PergolaPostSide.FR, false);
      this.changePostVisibility(false, PergolaPostSide.RC, true);
      this.lastSettings.mountingWall_Right = this.settings.mountingWall_Right;
    }
  }

  getAvaliableExtraLightObject(objects) {
    for (let index = 0; index < objects.length; index++) {
      const element = objects[index];
      if (element.active == true) {
        continue;
      }
      return element;
    }
  }

  getAvaliableObjectFromArray(objects) {
    for (let index = 0; index < objects.length; index++) {
      const element = objects[index];
      if (element.active == true) {
        continue;
      }
      return element;
    }
    return null;
  }

  // calculateExtraLightObjects(objects, mainPoints, pos1, pos2, dimension, interval = 7, numP = 0, useCenterMethod = false) {
  //   if (mainPoints.length > 0) {

  //     var mainPoints2 = generateMidpoints(pos1, pos2, Math.floor(dimension / 16), true);
  //     for (let i = 0; i < mainPoints2.length; i++) {

  //       if (i + 1 >= mainPoints2.length) { continue; }

  //       var point1 = mainPoints2[i];
  //       var point2 = mainPoints2[i + 1];
  //       var points = null;
  //       if (useCenterMethod == false) {
  //         points = generateMidpoints(point1, point2, numP <= 0 ? Math.floor(dimension / (mainPoints.length) / interval) : numP);
  //       } else {
  //         points = generateCenterMidpoints(point1, point2, numP <= 0 ? Math.floor(dimension / (mainPoints.length) / interval) : numP, true);
  //       }

  //       for (let w = 0; w < points.length; w++) {
  //         const point = points[w];
  //         const index = i * mainPoints2.length + w;

  //         if (index < objects.length) {
  //           const element = this.getAvaliableExtraLightObject(objects);

  //           element.object.position.x = point.x;

  //           switch (this.settings.postSize) {
  //             case PergolaPostType._4x4:
  //               element.object.position.y = 2.337;
  //               break;
  //             case PergolaPostType._7x7:
  //               element.object.position.y = 2.286;
  //               break;
  //             case PergolaPostType._8x8:
  //               element.object.position.y = 2.234;
  //               break;
  //             default:
  //               element.object.position.y = 2.286;
  //               break;
  //           }

  //           element.object.position.z = point.z;

  //           if (element.object.isGroup) {
  //             for (let index = 0; index < element.object.children.length; index++) {
  //               const obj = element.object.children[index];
  //               obj.visible = true;
  //             }
  //             element.object.visible = true;
  //             element.active = true;
  //           } else {
  //             element.object.visible = true;
  //             element.active = true;
  //           }
  //         } else {
  //           console.warn(`The element with index ${index} does not exist in the objects array.`);
  //         }
  //       }
  //     }
  //   } else {
  //     var points = generateMidpoints(pos1, pos2, Math.floor(dimension / interval));

  //     for (let w = 0; w < points.length; w++) {
  //       const point = points[w];

  //       const index = w;

  //       if (index < objects.length) {
  //         const element = this.getAvaliableExtraLightObject(objects);

  //         element.object.position.x = point.x;

  //         switch (this.settings.postSize) {
  //           case PergolaPostType._4x4:
  //             element.object.position.y = 2.337;
  //             break;
  //           case PergolaPostType._7x7:
  //             element.object.position.y = 2.286;
  //             break;
  //           case PergolaPostType._8x8:
  //             element.object.position.y = 2.234;
  //             break;
  //           default:
  //             element.object.position.y = 2.286;
  //             break;
  //         }

  //         element.object.position.z = point.z;

  //         if (element.object.isGroup) {
  //           for (let index = 0; index < element.object.children.length; index++) {
  //             const obj = element.object.children[index];
  //             obj.visible = true;
  //           }
  //           element.object.visible = true;
  //           element.active = true;
  //         } else {
  //           element.object.visible = true;
  //           element.active = true;
  //         }
  //       } else {
  //         console.warn(`The element with index ${index} does not exist in the objects array.`);
  //       }
  //     }
  //   }
  // }

  cloneMaterialTexture(name) {
    if (this.theModel == null) {
      return;
    }
    var mat = null;
    this.theModel.traverse((o) => {
      if (o.isMesh) {
        if (o.material.name == name) {
          mat = o.material;
          if (mat.map != null) {
            mat.map = mat.map.clone();
          }
        }
      }
    });
  }

  changeMaterialTilling(name, x, y) {
    if (this.theModel == null) {
      return;
    }
    var mat = null;
    this.theModel.traverse((o) => {
      if (o.isMesh) {
        if (o.material.name == name) {
          mat = o.material;
          if (mat.map != null) {
            mat.map.repeat.set(x, y);
          }
        }
      }
    });
  }

  changeMaterialOffset(name, x, y) {
    if (this.theModel == null) {
      return;
    }
    var mat = null;
    this.theModel.traverse((o) => {
      if (o.isMesh) {
        if (o.material.name == name) {
          mat = o.material;
          if (mat.map != null) {
            mat.map.offset.set(x, y);
          }
        }
      }
    });
  }

  changeExtraOptions() {
    const fanObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.fan
    );
    const heaterObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.heater
    );
    const fanBeams = this.roof.beams.filter((item) => item.isFanBeam === true);
    const lightObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.light
    );
    const ledObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.led
    );
    const moodLightObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.moodLight
    );
    const moodLedsObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.moodLed
    );

    this.changeObjectArrayVisibility(false, fanObjects);
    this.changeObjectArrayVisibility(false, heaterObjects);
    this.changeObjectArrayVisibility(false, fanBeams);
    this.changeObjectArrayVisibility(false, ledObjects);
    this.changeObjectArrayVisibility(false, moodLedsObjects);
    this.changeObjectArrayVisibility(false, lightObjects);
    this.changeMoodLightsVisibility(false, moodLightObjects);

    const { framesPoints } = this.getFramesPoints();

    //! HEATERS
    if (this.settings.extraOptionHeaters) {
      const { FL_point, FR_point, RL_point, RR_point } = this.getCornerPoints();
      const heaterOffset = 0.2;
      const heaterHight = this.totalHeight - 0.3;

      FL_point.x += heaterOffset;
      FL_point.y = heaterHight;
      FL_point.z -= heaterOffset;
      FR_point.x -= heaterOffset;
      FR_point.y = heaterHight;
      FR_point.z -= heaterOffset;
      RL_point.x += heaterOffset;
      RL_point.y = heaterHight;
      RL_point.z += heaterOffset;
      RR_point.x -= heaterOffset;
      RR_point.y = heaterHight;
      RR_point.z += heaterOffset;

      let leftPoints = [];
      let rightPoints = [];
      let frontPoints = [];
      let rearPoints = [];

      if (this.dimensions.length > this.settings.postLengthInterval) {
        leftPoints = generateMidpoints(FL_point, RL_point, 3, false);
        rightPoints = generateMidpoints(FR_point, RR_point, 3, false);
        leftPoints.splice(1, 1);
        rightPoints.splice(1, 1);
      } else {
        leftPoints = generateMidpoints(FL_point, RL_point, 1, false);
        rightPoints = generateMidpoints(FR_point, RR_point, 1, false);
      }

      if (this.dimensions.width > this.settings.postWidthInterval) {
        frontPoints = generateMidpoints(FL_point, FR_point, 3, false);
        rearPoints = generateMidpoints(RL_point, RR_point, 3, false);
        frontPoints.splice(1, 1);
        rearPoints.splice(1, 1);
      } else {
        frontPoints = generateMidpoints(FL_point, FR_point, 1, false);
        rearPoints = generateMidpoints(RL_point, RR_point, 1, false);
      }

      function setHeaters(points, rotationAngle) {
        points.forEach((point) => {
          const heater = this.getAvaliableObjectFromArray(heaterObjects);
          heater.object.position.set(point.x, point.y, point.z);
          heater.object.rotation.y = THREE.MathUtils.degToRad(rotationAngle);
          this.changeObjectVisibility(true, heater.object);
          heater.active = true;
        });
      }

      setHeaters.call(this, leftPoints, 90);
      setHeaters.call(this, rightPoints, -90);
      setHeaters.call(this, frontPoints, 180);
      setHeaters.call(this, rearPoints, 0);

      // this.lastSettings.extraOptionLight = this.settings.extraOptionLight;
    }

    //! LED STRIPS
    if (this.settings.extraOptionLed) {
      for (let index = 0; index < framesPoints.length; index++) {
        const point = framesPoints[index];
        const ledStrip = this.getAvaliableObjectFromArray(ledObjects);
        // console.log("🚀 ~ ledStrip:", ledStrip);
        ledStrip.object.position.x = point.x;
        ledStrip.object.position.z = point.z;
        this.changeObjectVisibility(true, ledStrip.object);
        ledStrip.active = true;
      }
    }

    //! POINTLIGHTS
    if (this.settings.extraOptionLight) {
      const minLightQty = this.getPointLightpositions(8).length;
      const maxLightQty = this.getPointLightpositions(2).length;

      const lightGap = this.settings.extraOptionLightSpacing;

      const lightPoints = this.getPointLightpositions(lightGap);
      const pointY = 2.185;

      for (let i = 0; i < lightPoints.length; i++) {
        const element = lightObjects[i];
        const light = element.object;
        light.position.set(lightPoints[i].x, pointY, lightPoints[i].z);
        // light.children[1].material.emissiveIntensity = 3;
        element.active = true;
        this.changeObjectVisibility(true, light);
      }

      this.lastSettings.extraOptionFan = this.settings.extraOptionFan;
    }
  }

  changeDimensions(width = null, length = null, height = null) {

    const { span_width, span_depth } = this.getSpanPoints();

    // ── Height offset for zip open calculation ──
    let offset = 0;
    let offsetNegative = 0;

    if (height >= 2.7 && height < 3.0) {
      offsetNegative = 0.1; offset = 0.14;
    } else if (height >= 3.0 && height < 3.2) {
      offsetNegative = 0.1; offset = 0.28;
    } else if (height >= 3.2 && height < 3.4) {
      offsetNegative = 0.1; offset = 0.43;
    } else if (height >= 3.4) {
      offsetNegative = 0.1; offset = 0.57;
    }

    let openZip = this.interpolateValue(
      +state.zipInput, 1, 100, 0 - offsetNegative, 1 + offset
    );

    const widthRange = state.roofType === 1 ? MORPH_DATA.retractable.width : MORPH_DATA.opening.width;
    const lengthRange = state.roofType === 1 ? MORPH_DATA.retractable.length : MORPH_DATA.opening.length;

    const targetWidth = ConvertMorphValue(width, widthRange.min, widthRange.max);
    const targetLength = ConvertMorphValue(length, lengthRange.min, lengthRange.max);
    const targetHeight = ConvertMorphValue(height, MORPH_DATA.height.min, MORPH_DATA.height.max);

    // ── Subsystem morph values ──
    const targetWidthSystem = ConvertMorphValue(span_width - 0.1, 0.879818, 4.87655);
    const targetLengthSystem = ConvertMorphValue(span_depth - 0.1, 0.879818, 4.87655);
    const targetWidthFrame = ConvertMorphValue(span_width - 0.1, 0.879106, 4);
    const targetLengthFrame = ConvertMorphValue(span_depth - 0.1, 0.879106, 4);
    const targetWidthShatters = ConvertMorphValue(span_width - 0.1, 0.879106, 6);
    const targetLengthShatters = ConvertMorphValue(span_depth - 0.1, 0.879106, 6);
    const targetWidthFixSlats = ConvertMorphValue(span_width, 0.9144, 3.6576);
    const targetLengthFixSlats = ConvertMorphValue(span_depth, 0.9144, 3.6576);

    // ════════════════════════════════════════════════════════════════════
    // SHARED MORPHS 
    // ════════════════════════════════════════════════════════════════════
    ChangeGlobalMorph("width", targetWidth);
    ChangeGlobalMorph("lenth", targetLength);
    ChangeGlobalMorph("height", getHeightMorph(state.height));

    // Wall morphs
    ChangeGlobalMorph("width_wall", targetWidth);
    ChangeGlobalMorph("length_wall", targetLength);
    ChangeGlobalMorph("height_wall", targetHeight);

    // Subsystem morphs (shades, doors, shutters)
    ChangeGlobalMorph("privacy_width", targetWidthFixSlats);
    ChangeGlobalMorph("privacy_lenth", targetLengthFixSlats);
    ChangeGlobalMorph("width_shades", targetWidthSystem);
    ChangeGlobalMorph("height_shades", targetHeight);
    ChangeGlobalMorph("height_shades_side", targetHeight);
    ChangeGlobalMorph("length_shades_side", targetLengthSystem);
    ChangeGlobalMorph("width_sl-doors_frame", targetWidthFrame);
    ChangeGlobalMorph("length_sl-doors_frame_side", targetLengthFrame);
    ChangeGlobalMorph("width_bi-doors_frame", targetWidthShatters);
    ChangeGlobalMorph("length_bi-doors_frame_side", targetLengthShatters);
    ChangeGlobalMorph("width_fix_shutters_frame", targetWidthShatters);
    ChangeGlobalMorph("length_fix_shutters_frame", targetLengthShatters);
    ChangeGlobalMorph("width_sl-shutters_frame", targetWidthShatters);
    ChangeGlobalMorph("length_sl-shutters_frame", targetLengthShatters);
    ChangeGlobalMorph("width_bifold_shutters_frame", targetWidthShatters);
    ChangeGlobalMorph("length_bifold_shutters_frame", targetLengthShatters);

    // Zip open/close
    ChangeGlobalMorph("close_shades_side", openZip);
    ChangeGlobalMorph("close_shades", openZip);

    // ════════════════════════════════════════════════════════════════════
    // POST MORPHS — roof-type-dependent
    // ════════════════════════════════════════════════════════════════════
    if (state.roofType === 0) {
      // Opening 
      ChangeGlobalMorph("frame_pivot", 1); //= transition morph
      ChangeGlobalMorph("frame_pivot_y_width", targetWidth);
      ChangeGlobalMorph("frame_pivot_y_lenth", targetLength);
      ChangeGlobalMorph("lenth_frame_y", targetLength);
      ChangeGlobalMorph("lenth_frame_x", 0);
      ChangeGlobalMorph("frame_pivot_x_width", 0);
      ChangeGlobalMorph("frame_pivot_x_lenth", 0);
      ChangeGlobalMorph("frame_retr_y_width", 0);
      ChangeGlobalMorph("frame_retr_y_lenth", 0);
      ChangeGlobalMorph("frame_retr_x_width", 0);
      ChangeGlobalMorph("frame_retr_x_lenth", 0);
    } else {
      // Retractable
      ChangeGlobalMorph("frame_pivot", 0);
      ChangeGlobalMorph("frame_retr_y_width", targetWidth);
      ChangeGlobalMorph("frame_retr_y_lenth", targetLength);
      ChangeGlobalMorph("lenth_frame_y", targetLength);
      ChangeGlobalMorph("lenth_frame_x", 0);
      if (state.roofType === 1 && state.postSize === 1) {
        const lenthFrameX150 = getLenthFrameX150Morph(length);

        scene.traverse((obj) => {
          if (!obj.isMesh || !obj.morphTargetDictionary) return;

          // Target only FC/BC central post
          const morphIndex = obj.morphTargetDictionary["lenth_frame_x"];
          if (morphIndex === undefined) return;

          // Extra check: only 150×150 post objects
          if (!obj.userData.postSize150 && !obj.name.includes("150")) return;

          obj.morphTargetInfluences[morphIndex] = lenthFrameX150;
        });
      }
      ChangeGlobalMorph("frame_retr_x_width", 0);
      ChangeGlobalMorph("frame_retr_x_lenth", 0);
      ChangeGlobalMorph("frame_pivot_x_width", 0);
      ChangeGlobalMorph("frame_pivot_x_lenth", 0);
      ChangeGlobalMorph("frame_pivot_y_width", 0);
      ChangeGlobalMorph("frame_pivot_y_lenth", 0);
    }
  }

  updateWallTilling(height, valueX, valueY, valueZ) {
    let wallBackTillingX = ConvertMorphValueReverse(
      valueX,
      1,
      9,
      0,
      0.6296296296296297
    );
    let wallSideTillingZ = ConvertMorphValueReverse(
      valueZ,
      1,
      5,
      0,
      0.6296296296296297
    );

    const wallSideTillingY = ConvertMorphValueReverse(valueY, 1, 1.703, 0, 1);
    const wallBackTillingY = ConvertMorphValueReverse(valueY, 1, 3.34, 0, 1);

    this.changeMaterialTilling("wall_side", wallSideTillingZ, wallSideTillingY);
    this.changeMaterialOffset(
      "wall_side",
      0.0,
      WALL_OFFSETS[`height_${height}`].sideWallOffsetY
    );

    this.changeMaterialTilling("wall_tile", wallBackTillingX, wallBackTillingY);
    this.changeMaterialOffset(
      "wall_tile",
      0.0,
      WALL_OFFSETS[`height_${height}`].backWallOffsetY
    );
  }

  changePostSupport() {
    this.changePostVisibility(false, null, true);
    const FC_Post = this.getPostObject(null, PergolaPostSide.FC);
    const BC_Post = this.getPostObject(null, PergolaPostSide.BC);
    const LC_Post = this.getPostObject(null, PergolaPostSide.LC);
    const RC_Post = this.getPostObject(null, PergolaPostSide.RC);
    const CC_Post = this.getPostObject(null, PergolaPostSide.CC);

    if (this.dimensions.width > this.settings.postWidthInterval) {
      FC_Post.visible = true;
      BC_Post.visible = true;
    } else {
      FC_Post.visible = false;
      BC_Post.visible = false;
    }

    if (this.dimensions.length > this.settings.postLengthInterval) {
      LC_Post.visible = true;
      RC_Post.visible = true;
    } else {
      LC_Post.visible = false;
      RC_Post.visible = false;
    }

    if (
      this.dimensions.width > this.settings.postWidthInterval &&
      this.dimensions.length > this.settings.postLengthInterval
    ) {
      CC_Post.visible = true;
    } else {
      CC_Post.visible = false;
    }
  }

  getSystem(name = null, type = null, direction = null, side = null) {
    if (this.system == null) {
      return;
    }
    if (this.system.objects == null) {
      return;
    }
    if (!this.system.objects) {
      return;
    }

    for (let i = 0; i < this.system.objects.length; i++) {
      const element = this.system.objects[i];

      if (name != null) {
        if (element.name != name) {
          continue;
        }
      }
      if (type != null) {
        if (element.type != type) {
          continue;
        }
      }
      if (direction != null) {
        if (element.direction != direction) {
          continue;
        }
      }
      if (side != null) {
        if (element.side != side) {
          continue;
        }
      }

      return element;
    }
  }

  cloneSystemObject(type, direction, side, count) {
    const element = this.getSystem(null, type, direction);

    if (!element) {
      return;
    }

    for (let i = 0; i < count; i++) {
      const clonedMesh = element.object.clone();
      clonedMesh.visible = false;
      const parent = scene.getObjectByName("Scene");

      if (parent) {
        parent.add(clonedMesh);
      } else {
        scene.add(clonedMesh);
      }

      if (side === pergolaConst.side.Right || side === pergolaConst.side.Back) {
        clonedMesh.scale.z = -1;
      }

      const systemObject = new PergolaSystemObject();
      systemObject.name = element.name;
      systemObject.object = clonedMesh;
      systemObject.type = type;
      systemObject.direction = direction;
      systemObject.side = side;

      this.system.objects.push(systemObject);
    }
  }

  prepareSystems() {
    const qtySpansWidth = 3;
    const qtySpansDepth = 3;

    //#region FRONT SIDE
    this.cloneSystemObject(
      pergolaConst.systemType.autoShade,
      pergolaConst.direction.Straight,
      pergolaConst.side.Front,
      qtySpansWidth - 1
    );
    this.cloneSystemObject(
      pergolaConst.systemType.privacyWall,
      pergolaConst.direction.Straight,
      pergolaConst.side.Front,
      qtySpansWidth - 1
    );
    //#endregion

    //#region BACK SIDE
    this.cloneSystemObject(
      pergolaConst.systemType.autoShade,
      pergolaConst.direction.Straight,
      pergolaConst.side.Back,
      qtySpansWidth
    );
    this.cloneSystemObject(
      pergolaConst.systemType.privacyWall,
      pergolaConst.direction.Straight,
      pergolaConst.side.Back,
      qtySpansWidth
    );
    //#endregion

    //#region LEFT SIDE
    this.cloneSystemObject(
      pergolaConst.systemType.autoShade,
      pergolaConst.direction.Perpendicular,
      pergolaConst.side.Left,
      qtySpansDepth - 1
    );
    this.cloneSystemObject(
      pergolaConst.systemType.privacyWall,
      pergolaConst.direction.Perpendicular,
      pergolaConst.side.Left,
      qtySpansDepth - 1
    );
    //#endregion

    //#region RIGHT SIDE
    this.cloneSystemObject(
      pergolaConst.systemType.autoShade,
      pergolaConst.direction.Perpendicular,
      pergolaConst.side.Right,
      qtySpansDepth
    );
    this.cloneSystemObject(
      pergolaConst.systemType.privacyWall,
      pergolaConst.direction.Perpendicular,
      pergolaConst.side.Right,
      qtySpansDepth
    );
    //#endregion
  }

  getSubsystemByTypeAndSide(type, side) {
    let searchSide = side;
    if (side === pergolaConst.side.Right) searchSide = pergolaConst.side.Left;
    if (side === pergolaConst.side.Back) searchSide = pergolaConst.side.Front;

    return this.system.objects.find(
      (system) => system.type === type && system.side === searchSide
    );
  }

  prepareSpans() {
    const spanColor = "#629A33";

    const qtyLeft = 3;
    const qtyRight = qtyLeft;
    const qtyFront = 3;
    const qtyBack = qtyFront;

    const spanGeometry = new THREE.BoxGeometry(1, 1, 1);
    const makeSpanBySide = (side, qty) => {
      for (let i = 0; i < qty; i++) {
        const span = new PergolaSpanObject();
        span.side = side;
        span.number = i;
        const spanMaterial = new THREE.MeshBasicMaterial({
          color: spanColor,
          transparent: true,
          depthWrite: false,
          opacity: 0,
        });
        const spanAvatar = new THREE.Mesh(spanGeometry, spanMaterial);
        spanAvatar.position.set(span.posX, span.posY, span.posZ);
        spanAvatar.visible = false;

        spanAvatar.name = `avatar_${side}_${i}`;
        spanAvatar.parentSpan = span;
        clickableObjects.push(spanAvatar);

        theModel.add(spanAvatar);
        span.avatar = spanAvatar;

        span.hotspot = createHotspot(
          `span_hotspot_${side}_${i}`,
          labelObjects.addObject.url,
          labelObjects.addObjectHover.url,
          new THREE.Vector3(0, 0, 0),
          "subsystems"
        );

        setHotspotVisibility(span.hotspot, false);
        hotspots.push(span.hotspot);

        const subsystems = [];

        Object.keys(pergolaConst.systemType).forEach((key) => {
          const sys = this.getSubsystemByTypeAndSide(
            pergolaConst.systemType[key],
            side
          );
          subsystems.push(sys);
        });

        if (subsystems.length > 0) {
          span.systems.push(...subsystems);
        }

        this.span.objects.push(span);
      }
    };

    makeSpanBySide(pergolaConst.side.Left, qtyLeft);
    makeSpanBySide(pergolaConst.side.Right, qtyRight);
    makeSpanBySide(pergolaConst.side.Front, qtyFront);
    makeSpanBySide(pergolaConst.side.Back, qtyBack);
  }

  changeBeamSupport() {
    this.changeBeamVisibility(false, null, null);

    const { FL_point, FR_point, RL_point } = this.getCornerPoints();

    const leftPoints = generateMidpoints(
      RL_point,
      FL_point,
      Math.floor(this.dimensions.length / this.settings.beamLengthInterval)
    );
    const frontPoints = generateMidpoints(
      FL_point,
      FR_point,
      Math.floor(this.dimensions.width / this.settings.beamWidthInterval)
    );

    if (this.dimensions.length > this.settings.beamPerimeterInterval) {
      const pointL = FL_point.clone();
      const pointR = FR_point.clone();
      pointL.x -= this.settings.beamThickness / 2;
      pointR.x += this.settings.beamThickness / 2;
      frontPoints.push(pointL, pointR);
    }

    if (this.dimensions.width > this.settings.beamPerimeterInterval) {
      leftPoints.push(RL_point, FL_point);
    }

    //* LEFT
    if (leftPoints.length > 0) {
      this.changeSupportBeamPositions(
        PergolaRoofDirection.Straight,
        leftPoints,
        null,
        0
      );
    }

    //* FRONT
    if (frontPoints.length > 0) {
      this.changeSupportBeamPositions(
        PergolaRoofDirection.Perpendicular,
        frontPoints,
        0,
        null
      );
    }
  }

  changeSupportBeamPositions(
    direction,
    points,
    x = null,
    y = null,
    height = null
  ) {
    const beams = this.roof.beams.filter(
      (item) => item.direction == direction && item.isFanBeam === false
    );

    for (let index = 0; index < points.length; index++) {
      const point = points[index];
      const element = this.getAvaliableObjectFromArray(beams);

      element.object.position.x = y == null ? point.x : y;

      if (height != null) {
        element.object.position.y = height;
      }

      element.object.position.z = x == null ? point.z : x;
      element.object.visible = true;
      element.active = true;
    }
  }

  changeMoodLightParameters(moodLightObjects, color) {
    const { mainBeamQty, leftPoints, frontPoints, framesPoints } =
      this.getFramesPoints();
    const framesPerGap = (leftPoints.length - 1) / (mainBeamQty + 1);
    const delta = this.settings.beamThickness / framesPerGap;
    const frameWidth = frontPoints[0].distanceTo(frontPoints[1]);
    const frameLength = leftPoints[0].distanceTo(leftPoints[1]) - delta;
    const moodOffset = 0.04;

    for (let i = 0; i < framesPoints.length; i++) {
      const element = moodLightObjects[i];

      for (let j = 0; j < element.objects.length; j++) {
        const light = element.objects[j];
        light.color = new THREE.Color(color);
        light.position.y = this.totalHeight - 0.2;

        if (j == 0) {
          light.position.x = framesPoints[i].x;
          light.position.z = framesPoints[i].z - frameLength / 2 + moodOffset;
          light.width = frameWidth - moodOffset * 2;
          light.rotation.y = THREE.MathUtils.degToRad(180);
          light.visible = frameLength < frameWidth;
        } else if (j == 1) {
          light.position.x = framesPoints[i].x + frameWidth / 2 - moodOffset;
          light.position.z = framesPoints[i].z;
          light.width = frameLength - moodOffset * 2;
          light.rotation.y = THREE.MathUtils.degToRad(90);
          light.visible = frameLength >= frameWidth;
        } else if (j == 2) {
          light.position.x = framesPoints[i].x;
          light.position.z = framesPoints[i].z + frameLength / 2 - moodOffset;
          light.width = frameWidth - moodOffset * 2;
          light.visible = frameLength < frameWidth;
        } else if (j == 3) {
          light.position.x = framesPoints[i].x - frameWidth / 2 + moodOffset;
          light.position.z = framesPoints[i].z;
          light.width = frameLength - moodOffset * 2;
          light.rotation.y = THREE.MathUtils.degToRad(-90);
          light.visible = frameLength >= frameWidth;
        }
      }
    }
  }

  getPointLightpositions(lightGap) {
    const { FL_point, FR_point, RL_point, RR_point } = this.getCornerPoints();
    const { mainBeamQty, leftPoints, frontPoints } = this.getFramesPoints();
    const framesPerGap = (leftPoints.length - 1) / (mainBeamQty + 1);
    const delta = this.settings.beamThickness / framesPerGap;
    const frameWidth = frontPoints[0].distanceTo(frontPoints[1]);
    const frameLength = leftPoints[0].distanceTo(leftPoints[1]) - delta;

    // const pointY = 2.45; // for testing
    const postOffset = 0.04;

    // Perimeter beams

    function calculatePerimeterPostPoints(
      startPoint,
      endPoint,
      dimensionValue,
      postInterval
    ) {
      if (dimensionValue > postInterval) {
        const q = Math.floor(dimensionValue / postInterval);
        return generateMidpoints(startPoint, endPoint, q, true);
      } else {
        return [startPoint, endPoint];
      }
    }

    const FLRL_postPoints = this.settings.mountingWall_Left
      ? []
      : calculatePerimeterPostPoints(
        FL_point,
        RL_point,
        this.dimensions.length,
        this.settings.postLengthInterval
      );
    const FLFR_postPoints = calculatePerimeterPostPoints(
      FL_point,
      FR_point,
      this.dimensions.width,
      this.settings.postWidthInterval
    );
    const FRRR_postPoints = this.settings.mountingWall_Right
      ? []
      : calculatePerimeterPostPoints(
        FR_point,
        RR_point,
        this.dimensions.length,
        this.settings.postLengthInterval
      );
    const RLRR_postPoints = this.settings.mountingWall_Back
      ? []
      : calculatePerimeterPostPoints(
        RL_point,
        RR_point,
        this.dimensions.width,
        this.settings.postWidthInterval
      );

    function calculatePointsBetweenPosts(postPoints, gap) {
      const points = [];
      if (postPoints.length <= 1) {
        return points;
      }

      for (let i = 0; i < postPoints.length - 1; i++) {
        let qty =
          Math.round(
            postPoints[i].distanceTo(postPoints[i + 1]) / (gap * 0.3048)
          ) - 1;
        if (qty < 1) {
          qty = 1;
        }
        points.push(
          generateMidpoints(postPoints[i], postPoints[i + 1], qty, false)
        );
      }

      return points;
    }

    let FLRL_points = calculatePointsBetweenPosts(
      FLRL_postPoints,
      lightGap
    ).flat();
    let FLFR_points = calculatePointsBetweenPosts(
      FLFR_postPoints,
      lightGap
    ).flat();
    let FRRR_points = calculatePointsBetweenPosts(
      FRRR_postPoints,
      lightGap
    ).flat();
    let RLRR_points = calculatePointsBetweenPosts(
      RLRR_postPoints,
      lightGap
    ).flat();

    setValueToCoordinates(FLRL_points, "x", FL_point.x + postOffset);
    setValueToCoordinates(FLFR_points, "z", FL_point.z - postOffset);
    setValueToCoordinates(FRRR_points, "x", FR_point.x - postOffset);
    setValueToCoordinates(RLRR_points, "z", RL_point.z + postOffset);

    const perimeterLightPoints = [
      ...FLRL_points,
      ...FLFR_points,
      ...FRRR_points,
      ...RLRR_points,
    ].flat();

    const vertCrossQty = Math.round(this.totalLength / frameLength) - 1;
    const horiCrossQty = Math.round(this.totalWidth / frameWidth) - 1;
    const vertCrossPoints = generateMidpoints(
      FL_point,
      RL_point,
      vertCrossQty,
      true
    );
    const horiCrossPoints = generateMidpoints(
      FL_point,
      FR_point,
      horiCrossQty,
      true
    );

    if (
      this.dimensions.width > this.settings.postWidthInterval &&
      this.dimensions.length > this.settings.postLengthInterval
    ) {
      if (vertCrossPoints.length % 2 === 0) {
        const middleIndex = vertCrossPoints.length / 2;
        vertCrossPoints.splice(middleIndex, 0, new THREE.Vector3(0, 0, 0));
      }
    }

    // Vertical beams
    let vertLightPoints = [];
    for (let i = 1; i < horiCrossPoints.length - 1; i++) {
      if (horiCrossPoints.length <= 2) {
        break;
      }
      setValueToCoordinates(vertCrossPoints, "x", horiCrossPoints[i].x);
      vertLightPoints.push(
        ...calculatePointsBetweenPosts(vertCrossPoints, lightGap)
      );
    }

    // Horisontal beams
    let horiLightPoints = [];

    if (
      this.dimensions.width > this.settings.postWidthInterval &&
      this.dimensions.length > this.settings.postLengthInterval
    ) {
      if (vertCrossPoints.length % 2 !== 0) {
        const middleIndex = Math.floor(vertCrossPoints.length / 2);
        vertCrossPoints.splice(middleIndex, 1);
      }
    }

    for (let i = 1; i < vertCrossPoints.length - 1; i++) {
      if (vertCrossPoints.length <= 2) {
        break;
      }
      setValueToCoordinates(horiCrossPoints, "z", vertCrossPoints[i].z);
      horiLightPoints.push(
        ...calculatePointsBetweenPosts(horiCrossPoints, lightGap)
      );
    }

    const allLightPoints = [
      ...perimeterLightPoints,
      ...vertLightPoints,
      ...horiLightPoints,
    ].flat();

    return allLightPoints;
  }

  getCornerPoints(xOffset = 0, zOffset = 0) {
    const offsetX = xOffset;
    const offsetZ = zOffset;
    const totalWidth = state.width;
    const totalDepth = state.length;

    const lineZback = -totalDepth / 2;
    const lineZfront = totalDepth / 2;

    let FL_point = new THREE.Vector3(
      -totalWidth / 2 - offsetX / 2,
      0,
      lineZfront + offsetZ / 2
    );
    let FR_point = new THREE.Vector3(
      totalWidth / 2 + offsetX / 2,
      0,
      lineZfront + offsetZ / 2
    );
    let RL_point = new THREE.Vector3(
      -totalWidth / 2 - offsetX / 2,
      0,
      lineZback - offsetZ / 2
    );
    let RR_point = new THREE.Vector3(
      totalWidth / 2 + offsetX / 2,
      0,
      lineZback - offsetZ / 2
    );

    return { FL_point, FR_point, RL_point, RR_point };
  }

  getFramesPoints() {
    const { FL_point, FR_point, RL_point } = this.getCornerPoints();

    let pointsQty = Math.floor(
      this.dimensions.length / this.settings.beamLengthInterval
    );
    const gapsQty = pointsQty + 1;
    const gapLength = this.dimensions.length / gapsQty;
    const mainBeamQty = gapsQty - 1;

    if (gapLength > this.settings.beamLouverLengthInterval) {
      pointsQty =
        pointsQty +
        Math.floor(gapLength / this.settings.beamLouverLengthInterval) *
        gapsQty;
    }

    let leftPoints = generateMidpoints(FL_point, RL_point, pointsQty, true);
    let leftCenterPoints = generateCenterMidpoints(
      FL_point,
      RL_point,
      pointsQty,
      true
    );

    const framesPerGap = (leftPoints.length - 1) / (mainBeamQty + 1);
    const adjustmentValue = this.settings.beamThickness / 4;

    if (framesPerGap == 2 && leftCenterPoints.length % 2 === 0) {
      for (let i = 0; i < leftCenterPoints.length; i += 2) {
        leftCenterPoints[i].z -= adjustmentValue;
        leftCenterPoints[i + 1].z += adjustmentValue;
      }
    }

    const frontPoints = generateMidpoints(
      FL_point,
      FR_point,
      Math.floor(this.dimensions.width / this.settings.beamWidthInterval),
      true
    );
    const frontCenterPoints = generateCenterMidpoints(
      FL_point,
      FR_point,
      Math.floor(this.dimensions.width / this.settings.beamWidthInterval),
      true
    );

    let framesPoints = [];

    for (let i = 0; i < leftCenterPoints.length; i++) {
      for (let j = 0; j < frontCenterPoints.length; j++) {
        const point = new THREE.Vector3(
          frontCenterPoints[j].x,
          0,
          leftCenterPoints[i].z
        );
        framesPoints.push(point);
      }
    }

    return { mainBeamQty, leftPoints, frontPoints, framesPoints };
  }

  changeRoofFrame() {
    this.changeRoofFrameVisibility(false);

    const { mainBeamQty, leftPoints, frontPoints, framesPoints } =
      this.getFramesPoints();

    const framesPerGap = (leftPoints.length - 1) / (mainBeamQty + 1);
    const delta = this.settings.beamThickness / framesPerGap;
    const frameWidth = frontPoints[0].distanceTo(frontPoints[1]);
    const frameLength = leftPoints[0].distanceTo(leftPoints[1]) - delta;

    // this.changeFramePosition(framesPoints);

    const targetValueLength = ConvertMorphValue(
      frameLength,
      MORPH_DATA_SI.frameLength.min,
      MORPH_DATA_SI.frameLength.max
    );
    const targetValueWidth = ConvertMorphValue(
      frameWidth,
      MORPH_DATA_SI.frameWidth.min,
      MORPH_DATA_SI.frameWidth.max
    );

    ChangeGlobalMorph("length_louver", targetValueLength);
    ChangeGlobalMorph("width_louver", targetValueWidth);

    this.changeLouvers(frameWidth, framesPoints);
  }

  changeFramePosition(points, x = null, y = null, height = null) {
    const frames = this.roof.frames;

    for (let index = 0; index < points.length; index++) {
      const point = points[index];
      const element = this.getAvaliableObjectFromArray(frames);

      element.object.position.x = y == null ? point.x : y;
      if (height != null) {
        element.object.position.y = height;
      }
      element.object.position.z = x == null ? point.z : x;

      this.changeObjectVisibility(true, element.object);
      element.active = true;
    }
  }

  changeLouvers(frameWidth, framesPoints) {
    this.changeLouversVisibility(false);

    // const louverWidth = 0.17989;
    const louverWidth = 0.1677;
    const firstLouverOffset = 0.15;
    const louverQtyPerFrame =
      (frameWidth - firstLouverOffset + 0.03) / louverWidth;
    const louverQtyPerFrameRound = Math.floor(louverQtyPerFrame);
    const delta = louverQtyPerFrame - louverQtyPerFrameRound;
    const coveredWidth = louverQtyPerFrameRound * louverWidth;

    let loversPoints = [];

    for (let i = 0; i < framesPoints.length; i++) {
      let louverPointX =
        delta >= 0.5
          ? framesPoints[i].x - coveredWidth / 2 + 0.06
          : framesPoints[i].x - frameWidth / 2 + firstLouverOffset;

      const louverPointZ = framesPoints[i].z;

      for (let j = 0; j < louverQtyPerFrameRound; j++) {
        const point = new THREE.Vector3(louverPointX, 0, louverPointZ);
        loversPoints.push(point);
        louverPointX += louverWidth;
      }
    }

    const louverHeight = this.totalHeight - 0.125;
    this.changeLouversPosition(loversPoints, louverHeight);
  }

  changeLouversPosition(points, height = null, x = null, y = null) {
    const louvers = this.roof.louvered.objects;

    for (let index = 0; index < points.length; index++) {
      const point = points[index];
      const element = this.getAvaliableObjectFromArray(louvers);

      element.object.position.x = y == null ? point.x : y;
      if (height != null) {
        element.object.position.y = height;
      }
      element.object.position.z = x == null ? point.z : x;

      this.changeObjectVisibility(true, element.object);
      element.active = true;
    }
  }


  changePostColor(value) {
    if (value == null) {
      return;
    }

    for (let index = 0; index < this.post.objects.length; index++) {
      const element = this.post.objects[index];
      element.object.material.color.set(value);
      setMaterialColor("alum", value);
    }
  }

  changeLouverColor(value) {
    if (value == null) {
      return;
    }

    for (let index = 0; index < this.roof.louvered.objects.length; index++) {
      const element = this.roof.louvered.objects[index];
      element.object.material.color.set(value);
    }
  }

  changeLedColor(value) {
    if (value == null) {
      return;
    }

    const ledObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.led
    );

    ledObjects[0].object.material.color.set(value);
    ledObjects[0].object.material.emissive.set(value);
    // ledObjects[0].object.material.emissiveIntensity = 5;
  }

  changeMoodLedColor(value) {
    if (value == null) {
      return;
    }

    const moodLedObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.moodLed
    );

    moodLedObjects[0].object.material.color.set(value);
    moodLedObjects[0].object.material.emissive.set(value);
    // moodLedObjects[0].object.material.emissiveIntensity = 5;
  }

  getPostObject(name = null, postSide = null, isLock = null, isSupport = null) {
    if (this.post == null) {
      return;
    }
    if (this.post.objects == null) {
      return;
    }

    for (let index = 0; index < this.post.objects.length; index++) {
      const element = this.post.objects[index];

      if (name != null) {
        if (element.name != name) {
          continue;
        }
      }

      if (postSide != null) {
        if (element.side != postSide) {
          continue;
        }
      }

      if (isLock != null) {
        if (element.isLock != isLock) {
          continue;
        }
      }

      if (isSupport != null) {
        if (element.isSupport != isSupport) {
          continue;
        }
      }

      return element.object;
    }
  }

  changeRoofFrameVisibility(status, frameType = null) {
    if (this.roof == null) {
      return;
    }
    if (this.roof.frames == null) {
      return;
    }

    for (let index = 0; index < this.roof.frames.length; index++) {
      const element = this.roof.frames[index];

      if (frameType != null) {
        if (element.type != frameType) {
          continue;
        }
      }

      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const ge = element.object.children[index];
          ge.visible = status;
        }
      } else {
        element.object.visible = status;
      }

      element.active = status;
    }
  }

  changeLouversVisibility(status) {
    if (this.roof == null) {
      return;
    }
    if (this.roof.louvered == null) {
      return;
    }
    if (this.roof.louvered.objects == null) {
      return;
    }

    for (let index = 0; index < this.roof.louvered.objects.length; index++) {
      const element = this.roof.louvered.objects[index];

      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const ge = element.object.children[index];
          ge.visible = status;
        }
      } else {
        element.object.visible = status;
      }

      element.active = status;
    }
  }

  changeObjectVisibility(status, object) {
    if (object == null) {
      return;
    }

    object.visible = status;

    if (object.isGroup) {
      for (let index = 0; index < object.children.length; index++) {
        const ge = object.children[index];
        ge.visible = status;
      }
    }
  }

  changeMoodLightVisibility(status, element) {
    if (element == null) {
      return;
    }

    for (let i = 0; i < element.objects.length; i++) {
      element.objects[i].visible = status;

      if (element.objects[i].isGroup) {
        for (
          let index = 0;
          index < element.objects[i].children.length;
          index++
        ) {
          const ge = element.objects[i].children[index];
          ge.visible = status;
        }
      }
    }
  }

  changeObjectArrayVisibility(status, objectArray) {
    if (objectArray == null || objectArray.length == 0) {
      return;
    }

    for (let f = 0; f < objectArray.length; f++) {
      const element = objectArray[f];
      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const obj = element.object.children[index];
          obj.visible = status;
        }
        element.object.visible = status;
        element.active = status;
      } else {
        element.object.visible = status;
        element.active = status;
      }
    }
  }

  changeMoodLightsVisibility(status, objectArray) {
    if (objectArray == null || objectArray.length == 0) {
      return;
    }

    for (let f = 0; f < objectArray.length; f++) {
      const element = objectArray[f];
      for (let i = 0; i < element.objects.length; i++) {
        if (element.objects[i].isGroup) {
          for (
            let index = 0;
            index < element.objects[i].children.length;
            index++
          ) {
            const obj = element.objects[i].children[index];
            obj.visible = status;
          }
          element.objects[i].visible = status;
          element.active = status;
        } else {
          element.objects[i].visible = status;
          element.active = status;
        }
      }
    }
  }

  changePostVisibility(status, nameArray, reset = false) {
    if (this.post == null) {
      return;
    }

    for (let index = 0; index < this.post[nameArray].length; index++) {
      const element = this.post[nameArray][index];

      element.active = false;

      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const ge = element.object.children[index];
          ge.visible = status;

          if (status === false && reset === true) {
            ge.active = false;
          }
        }
      } else {
        element.object.visible = status;
        if (status === false && reset === true) {
          element.object.active = false;
        }
      }
    }
  }

  changeBeamVisibility(status, postType = null, postSide = null) {
    if (this.roof == null) {
      return;
    }
    if (this.roof.beams == null) {
      return;
    }

    for (let index = 0; index < this.roof.beams.length; index++) {
      const element = this.roof.beams[index];

      if (postType != null) {
        if (element.type != postType) {
          continue;
        }
      }

      if (postSide != null) {
        if (element.side != postSide) {
          continue;
        }
      }

      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const ge = element.object.children[index];
          ge.visible = status;
        }
        element.object.visible = status;
        element.active = status;
      } else {
        element.object.visible = status;
        element.active = status;
      }
    }
  }

  changeMountingWallVisibility(status, side = null) {
    if (this.mountingWall == null) {
      return;
    }
    if (this.mountingWall.elements == null) {
      return;
    }

    for (let index = 0; index < this.mountingWall.elements.length; index++) {
      const element = this.mountingWall.elements[index];

      if (side != null) {
        if (element.side != side) {
          continue;
        }
      }

      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const ge = element.object.children[index];
          ge.visible = status;
        }
      } else {
        element.object.visible = status;
      }
    }
  }
}

export class PergolaSettings {
  constructor() {
    this.width = null;
    this.length = null;
    this.height = null;
    this.postSize = null;
    this.postWidthInterval = null;
    this.postLengthInterval = null;
    this.color = 0;
    this.colorHex = null;
    this.colorLouvered = 0;
    this.colorLouveredHex = null;
    this.colorLedHex = null;
    this.colorMoodHex = null;
    this.colors = null;
    this.colorsLouvered = null;
    this.roofColor = null;
    this.mountingWall_Back = false;
    this.mountingWall_Left = false;
    this.mountingWall_Right = false;
    this.extraOptionLight = null;
    this.extraOptionLightSpacing = null;
    this.extraOptionFan = null;
    this.extraOptionLed = null;
    this.extraOptionHeaters = null;
    this.extraOptionMoodLight = null;
  }

  getValues() {
    var values = [
      {
        name: "Dimensions",
        value: pergolaSettings.toString_dimensions(),
        options: null,
      },
      {
        name: "FRAME COLOR",
        value: pergolaSettings.toString_color(),
        options: null,
      },
      {
        name: "Louver Color",
        value: pergolaSettings.toString_louverColor(),
        options: null,
      },
      {
        name: "Post size",
        value: pergolaSettings.toString_postSize(),
        options: null,
      },
      {
        name: "Wall Mounted",
        value: pergolaSettings.toString_mountingWall(),
        options: null,
      },
      {
        name: "Side Options",
        value: "",
        options: [
          ["Perimeter LED lights", pergolaSettings.toString_extraOptions_Led()],
          ["Heater", pergolaSettings.toString_extraOptions_Heater()],
        ],
      },
    ];

    return values;
  }

  toString_dimensions() {
    return `Width: ${this.width}', Projection:${this.length}', Height: ${this.height}'`;
  }

  toString_color() {
    return this.colorHex.toUpperCase();
  }

  toString_louverColor() {
    return this.colorLouveredHex.toUpperCase();
  }

  toString_postSize() {
    switch (this.postSize) {
      case PergolaPostType._4x4:
        return '4"x4"';
      case PergolaPostType._7x7:
        return '7"x7"';
      default:
        return "";
    }
  }

  toString_mountingWall() {
    let array = [];

    if (this.mountingWall_Back == true) {
      array.push("Back Side");
    }
    if (this.mountingWall_Left == true) {
      array.push("Left Side");
    }
    if (this.mountingWall_Right == true) {
      array.push("Right Side");
    }

    if (array.length == 1) {
      return array[0];
    }

    let result = "";

    for (let index = 0; index < array.length; index++) {
      result += array[index];

      if (index != array.length - 1) {
        result += ", ";
      }
    }

    return result;
  }

  toString_extraOptions_Light() {
    return this.extraOptionLight == true
      ? `Yes (Spacing: ${this.extraOptionLightSpacing}')`
      : "No";
  }

  toString_extraOptions_Fan() {
    return this.extraOptionFan == true ? "Yes" : "No";
  }

  toString_extraOptions_Led() {
    return this.extraOptionLed == true
      ? `Yes (${this.colorLedHex.toUpperCase()})`
      : "No";
  }

  toString_extraOptions_Mood() {
    return this.extraOptionMoodLight == true
      ? `Yes (${this.colorMoodHex.toUpperCase()})`
      : "No";
  }

  toString_extraOptions_Heater() {
    return this.extraOptionHeaters == true ? "Yes" : "No";
  }
}

// Клас для розмірів перголи
class PergolaDimensions {
  constructor() {
    this.width = 8;
    this.length = 8;
    this.height = 8;
  }
}

class PergolaPost {
  constructor() {
    this.postFR = null;
    this.postFL = null;
    this.postBL = null;
    this.postBR = null;

    this.leftCenter = [];
    this.rightCenter = [];
    this.backCenter = [];
    this.frontCenter = [];

    this.centerCenter = [];
  }
}

class PergolaPostObject {
  constructor() {
    this.name = "";
    this.type = null;
    this.isSupport = false;
    this.isLock = false;
    this.side = null;
    this.object = null;
    this.active = false;
  }
}

const PergolaPostSide = {
  FL: 0,
  FR: 1,
  RL: 2,
  RR: 3,

  FC: 4,
  BC: 5,
  LC: 6,
  RC: 7,

  CC: 8,
};

const PergolaElementOrientSide = {
  Front: 0,
  Back: 1,
  Left: 2,
  Right: 3,
  Center: 4,
};

//* SYSTEMS
class PergolaSystem {
  constructor() {
    this.objects = [];
  }
}

//* SPAN
class PergolaSpan {
  constructor() {
    this.objects = [];
  }
}

class PergolaSpanObject {
  constructor() {
    this.side = null;
    this.number = 0;
    this.width = null;
    this.height = null;
    this.posX = 0;
    this.posY = 0;
    this.posZ = 0;
    this.offsetY = 0.2;
    this.avatar = null;
    this.hotspot = null;
    this.active = false;
    this.isSystemSet = false;
    this.activeSystemType = null;
    this.systems = [];
    this.isLocked = false;

    this.getCurrentSystem = () => {
      return this.systems.find((system) => {
        return this.activeSystemType !== null
          ? system.type === this.activeSystemType
          : system.active;
      });
    };
  }
}

class PergolaSystemObject {
  constructor() {
    this.name = "";
    this.type = null;
    this.spanWidth = null;
    this.spanHeight = null;
    this.direction = null;
    this.side = null;
    this.posX = 0;
    this.posZ = 0;
    this.openingside = null;
    this.openValue = 0;
    this.color = null;
    this.object = null;
    this.active = false;
    this.isLocked = false;
    this.windowObject = null;
    this.windowPosX = 0;
    this.windowPosZ = 0;
    this.doorQty = 0;
  }
}

class PergolaRoof {
  constructor() {
    this.name = "";
    this.beamX = [];
    this.beamY = [];
    this.louverY = [];
    this.louverX = [];
    this.solidRoof = [];

    this.pointLED = [];
    this.rampLEDX = [];
    this.rampLEDY = [];

    this.headerLed = [];
    this.beamXLed = [];
    this.beamYLed = [];
  }
}

class PergolaRoofObject {
  constructor() {
    this.name = "";
    this.type = null;
    this.object = null;
    this.direction = null;
    this.active = false;
  }
}

class PergolaRoofFrame {
  constructor() {
    this.type = null;
    this.object = null;
    this.active = false;
  }
}

class PergolaRoofBeam {
  constructor() {
    this.type = null;
    this.direction = null;
    this.object = null;
    this.active = false;
  }
}

const PergolaRoofType = {
  Louvered: 0,
};

// Типи даху
class PergolaRoofTypeLouvered {
  constructor() {
    this.rotate = 0;
    this.rails = [];
    this.objects = [];
  }
}

class PergolaRoofTypeLouveredObject {
  constructor() {
    this.object = null;
    this.active = false;
  }
}

const PergolaRoofDirection = {
  Straight: 0,
  Perpendicular: 1,
};

class PergolaMountingWall {
  constructor() {
    this.elements = [];
  }
}

class PergolaMountingWallElement {
  constructor() {
    this.side = null;
    this.object = null;
    this.active = false;
  }
}

class PergolaExtraOptions {
  constructor() {
    this.elements = [];
  }
}

// Клас для додаткових елементів
class PergolaExtraOptionElement {
  constructor() {
    this.type = null;
    this.active = false;
    this.object = null;
    this.objects = [];
  }
}

const PergolaExtraOptionType = {
  light: 0,
  fan: 1,
  heater: 2,
  led: 3,
  moodLight: 4,
  moodLed: 5,
};

var pergolaSettings = new PergolaSettings();

pergolaSettings.beamThickness = 0.0508;
pergolaSettings.postWidthInterval = 30;
pergolaSettings.postLengthInterval = 30;
pergolaSettings.beamWidthInterval = 20.1;
pergolaSettings.beamLengthInterval = 14.1;
pergolaSettings.beamPerimeterInterval = 20.1;
pergolaSettings.beamLouverLengthInterval = 14.1;

pergolaSettings.width = 18;
pergolaSettings.length = 12;
pergolaSettings.height = 8;
pergolaSettings.colorHex = "#281F1E";
pergolaSettings.colorLouveredHex = "#281F1E";
pergolaSettings.colorLedHex = "#FFFFFF";
pergolaSettings.colorMoodHex = "#FFFFFF";
pergolaSettings.roofType = PergolaRoofType.Louvered;
pergolaSettings.roofLouveredDirection = PergolaRoofDirection.Perpendicular;
pergolaSettings.mountingWall_Back = false;
pergolaSettings.mountingWall_Left = false;
pergolaSettings.mountingWall_Right = false;
pergolaSettings.extraOptionLight = false;
pergolaSettings.extraOptionLightSpacing = 4;
pergolaSettings.extraOptionFan = false;
pergolaSettings.extraOptionLed = false;
pergolaSettings.extraOptionHeaters = false;
pergolaSettings.extraOptionMoodLight = false;

var sceneTime = "Day"; // Day, Night
var blockURLWriter = true;
export var pergola = new PergolaObject();

function CreatePergola(model) {
  pergola = new PergolaObject(pergolaSettings);
  window.pergola = pergola;

  pergola.createFrom3DModel(model);
  changeSceneTime(sceneTime);
  AssignUIFromPergolaSettings();
}

export function RegisterMorphsForObject(object) {
  if (!object.isMesh) return;
  if (object.morphTargetDictionary == null) return;

  for (const [key, value] of Object.entries(object.morphTargetDictionary)) {
    var morph = {
      name: key,
      object: object,
      key: value,
      value: value,
    };
    morphs.push(morph);
  }
}

//#region Assign UI

function AssignUIFromPergolaSettings() {
  if (pergolaSettings == null) {
    return;
  }

  $("#range-width").val(pergolaSettings.width);
  $("#range-width").trigger("change");

  $("#range-length").val(pergolaSettings.length);
  $("#range-length").trigger("change");

  $("#range-height").val(pergolaSettings.height);
  $("#range-height").trigger("change");

  $("#color-frame").val(pergolaSettings.colorHex);
  $("#color-frame")
    .next(".color-picker-display")
    .css("background-color", pergolaSettings.colorHex);
  $("#group_1_title").text(pergolaSettings.colorHex);

  $("#color-louver").val(pergolaSettings.colorLouveredHex);
  $("#color-louver")
    .next(".color-picker-display")
    .css("background-color", pergolaSettings.colorLouveredHex);
  $("#group_2_title").text(pergolaSettings.colorLouveredHex);

  $("#color-led-lights").val(pergolaSettings.colorLedHex);
  $("#color-led-lights")
    .next(".color-picker-display")
    .css("background-color", pergolaSettings.colorLedHex);
  // $("#group_2_title").text(pergolaSettings.colorLedHex);

  $("#color-mood-lightning").val(pergolaSettings.colorMoodHex);
  $("#color-mood-lightning")
    .next(".color-picker-display")
    .css("background-color", pergolaSettings.colorMoodHex);
  // $("#group_2_title").text(pergolaSettings.colorMoodHex);

  $("#range-angle").trigger("change");

  $("#wallBack").prop("checked", pergolaSettings.mountingWall_Back);
  $("#wallBack").trigger("change");
  $("#wallLeft").prop("checked", pergolaSettings.mountingWall_Left);
  $("#wallLeft").trigger("change");
  $("#wallRight").prop("checked", pergolaSettings.mountingWall_Right);
  $("#wallRight").trigger("change");

  $("#moodLightning").prop("checked", pergolaSettings.extraOptionMoodLight);
  $("#moodLightning").trigger("change");
  $("#ledLights").prop("checked", pergolaSettings.extraOptionLed);
  $("#ledLights").trigger("change");
  $("#ceilingFan").prop("checked", pergolaSettings.extraOptionFan);
  $("#ceilingFan").trigger("change");
  $("#heaters").prop("checked", pergolaSettings.extraOptionHeaters);
  $("#heaters").trigger("change");
  $("#recessedLighting").prop("checked", pergolaSettings.extraOptionLight);
  $("#recessedLighting").trigger("change");

  $("#range-quantity").val(pergolaSettings.extraOptionLightSpacing);
  $("#range-quantity").trigger("change");

  if (sceneTime == "Night") {
    $(".tumbler-wrapper").addClass("active");
    changeSceneTime("Night");
  }

  // $('.formWrapper input[type="range"]').each(function() {
  //   updateRangeBackgroundAndLabel($(this));
  // });
}


function estimationStringValue() {
  var result = "";
  var values = pergolaSettings.getValues();

  result += "I'd like to get a quotation for this configuration ";

  var data_url = GetURLWithParameters();
  if (wix_current_url != null) {
    data_url = wix_current_url;
  }

  result += data_url + "\n\n";

  switch (pergolaSettings.roofType) {
    case PergolaRoofType.Solid:
      values[4].options = null;
      break;
    case PergolaRoofType.Lattice:
      values[4].options = null;
      break;
    case PergolaRoofType.Louvered:
      values[4].options = null;
      break;
    default:
      values[4].options = null;
      break;
  }

  for (let index = 0; index < values.length; index++) {
    const element = values[index];
    result += element.name + ": ";

    if (element.options != null) {
      result += element.value + "\n";

      for (let i = 0; i < element.options.length; i++) {
        const arrayValue = element.options[i];
        result += arrayValue[0] + ": " + arrayValue[1] + "\n";
      }
    } else {
      result += element.value + "\n";
    }
  }

  return result;
}

//#endregion

// GUI - TEST WORK
function customGUI() {
  const gui = new dat.GUI();
  gui.close();

  const gui_TimeOptions_functions = {
    default: false,
    Time: ["Day", "Night"],
  };
  gui.add(gui_TimeOptions_functions, "default");

  const folder_TimeOptions = gui.addFolder("Time Options");
  folder_TimeOptions
    .add(gui_TimeOptions_functions, "Time", gui_TimeOptions_functions.Time)
    .onChange(function (newValue) {
      changeSceneTime(newValue);
    });

  const gui_PDF_functions = {
    GetPDF: function () {
      // createPDF();
    },
  };

  const folder_PDF = gui.addFolder("PDF Options");
  folder_PDF.add(gui_PDF_functions, "GetPDF");

  const gui_CreateImage_functions = {
    CreateImages: function () {
      CreateImageList();
    },
  };

  const folder_Screenshot = gui.addFolder("Image Options");
  folder_Screenshot.add(gui_CreateImage_functions, "CreateImages");

  var params_Bloom = {
    threshold: 1,
    strength: 1,
    radius: 1,
  };

  const folder_bloom = gui.addFolder("Bloom Options");
  folder_bloom
    .add(params_Bloom, "threshold", 0, 10)
    .onChange(function (newValue) {
      updateBloomSettings(newValue);
    });
  folder_bloom
    .add(params_Bloom, "strength", 0, 10)
    .onChange(function (newValue) {
      updateBloomSettings(null, newValue);
    });
  folder_bloom.add(params_Bloom, "radius", 0, 10).onChange(function (newValue) {
    updateBloomSettings(null, null, newValue);
  });
}

//#endregion

export function changeSceneTime(value) {
  if (value == null) {
    return;
  }

  switch (value) {
    case "Night":
      updateEnvMap("public/environment/moonless_golf_2k.hdr", 0.01, false);
      bloomPass.enabled = true;
      saoPass.enabled = false;
      outputPass.enabled = true;
      fxaaPass.enabled = false; // disabled: FXAA blurs high-contrast logo edges (white on dark bg)
      scene.background = new THREE.Color(0x1f1c1c);
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 0.5;
      updateBloomSettings(1.2, 0.12, 0.25); // threshold > 1.0 keeps white logo below bloom range
      dirLight.intensity = 0.1;
      changePointLightStatus(pointLights, 0.0002, true);
      scene.traverse((o) => {
        if (
          (o.name === "wall_behind_heater_black" || o.name === "no_wall_heater_black") &&
          o.isMesh && o.material && o.material.name === "heaters"
        ) {
          o.material = o.material.clone();
          o.material.emissive = new THREE.Color(0xff6600);
          o.material.emissiveIntensity = 1.9;
          o.material.needsUpdate = true;
        }
      });
      break;

    case "Day":
    default:
      bloomPass.enabled = false;
      saoPass.enabled = false;
      outputPass.enabled = false;
      fxaaPass.enabled = false;
      updateEnvMap(ENVIRONMENT_MAP, ENVIRONMENT_MAP_INTENSITY);
      updateBloomSettings(null, 0);
      dirLight.intensity = 1.0;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.0;
      scene.background = new THREE.Color(BACKGROUND_COLOR);
      changePointLightStatus(pointLights, 0, false);
      scene.traverse((o) => {
        if (
          (o.name === "wall_behind_heater_black" || o.name === "no_wall_heater_black") &&
          o.isMesh && o.material && o.material.name === "heaters"
        ) {
          o.material = o.material.clone();
          o.material.emissive = new THREE.Color(0x000000);
          o.material.emissiveIntensity = 0.2;
          o.material.needsUpdate = true;
        }
      });
      break;
  }

  sceneTime = value;
  requestDelayedRender();
}

function changePointLightStatus(array, intensity, visible) {
  if (array == null) {
    return;
  }
  if (pointLights == null) {
    return;
  }
  if (pointLights.length <= 0) {
    return;
  }

  if (["Android", "iOS", "VisionPro"].includes(currentOS)) {
    return;
  }

  if (pointLights.length > 0) {
    for (let index = 0; index < pointLights.length; index++) {
      const element = pointLights[index];
      element.intensity = intensity;
      element.visible = visible;
    }
  }
}

//#region PDF
function calculateImageScale(
  originalWidth,
  originalHeight,
  targetWidth,
  targetHeight
) {
  return Math.min(targetWidth / originalWidth, targetHeight / originalHeight);
}


//#endregion

//#region Dimmensions

function removeObject3D(object3D) {
  if (!(object3D instanceof THREE.Object3D)) return false;

  if (object3D.geometry) object3D.geometry.dispose();

  if (object3D.material) {
    if (object3D.material instanceof Array) {
      object3D.material.forEach((material) => material.dispose());
    } else {
      object3D.material.dispose();
    }
  }
  object3D.removeFromParent();
  return true;
}

var dimmensionObjects = [];

function changeDimmensionRender(status, lookAtCamera = null, stage) {
  if (!status) {
    for (let index = 0; index < dimmensionObjects.length; index++) {
      const element = dimmensionObjects[index];
      removeObject3D(element);
    }

    dimmensionObjects = [];
    return;
  }

  const colorDemension = "#000000";
  const { FL_point, FR_point, RR_point } = pergola.getCornerPoints();
  const modelHeight = state.height;
  const deltaHeight = 0.01;

  let textSize = 0.2;

  if (state.width > 15 || state.length > 15) {
    textSize = 0.25;
  }

  if (state.width > 25 || state.length > 25) {
    textSize = 0.3;
  }

  if (state.width > 30 || state.length > 30) {
    textSize = 0.35;
  }

  var pos_width_0 = new THREE.Vector3(
    FL_point.x - 0.1,
    modelHeight - deltaHeight,
    FL_point.z + 0.1
  );
  var pos_width_1 = new THREE.Vector3(
    FR_point.x + 0.08,
    modelHeight - deltaHeight,
    FR_point.z + 0.1
  );

  var pos_length_0 = new THREE.Vector3(
    FR_point.x + 0.1,
    modelHeight - deltaHeight,
    FR_point.z + 0.08
  );
  var pos_length_1 = new THREE.Vector3(
    RR_point.x + 0.1,
    modelHeight - deltaHeight,
    RR_point.z - 0.1
  );

  var pos_width_center = generateMidpoints(pos_width_0, pos_width_1, 1);
  var pos_length_center = generateMidpoints(pos_length_0, pos_length_1, 1);

  var pos_width_textPosition = new THREE.Vector3(
    pos_width_center[0].x,
    pos_width_center[0].y + 0.2,
    pos_width_center[0].z + 0.1
  );
  var pos_length_textPosition = new THREE.Vector3(
    pos_length_center[0].x + 0.1,
    pos_length_center[0].y + 0.1,
    pos_length_center[0].z
  );

  AddDimmension(
    pos_width_center[0],
    pos_width_0,
    pos_width_1,
    (state.width.toString()) + "m",
    pos_width_textPosition,
    "x",
    0.01,
    colorDemension,
    lookAtCamera
  );
  createDimensionBorderLine(pos_width_0, 0.25, 0.01, "x", colorDemension);
  createDimensionBorderLine(pos_width_1, 0.25, 0.01, "x", colorDemension);
  createDimensionText(
    state.width.toString() + " m",
    pos_width_textPosition,
    colorDemension,
    lookAtCamera,
    textSize
  );

  AddDimmension(
    pos_length_center[0],
    pos_length_0,
    pos_length_1,
    (state.length.toString()) + " m",
    pos_length_textPosition,
    "z",
    0.01,
    colorDemension,
    lookAtCamera
  );
  createDimensionBorderLine(pos_length_0, 0.25, 0.01, "x", colorDemension);
  createDimensionBorderLine(pos_length_1, 0.25, 0.01, "x", colorDemension);
  createDimensionText(
    state.length.toString() + " m",
    pos_length_textPosition,
    colorDemension,
    lookAtCamera,
    textSize
  );

  if (stage !== 1) {
    var pos_height_0 = new THREE.Vector3(RR_point.x + 0.5, -1, RR_point.z);
    var pos_height_1 = new THREE.Vector3(
      RR_point.x + 0.2,
      modelHeight,
      RR_point.z
    );

    var pos_height_center = generateMidpoints(pos_height_0, pos_height_1, 1);
    var pos_height_textPosition = new THREE.Vector3(
      pos_height_center[0].x + 0.1,
      pos_height_center[0].y,
      pos_height_center[0].z
    );

    AddDimmension(
      pos_height_center[0],
      pos_height_0,
      pos_height_1,
      "8" + " m",
      pos_height_textPosition,
      "y",
      0.01,
      colorDemension,
      lookAtCamera
    );
    createDimensionBorderLine(pos_height_0, 0.25, 0.01, "y", colorDemension);
    createDimensionBorderLine(pos_height_1, 0.25, 0.01, "y", colorDemension);
    createDimensionText(
      state.height.toString() + " m",
      pos_height_textPosition,
      colorDemension,
      lookAtCamera,
      textSize
    );
  }
}

function AddDimmension(
  position,
  start,
  end,
  text,
  textPosition = null,
  side = "x",
  thickness = 0.01,
  color = colorDemension,
  lookAtCamera = null
) {
  const line = createDimensionLine(
    position,
    start,
    end,
    thickness,
    side,
    color
  );
  scene.add(line);
  dimmensionObjects.push(line);

  /*
  if(textPosition != null){
    createDimensionText(text, textPosition, colorDemension, lookAtCamera);
    return;
  }

  var line1_center = generateMidpoints(start, end, 1);
  createDimensionText(text, line1_center[0], colorDemension, lookAtCamera);
  dimmensionObjects.push(line);
  */
}

function getDistance(point1, point2) {
  return point1.distanceTo(point2);
}

function createDimensionLine(
  position,
  start,
  end,
  thickness = 0.01,
  side = "x",
  color = colorDemension
) {
  //const material = new THREE.LineBasicMaterial({ color: color });
  var length = getDistance(start, end);

  var x_value = side != "x" ? thickness : length;
  var y_value = side != "y" ? thickness : length;
  var z_value = side != "z" ? thickness : length;

  const material = new THREE.MeshBasicMaterial({ color: color });
  const geometry = new THREE.BoxGeometry(x_value, y_value, z_value);
  const lineMesh = new THREE.Mesh(geometry, material);
  lineMesh.position.set(position.x, position.y, position.z);

  return lineMesh;
}

function createDimensionBorderLine(
  position,
  length,
  thickness = 0.01,
  side = "x",
  color = colorDemension
) {
  var x_value = side != "y" ? thickness : length;
  var y_value = side != "x" ? thickness : length;
  var z_value = side != "z" ? thickness : length;

  switch (side) {
    case "x":
      x_value = thickness;
      y_value = length;
      z_value = thickness;
      break;
    case "y":
      x_value = length;
      y_value = thickness;
      z_value = thickness;
      break;
    case "z":
      x_value = thickness;
      y_value = length;
      z_value = thickness;
      break;

    default:
      break;
  }

  const material = new THREE.MeshBasicMaterial({ color: color });
  const geometry = new THREE.BoxGeometry(x_value, y_value, z_value);
  const lineBorderMesh = new THREE.Mesh(geometry, material);
  lineBorderMesh.position.set(position.x, position.y, position.z);

  scene.add(lineBorderMesh);
  dimmensionObjects.push(lineBorderMesh);
  return lineBorderMesh;
}

function loadThreeJSFonts() {
  const loader = new FontLoader();
  loader.load(
    "https://threejs.org/examples/fonts/helvetiker_regular.typeface.json",
    function (font) {
      threejs_font_helvetiker_regular = font;
    }
  );
}

function createDimensionText(
  text,
  position,
  color = colorDemension,
  lookAtCamera = null,
  textSize = 0.2
) {
  if (threejs_font_helvetiker_regular == null) {
    return;
  }

  const textGeometry = new TextGeometry(text, {
    font: threejs_font_helvetiker_regular,
    size: textSize, // Розмір тексту
    depth: 0.01, // Глибина тексту
  });
  const textMaterial = new THREE.MeshBasicMaterial({ color: color });
  const textMesh = new THREE.Mesh(textGeometry, textMaterial);
  textMesh.position.set(position.x, position.y, position.z);
  if (lookAtCamera != null) {
    textMesh.lookAt(lookAtCamera.position);
  }

  scene.add(textMesh);
  dimmensionObjects.push(textMesh);

  return textMesh;
}

//#endregion

//#region CAPTURE CAMERA IMAGE

var share_RenderImageSize = {
  x: 650,
  y: 400,
};

var share_RenderImages = [];

export async function CreateImageList() {
  if (canvas == null) {
    return;
  }

  const fov = 50;
  let width = Number(state.width);
  let length = Number(state.length);
  const sizeValue = width > length ? width : length;

  const deltaDist = ConvertMorphValue(state.height, 1.0, 3.5, 0.5, 2.0);
  const deltaY = ConvertMorphValue(state.height, 1.0, 3.5, 1.0, 2.5);

  const dist = sizeValue * 1.3 + deltaDist + 2.5;

  console.log(canvas);
  const cameraImageViews_Global = [
    {
      id: "view_1.png",
      alt: "view 1",
      cameraObject: new THREE.PerspectiveCamera(
        29,
        canvas.width / canvas.height,
        0.01,
        1000
      ),
      position: new THREE.Vector3(dist / 1.0, deltaY * 0.5, dist / 1.0),
      rotation: new THREE.Vector3(0, Math.PI / 4.5, 0),
      lookAt: new THREE.Vector3(0, deltaY * 0.3 - 0.5, 0),
    },
    {
      id: "view_top.png",
      alt: "view from top",
      cameraObject: new THREE.PerspectiveCamera(
        47,
        canvas.width / canvas.height,
        0.01,
        1000
      ),
      position: new THREE.Vector3(0, dist * 0.95, 0),
      rotation: new THREE.Vector3(-Math.PI / 2, 0, 0),
      rotate: true,
    },
  ];

  share_RenderImages = [];

  pergola.update();

  if (state.pdfMode) {
    const louverNameX = getLouverMeshNames(state.roofType, state.louvreType, 'x');
    const louverNameY = getLouverMeshNames(state.roofType, state.louvreType, 'y');
    const namesToHide = [louverNameX, louverNameY, `lighting_${louverNameX}`, `lighting_${louverNameY}`].filter(Boolean);

    const rootScene = pergola.theModel.parent || pergola.theModel;
    rootScene.traverse((obj) => {
      if (obj.name && namesToHide.includes(obj.name)) {
        obj.visible = false;
        obj.traverse(ch => { ch.visible = false; });
      }
    });
  }

  for (let index = 0; index < cameraImageViews_Global.length; index++) {
    const element = cameraImageViews_Global[index];

    element.cameraObject.visible = true;
    element.cameraObject.aspect = camera.aspect;
    element.cameraObject.updateProjectionMatrix();
    element.cameraObject.position.set(
      element.position.x,
      element.position.y,
      element.position.z
    );
    if (element.lookAt) {
      element.cameraObject.lookAt(element.lookAt);
    } else {
      element.cameraObject.rotation.set(
        element.rotation.x,
        element.rotation.y,
        element.rotation.z
      );
    }

    changeDimmensionRender(true, element, index, element.rotate);
    TakeImage(element, "ar_pop_share_image");
    changeDimmensionRender(false);
  }

  pdfImg.img = share_RenderImages[0].src;
  pdfImgTop.img = share_RenderImages[1].src;

  return share_RenderImages;
}

function TakeImage(view, img_class) {
  var img_div = document.createElement("div");
  img_div.classList.add(img_class);
  var img = CreateImage(view);
  img_div.appendChild(img);
  //DownloadRenderImage(img.src, img.alt);
  //ar_pop_share_pics.appendChild(img_div);
}

function CreateImage(view) {
  var img = new Image();
  renderer.setSize(share_RenderImageSize.x, share_RenderImageSize.y, false);
  view.cameraObject.aspect = share_RenderImageSize.x / share_RenderImageSize.y;
  view.cameraObject.updateProjectionMatrix();
  renderer.render(scene, view.cameraObject);
  img.src = renderer.domElement.toDataURL();
  img.alt = view.alt;
  share_RenderImages.push(img);
  view.cameraObject.visible = false;
  updateRenderSize();
  return img;
}

function DownloadRenderImage(src, alt) {
  if (src == null) {
    return;
  }
  if (alt == 0) {
    return;
  }

  var a = document.createElement("a");
  a.href = src;
  a.download = alt;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

//#endregion

//#region Encode/Decode

String.prototype.SEncode = function () {
  if (this == undefined) {
    return "";
  }
  return btoa(unescape(encodeURIComponent(this)));
};

String.prototype.SDecode = function () {
  if (this == undefined) {
    return "";
  }
  return decodeURIComponent(escape(atob(this)));
};

//#endregion
